export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

/** Un compte sur lequel l'acteur peut agir. */
export type AccessibleAccount = {
  __typename?: 'AccessibleAccount';
  id?: Maybe<Scalars['ID']['output']>;
  kind?: Maybe<OrganizationKind>;
  /** Ce compte exige le MFA de ses utilisateurs (PCG-303). POLITIQUE du compte : ne dit rien de ce que chaque personne a pose, qui vit dans le pool Cognito. Se change par `setAccountMfaRequirement`. */
  mfaRequired?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Le compte est-il ouvert au portail. FAUX fait echouer l'invitation, et l'echec tombait jusqu'ici a la DERNIERE etape du parcours, apres le choix du role et du perimetre : l'ecran grise donc le compte des l'arborescence, comme il grise deja une autre societe. N'est pas un droit d'acces, l'ouverture est une decision metier, interdite a l'import et portee par aucun ecran a ce jour. */
  portalEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Racine de l'arbre du compte, c'est-a-dire le CLIENT auquel il appartient. Calculee par organization_root(), la meme fonction que le declencheur membership_single_root_check et le refus DIFFERENT_ROOT_ORGANIZATION : un ecran qui regroupe par cette cle regroupe donc exactement comme la base refuse. N'est PAS un identifiant de cloisonnement, et n'elargit aucun acces : voir onboarding-back-office.md §2.4. Nulle quand la remontee n'atteint pas de racine, ce qui SIGNALE une boucle dans parent_organization_id. */
  rootOrganizationId?: Maybe<Scalars['ID']['output']>;
  /** Nom de cette racine, pour l'en-tete d'un regroupement par societe. Il voyage avec l'identifiant parce que la racine est souvent ABSENTE de la liste qu'elle coiffe (le portefeuille d'un collaborateur peut ne porter qu'un noeud fils) et qu'un uuid affiche a un operateur ne lui dit rien. */
  rootOrganizationName?: Maybe<Scalars['String']['output']>;
};

/**
 * Une ligne de la liste des comptes du back-office. UNE TABLE A PLAT : la societe d'appartenance est une COLONNE (`rootOrganizationName`), jamais un niveau de regroupement.
 *
 *  **Et le jeu de volume ne permet PAS d'en juger, c'est le piege de cette decision.** Le parc reel compte 6 975 racines pour 7 584 comptes (mesure sur le miroir, PCG-128) : un arbre depliable y rendrait presque autant de noeuds racines que de comptes, chacun a un seul enfant, c'est-a-dire une liste a plat deguisee en arbre. Le jeu de volume, lui, n'en porte que 900 pour 7 583 comptes (verifie) parce qu'il reproduit deliberement les natures et non la foret (divergence 8). Un arbre essaye la-bas aurait donc l'air raisonnable, a huit comptes par racine.
 *
 *  Elle ne porte PAS `kind` : cette liste ne rend que des comptes CLIENTS, l'organisation interne en etant exclue (voir la description de `accounts`). Un champ constant inviterait un ecran a brancher sur une valeur qui ne varie jamais.
 */
export type Account = {
  __typename?: 'Account';
  /**
   * Entrees VIVANTES du catalogue de tableaux de bord du compte (`archived_at IS NULL`), le meme filtre que `assignableDashboards`, `inviteUser` et le fabricant de jeton. Une entree archivee a quitte le catalogue : la compter annoncerait un contenu que plus personne ne peut se voir accorder.
   *
   *  Zero est l'etat ORDINAIRE et non un defaut : le contenu de ce module n'est pas ingere, il est saisi a la main, et il faut deux gestes, declarer l'entree, puis l'accorder.
   */
  dashboardCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /**
   * Ce compte exige-t-il le MFA de ses utilisateurs (PCG-303). Comme `portalEnabled`, c'est une politique du compte que cet ecran existe pour changer ; contrairement a lui, ce n'est PAS un filtre de la liste, l'exigence etant minoritaire et la question « lesquels ne l'exigent pas » n'etant posee par personne.
   *
   *  Ne dit rien de ce que chaque personne a effectivement pose : cet etat-la vit dans le pool Cognito, et `user.mfa_method` n'en est qu'un miroir d'affichage.
   */
  mfaRequired?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Modules OUVERTS sur ce compte. La presence de la ligne vaut activation : il n'y a ni booleen ni troisieme etat.
   *
   *  NUMERATEUR SANS DENOMINATEUR, delibere. « 2 sur 6 » s'ecrit a l'ecran, et le 6 se lit sur `portalModules`, jamais en dur, le referentiel nommant le menu entier et grandissant avec lui. Le servir ici serait un second endroit ou ce nombre s'ecrit.
   */
  moduleCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Le compte est-il ouvert au portail. C'est le fait que cet ecran existe pour changer, et le seul filtre que la liste porte. Attention, ce n'est pas un droit d'acces : l'ouverture est une decision metier, interdite a l'import. */
  portalEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Racine de l'arbre, c'est-a-dire le CLIENT auquel le compte appartient. Calculee par organization_root(), la MEME fonction que le declencheur membership_single_root_check et le refus DIFFERENT_ROOT_ORGANIZATION. N'est PAS un identifiant de cloisonnement et n'elargit aucun acces. Nulle quand la remontee n'atteint pas de racine, ce qui SIGNALE une boucle dans parent_organization_id. */
  rootOrganizationId?: Maybe<Scalars['ID']['output']>;
  /** Nom de cette racine : la colonne « Societe » de la table. Il voyage avec l'identifiant parce qu'un uuid affiche a un operateur ne lui dit rien. La racine peut etre ABSENTE de la page rendue, et meme du perimetre de l'acteur : le nom est la pour etre lu, pas pour etre lie. */
  rootOrganizationName?: Maybe<Scalars['String']['output']>;
  /**
   * PERSONNES portant un acces vivant sur ce compte : `active` ou `invited`, le MEME filtre que `viewer.memberships` et `Role.membershipCount`. Les revoques et les partis ne comptent pas : ils sont l'historique d'un acces, pas un acces.
   *
   *  CE QU'IL COMPTE EST DIT PARCE QUE CE DEPOT A DEJA PAYE LA CONFUSION : `accountUsers` annoncait « N utilisateurs » sur un decompte de rattachements, 10 666 pour 8 000 personnes. Ici les deux lectures donnent le MEME nombre, et c'est une contrainte qui le garantit, l'index unique (user_id, organization_id) fait qu'une personne ne porte qu'un rattachement par compte. Verifie par execution sur 3 801 comptes et 36 016 rattachements : zero compte ou les deux different. Le raisonnement ne se transporte PAS a une liste de personnes a travers les comptes, qui est exactement la forme que PCG-90 a du corriger.
   */
  userCount?: Maybe<Scalars['Int']['output']>;
};

/** Les activites cochables d'un compte, pre-cochees pour une adresse. C'est ce que l'etape « Perimetre » de l'onboarding liste depuis qu'on coche des ACTIVITES et non plus des marches. */
export type AccountActivities = {
  __typename?: 'AccountActivities';
  marketGroups: Array<ActivityMarketGroup>;
  /** Combien de contacts ingeres cette adresse a designes. `contact.email` ne porte AUCUNE unicite, la table etant un reflet : on prend l'UNION de leurs activites plutot que d'en elire un. Mais une boite partagee designant deux personnes pre-cocherait alors les activites de l'une pour l'autre, et un ecran qui recoit plus de 1 a de quoi le dire. ZERO veut dire que l'adresse ne designe personne : la liste sort alors entiere, sans rien de pre-coche. */
  matchedContactCount: Scalars['Int']['output'];
  /** A plat et non groupes : leur marche ne sert a rien ici, et un groupement n'aurait de sens que s'il servait a cocher en bloc, ce que le produit n'a pas demande pour eux. */
  needs: Array<ActivityOption>;
  /** Ce que le plafond a laisse dehors. AUCUN PLAFOND SILENCIEUX : un selecteur tronque sans le dire fait croire que le compte n'a que ce qu'on voit, et l'operateur coche alors un perimetre qu'il croit complet. Zero sur tous les comptes connus, le plus gros portant 741 besoins. */
  omittedNeeds: Scalars['Int']['output'];
  /** Meme regle que `omittedNeeds`. Zero sur tous les comptes connus. */
  omittedServices: Scalars['Int']['output'];
};

/** Exigence de MFA d'un compte, apres le geste. */
export type AccountMfaRequirement = {
  __typename?: 'AccountMfaRequirement';
  /** Combien de PERSONNES l'exigence porte desormais, rattachements actifs et invites. Compte des personnes et non des rattachements, par l'index unique `(user_id, organization_id)` : confondre les deux a deja fait afficher « 10 666 utilisateurs pour 8 000 personnes » a ce depot. */
  affectedUsers?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Ce compte exige-t-il le MFA de ses utilisateurs. C'est une POLITIQUE du compte, et elle ne dit rien de ce que chaque personne a effectivement pose : cet etat-la vit dans le pool Cognito. */
  mfaRequired?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Un module du referentiel et son etat sur UN compte. La liste rend TOUT le referentiel : les six entrees du menu de la maquette V2, actives ou non, livrees ou non : une liste qui se raccourcit se lit comme un referentiel incomplet, et l'operateur ne peut pas activer ce qu'il ne voit pas. Deux etats distincts se lisent donc ici, et les confondre ferait dire a l'ecran une chose fausse : `enabled` dit si le module est OUVERT SUR CE COMPTE, `activatable` s'il est LIVRE, un module non livre est faux partout, sur tous les comptes, et pour une raison qui ne concerne pas le compte. */
export type AccountModule = {
  __typename?: 'AccountModule';
  /** Le module est-il LIVRE, c'est-a-dire l'activer ouvre-t-il quelque chose. Faux sur les entrees de menu dont l'ecran n'existe pas encore. Ne dit RIEN du compte : c'est un fait sur la plateforme, vrai ou faux partout a la fois. L'ecran desactive la ligne et affiche `notActivatableReason` ; `enableAccountModule` refuse MODULE_NOT_DELIVERED si le clic a quand meme lieu. */
  activatable: Scalars['Boolean']['output'];
  code: Scalars['ID']['output'];
  /** Le module est-il ouvert sur ce compte. DERIVE DE LA PRESENCE DE LA LIGNE, il n'existe aucune colonne : desactiver, c'est supprimer la ligne, et il n'y a donc pas de troisieme etat. */
  enabled: Scalars['Boolean']['output'];
  /** Depuis quand. Nul tant que le module n'est pas active sur ce compte. */
  grantedAt?: Maybe<Scalars['String']['output']>;
  /** Qui l'a active : le nom si on l'a, l'adresse sinon. Nul quand le module n'est pas actif. L'historique complet, lui, est dans activity_log : ce champ repond « depuis quand et par qui » sans avoir a le relire. */
  grantedByName?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  /** La raison, quand `activatable` est faux : nulle sinon, une seule source pour un seul fait. Formulation cote API : c'est une regle de la plateforme (« l'ecran n'est pas encore livre »), pas une panne ni un refus adresse a l'acteur, et aucun geste de sa part ne la leve. */
  notActivatableReason?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
};

/** Etat d'ouverture d'un compte au portail, apres le geste. */
export type AccountPortalAccess = {
  __typename?: 'AccountPortalAccess';
  id?: Maybe<Scalars['ID']['output']>;
  kind?: Maybe<OrganizationKind>;
  name?: Maybe<Scalars['String']['output']>;
  /** Le compte peut-il recevoir des utilisateurs du portail. N'accorde d'acces a PERSONNE : c'est une eligibilite, pas une habilitation. */
  portalEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** UNE LIGNE PAR PERSONNE, et non par rattachement (PCG-90). Le role, le statut et le perimetre appartiennent au couple personne x compte : les colonnes qui different d'un compte a l'autre sont donc agregees, et la ligne porte AUSSI le detail de ses rattachements pour que l'ecran rende « plusieurs » sans second appel. */
export type AccountUser = {
  __typename?: 'AccountUser';
  /** Nombre de comptes enumeres. Porte pour que l'ecran n'ait pas a compter. */
  accountCount?: Maybe<Scalars['Int']['output']>;
  /** Consommation du lien d'activation, qui verifie l'e-mail : la colonne « Creation du compte ». Nul tant que l'invitation est en attente. */
  activatedAt?: Maybe<Scalars['String']['output']>;
  /** Perimetre agrege. Nul quand les rattachements divergent. */
  dataScope?: Maybe<DataScope>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  /** Fin de validite du lien, quand une invitation est en cours. */
  invitationExpiresAt?: Maybe<Scalars['String']['output']>;
  /** Derniere invitation ENVOYEE, relances comprises : la colonne « Date d'invitation » du back-office. */
  invitedAt?: Maybe<Scalars['String']['output']>;
  /** Dernier PASSAGE authentifie : une personne se connecte, pas un rattachement. Attention, ce n'est pas l'evenement de connexion et il n'est repose qu'au-dela d'une heure : a libeller « derniere activite ». Nul = jamais passee, ce que la colonne Statut rend deja par « Jamais connecte ». */
  lastLoginAt?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Tous les rattachements de la personne DANS LE PERIMETRE DE L'ACTEUR, tries par nom de compte. Le surplus « +n » est donc celui des comptes QUE VOUS POUVEZ VOIR : agreger ne doit rien elargir, et deux operateurs aux portefeuilles differents verront legitimement des surplus differents, l'ecran doit le dire, sinon comparer deux ecrans se lit comme une incoherence de la base. L'enumeration ne traverse JAMAIS deux clients : check_membership_single_root borne les rattachements d'une personne a l'arbre d'un seul client. */
  memberships?: Maybe<Array<AccountUserMembership>>;
  /** Role agrege. NUL quand les rattachements divergent, ce que l'ecran rend par « plusieurs » : c'est l'agregat qui dit « pas de reponse unique », jamais une valeur manquante, un rattachement porte toujours un role. SOUS FILTRE DE ROLE, la colonne bascule et affiche LE ROLE QUI A FAIT ENTRER LA LIGNE : qui filtre sur « Contract manager » pose une question precise, et « plusieurs » n'y repond pas. */
  roleName?: Maybe<Scalars['String']['output']>;
  /** Statut agrege, NUL quand les rattachements divergent. SOUS FILTRE DE STATUT, la colonne bascule et affiche LE STATUT QUI A FAIT ENTRER LA LIGNE : le filtre definit la question posee, et qui cherche les invitations en attente n'est pas renseigne par un « plusieurs ». */
  status?: Maybe<MembershipDisplayStatus>;
  userId?: Maybe<Scalars['ID']['output']>;
};

/** Un rattachement de la personne, dans le perimetre de l'acteur. Il ne porte AUCUNE action de ligne : PCG-40 a fait de la personne l'unite de travail, donc une ligne renvoie a la fiche. L'identifiant sert a lier, jamais a choisir arbitrairement une cible de mutation. */
export type AccountUserMembership = {
  __typename?: 'AccountUserMembership';
  dataScope?: Maybe<DataScope>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  membershipId?: Maybe<Scalars['ID']['output']>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  roleCode?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['ID']['output']>;
  roleName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MembershipDisplayStatus>;
};

export type AccountUsersPage = {
  __typename?: 'AccountUsersPage';
  items?: Maybe<Array<AccountUser>>;
  /** Nombre de PERSONNES avant pagination : jamais un nombre de rattachements. Le compteur doit compter ce que son nom annonce : « N utilisateurs » sur un decompte de rattachements etait un chiffre faux ecrit avec assurance. */
  total?: Maybe<Scalars['Int']['output']>;
};

/** Colonne de tri de la liste des utilisateurs. */
export enum AccountUsersSort {
  /** Creation du compte. */
  ActivatedAt = 'ACTIVATED_AT',
  /** Date d'invitation. */
  InvitedAt = 'INVITED_AT',
  /** Nom, puis prenom. A defaut l'e-mail. */
  LastName = 'LAST_NAME'
}

export type AccountsPage = {
  __typename?: 'AccountsPage';
  items?: Maybe<Array<Account>>;
  /** Nombre de comptes repondant aux filtres dans le perimetre de l'acteur, AVANT pagination. Il suit la recherche et le filtre, comme `totalInProgress` sur « Mes besoins » : un total qui les ignorerait afficherait « 1–25 sur 7 583 » au-dessus de trois lignes, ce qu'un lecteur prend pour un defaut d'affichage et non pour une information. */
  total?: Maybe<Scalars['Int']['output']>;
};

export type ActivateAccountInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ActivateAccountPayload = {
  __typename?: 'ActivateAccountPayload';
  email?: Maybe<Scalars['String']['output']>;
  /** Comptes ouverts par l'activation. */
  organizationNames?: Maybe<Array<Scalars['String']['output']>>;
};

/** Les prestations d'un marche. Attention, LE MARCHE N'EST QU'UN GROUPEMENT : cocher le groupe coche ses prestations, mais ce que l'ecran enregistre est la liste des PRESTATIONS. Enregistrer le marche ramenerait le defaut que ce lot corrige, une prestation sans marche disparaissant alors en silence. */
export type ActivityMarketGroup = {
  __typename?: 'ActivityMarketGroup';
  /** NUL pour le groupe « sans contrat cadre », qui N'EST PAS UNE ANOMALIE : c'est pres d'une prestation sur deux sur certains comptes, et c'est exactement ce que l'ancien mecanisme perdait. Il se rend comme les autres, range en dernier. */
  marketId?: Maybe<Scalars['ID']['output']>;
  /** Le nom du referentiel, ou a defaut l'intitule porte par la prestation. NUL sur un marche resolu qui n'a aucun nom : l'ecran le dit alors, il n'invente pas. */
  marketName?: Maybe<Scalars['String']['output']>;
  services: Array<ActivityOption>;
};

/** Une activite cochable a l'etape « Perimetre » de l'onboarding : un besoin ou une prestation. */
export type ActivityOption = {
  __typename?: 'ActivityOption';
  /**
   * De quoi SITUER la ligne, jamais la filtrer : une prestation terminee reste un perimetre legitime.
   *
   * Attention, LES DEUX OBJETS NE DISENT PAS LA MEME CHOSE SOUS CE NOM. Une prestation rend son STATUT (« en cours », « regle »), un besoin rend son ETAPE de processus : deux referentiels, ni la meme forme ni la meme echelle. L'ecran les affiche comme un reperage et ne doit pas les comparer entre eux.
   */
  displayStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * LA SOURCE RATTACHE-T-ELLE CETTE PERSONNE A CETTE ACTIVITE ? C'est ce qui fait le pre-cochage et le badge « designe par la source ». Lu sur le contact des deux objets, ET sur le contact ACHAT pour les besoins : 245 contacts du parc n'apparaissent JAMAIS autrement, et ce sont des acheteurs, le profil qu'on onboarde.
   *
   * Attention, IL PRE-COCHE, IL NE VERROUILLE PAS : l'operateur decoche ce qu'il veut. La source dit ou la personne travaille, elle ne decide pas ce qu'un administrateur ouvre.
   */
  linkedToContact: Scalars['Boolean']['output'];
  /** Le titre du besoin ou le nom de la prestation. NUL est possible et l'ecran doit l'ecrire : une ligne sans nom reste cochable, et un blanc dans une liste de cases se lit comme une ligne cassee. */
  name?: Maybe<Scalars['String']['output']>;
};

/** Ou l'activite d'une prestation est saisie, donc ce que son onglet lit. Voir la description des valeurs. */
export enum ActivitySource {
  /** Saisie dans Connecteed : l'onglet lit les CRA (`INO_Consommation__c`). Il suffit qu'UNE mission de gestion soit validee, parce que s'il en existe une, il y a de l'activite saisie la-bas donc quelque chose a montrer. */
  Consumptions = 'CONSUMPTIONS',
  /** Saisie dans Salesforce : l'onglet lit les PHASES du contrat (`servicePhases`). C'est le cas quand aucune mission de gestion de la prestation n'est validee, y compris quand elle n'en porte aucune. */
  Phases = 'PHASES'
}

/** Une entree du catalogue de tableaux de bord, attribuable a un rattachement. Le catalogue est une LISTE BLANCHE saisie a la main, jamais un reflet de Metabase : un reflet listerait des centaines de dashboards internes, et le back-office devrait FILTRER ce qu'il propose, un filtre qui s'oublie, et dont l'oubli est une fuite. Declarer l'entree EST l'autorisation. */
export type AssignableDashboard = {
  __typename?: 'AssignableDashboard';
  /** Notre uuid, jamais l identifiant Metabase. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Le libelle vu par le CLIENT, et non le nom de l'objet Metabase. */
  name?: Maybe<Scalars['String']['output']>;
  /** Le compte dont le tableau de bord est l'objet. C'est le compte qui doit figurer dans la selection de l'etape 2 : `inviteUser` refuse par FORBIDDEN_OUT_OF_SCOPE une habilitation posee ailleurs, et la cle etrangere composite de dashboard_membership la refuserait de toute facon. */
  organizationId?: Maybe<Scalars['ID']['output']>;
  /** Nom du compte, pour l'en-tete du regroupement : le module rend N entrees NOMMEES PAR LEUR COMPTE, jamais un selecteur de compte. */
  organizationName?: Maybe<Scalars['String']['output']>;
  /** L'entree declare-t-elle le slug du parametre VERROUILLE qui porte le perimetre (organization_param) ? FAUX veut dire que l'habilitation serait accordee puis n'ouvrirait jamais : sans ce parametre le fabricant de jeton doit REFUSER DE SIGNER, pas de repli « on verrouille ce qu'on peut », un parametre nul montrant l'integralite du tableau de bord a qui tient le jeton porteur. Expose et non filtre, pour la meme raison que portalEnabled sur un compte : masquer l'entree ferait passer le catalogue pour vide. */
  perimeterLocked?: Maybe<Scalars['Boolean']['output']>;
};

export type AssignableDashboards = {
  __typename?: 'AssignableDashboards';
  dashboards?: Maybe<Array<AssignableDashboard>>;
  /** Pourquoi la liste est vide. Nul des qu'elle ne l'est pas. Ce n'est pas une erreur : le catalogue vide est aujourd'hui le cas NORMAL, et un selecteur qui s'ouvre sur rien sans le dire se lit comme un controle casse. */
  emptyReason?: Maybe<CatalogueEmptyReason>;
};

/** Une liste de partenaires, attribuable a une PERSONNE et non a un rattachement : le module de decouverte n'a aucun axe de compte, une liste par rattachement y serait inobservable. */
export type AssignablePartnerList = {
  __typename?: 'AssignablePartnerList';
  id?: Maybe<Scalars['ID']['output']>;
  /** SON NOM EST LE THEME. Aucune source ne porte l'expertise, pourtant axe de recherche n°1 du portail : « Partenaires IA » n'existe qu'a cet endroit. Corollaire de gouvernance, un nom est partage par tous les clients et ne nomme jamais l'un d'eux. */
  name?: Maybe<Scalars['String']['output']>;
  /** Nombre de LIGNES DE LA LISTE, et non ce que la personne verra : les 1 025 partenaires radies filtrent la vue du module de decouverte sans etre retires d'aucune liste. Zero est la valeur qui compte, une liste vide est valide, et l'accorder ouvre un module sans rien dedans. */
  partnerCount?: Maybe<Scalars['Int']['output']>;
};

export type AssignablePartnerLists = {
  __typename?: 'AssignablePartnerLists';
  /** Vaut toujours EMPTY_CATALOGUE quand il n'est pas nul : ce catalogue est un referentiel de plateforme, sans axe de compte, donc NO_ACCOUNT_IN_PERIMETER n'y est pas atteignable. */
  emptyReason?: Maybe<CatalogueEmptyReason>;
  lists?: Maybe<Array<AssignablePartnerList>>;
};

/** Decision du client sur une candidature. N'ecrit rien dans Salesforce et ne pilote pas le statut de la candidature. */
export enum CandidacyDecision {
  Rejected = 'REJECTED',
  Selected = 'SELECTED'
}

/** Statut affiche d'une candidature. Six valeurs la ou la source en porte dix : les quatre statuts internes de sourcing ne sortent jamais de l API. */
export enum CandidacyStatus {
  /** Source « Soutenance », le libelle DIFFERE de la source. */
  AValiderPourSoutenance = 'A_VALIDER_POUR_SOUTENANCE',
  /** Source « Proposition au client », le libelle DIFFERE de la source. */
  CvAValider = 'CV_A_VALIDER',
  Demarrage = 'DEMARRAGE',
  NoGoCandidat = 'NO_GO_CANDIDAT',
  RejetClientApresSoutenance = 'REJET_CLIENT_APRES_SOUTENANCE',
  RejetClientSurCv = 'REJET_CLIENT_SUR_CV'
}

/** Pourquoi une liste du parcours d'onboarding est vide. Nul des qu'elle ne l'est pas. */
export enum CatalogueEmptyReason {
  /** Le perimetre est bon, le catalogue ne porte aucune entree VIVANTE. Une entree archivee compte comme absente : elle garde ses habilitations mais ne s'accorde plus. L'action est de declarer l'entree au back-office. */
  EmptyCatalogue = 'EMPTY_CATALOGUE',
  /** L'acteur n'a aucun compte dans son perimetre : un collaborateur interne au portefeuille vide. Rien ne s'affichera ici tant qu'un compte ne lui est pas confie : l'action est de demander un portefeuille, pas de declarer un tableau de bord. */
  NoAccountInPerimeter = 'NO_ACCOUNT_IN_PERIMETER'
}

export type CollaboratorPortfolio = {
  __typename?: 'CollaboratorPortfolio';
  added?: Maybe<Scalars['Int']['output']>;
  entries?: Maybe<Array<PortfolioAssignment>>;
  membershipId?: Maybe<Scalars['ID']['output']>;
  removed?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

/** Ce que les lignes de l'onglet Conformite designent. Voir la description des valeurs. */
export enum ComplianceSubject {
  /** Des PARTENAIRES : une ligne par partenaire distinct porte par les phases affichables. Forfait et UO, les deux vivant sous le meme type d'enregistrement « Contrat d'application Forfait/UO ». La colonne « Intervenant » y porte le partenaire et non une personne, et il n'y a pas de colonne « Type ». */
  Partner = 'PARTNER',
  /** Des PERSONNES : une ligne par couple (intervenant, partenaire) porte par les phases affichables. AT, ATF et RM. La colonne « Type » (la nature) n'a de sens que la. */
  Resource = 'RESOURCE'
}

/** Pourquoi aucun contact n'est rendu pour cette adresse. Nul des qu'il y en a un. Le vide est une REPONSE, pas un incident. */
export enum ContactMatchEmptyReason {
  /** L'adresse designe un ou plusieurs contacts, mais AUCUN sur un compte que l'acteur administre. Ni identite, ni societe, ni decompte ne sortent : seulement cette valeur. L'action est de demander le compte, ou de passer la main a qui l'administre ; relire l'adresse n'a aucun sens ici, et c'est ce qui separe cette valeur de la precedente. */
  ContactsOutOfPerimeter = 'CONTACTS_OUT_OF_PERIMETER',
  /** L'acteur n'administre AUCUN compte : un collaborateur interne au portefeuille vide. Aucune adresse ne rendra quoi que ce soit tant qu'un compte ne lui est pas confie : l'action est de demander un portefeuille, jamais de relire l'adresse. */
  NoAccountInPerimeter = 'NO_ACCOUNT_IN_PERIMETER',
  /** Cette adresse ne designe aucun contact ingere, nulle part. C'est le refus de l'option stricte : on n'onboarde que des contacts CONNUS, parce qu'une personne inconnue de la source n'a ni compte, ni marche, ni perimetre, l'inviter produirait un utilisateur qui se connecte et ne voit rien. L'action est de relire l'adresse, ou de faire creer le contact dans la source. Un contact SANS adresse e-mail se lit ICI et non NO_EMAIL : il est structurellement introuvable par une recherche PAR l'adresse. */
  NoContactForEmail = 'NO_CONTACT_FOR_EMAIL'
}

export type ContactMatches = {
  __typename?: 'ContactMatches';
  /** Les contacts que l'adresse designe, dans le perimetre de l'acteur. UNE LISTE, jamais un contact elu : `contact.email` ne porte AUCUNE unicite, la table est un reflet, la source tolere les doublons, l'unicite de l'e-mail est une regle du portail tenue par `user.email`. Mesure sur le miroir (2026-08-07, perimetre client) : 23 adresses portees par plus d'un contact, 52 contacts sur 33 715 (0,15 %), toutes des doublons de la meme personne et aucune ne portant de besoin. Le cas qui compte est la BOITE PARTAGEE, que le jeu A porte expres : deux personnes differentes derriere une meme adresse, et c'est l'ecran qui tranche. */
  contacts: Array<MatchedContact>;
  /** Pourquoi la liste est vide. NUL des qu'elle ne l'est pas. Ce n'est PAS une erreur : la requete a reussi, et « cette adresse n'est pas connue » est exactement ce que l'etape 1 doit afficher. */
  emptyReason?: Maybe<ContactMatchEmptyReason>;
  /**
   * Les comptes ou l'adresse cherchee est DEJA rattachee, dans le perimetre de l'acteur (PCG-109). C'est ce qui permet a l'etape 2 de GRISER la ligne avec son qualificatif court (« Deja rattachee ») au lieu de la laisser cocher puis de la refuser a l'envoi, une fois le role, les marches, les tableaux de bord et la liste de partenaires composes.
   *
   *  **Le fait porte sur l'ADRESSE, pas sur le contact**, et c'est pourquoi il vit ici et non sur chaque `MatchedContact` : `inviteUser` refuse sur `user.email`, et une personne invitee avant que le lien `contact_onboarding` n'existe, ou invitee depuis un autre contact portant la meme adresse, se lirait « libre » sur un compte que la mutation refuse. Deux contacts derriere une boite partagee rendraient d'ailleurs deux fois la meme liste.
   *
   *  **La lecture ne remplace pas le refus** : `MEMBERSHIP_ALREADY_EXISTS` reste leve par `inviteUser`, qui appelle LA MEME fonction, deux operateurs en parallele restent possibles, et une lecture ne verrouille rien.
   *
   *  Un refus reste hors de portee de l'ecran, deliberement : DIFFERENT_ROOT_ORGANIZATION se prononce sur les rattachements de la personne OU QU'ILS SOIENT, y compris hors du perimetre de l'acteur, l'annoncer nommerait un compte qu'il n'a pas le droit de lire.
   *
   * VIDE quand `contacts` l'est, sans second sens : hors perimetre rien ne sort, et sans contact l'option stricte rend l'etape 2 inatteignable, donc il n'y a aucune case a griser.
   */
  existingAttachments: Array<ExistingAttachment>;
};

/** Etat du parcours d'onboarding d'un contact ingere. Echelle a priorite, premier vrai gagnant. Ce n'est PAS l'etat d'acces, qui vit sur membership_status compte par compte. */
export enum ContactOnboardingStatus {
  /** Aucun refus de l'echelle : le parcours peut continuer. */
  Eligible = 'ELIGIBLE',
  /** La source declare que la personne a quitte la societe. Garde-fou d'ELIGIBILITE, jamais d'autorisation : un contact parti dont la personne est deja onboardee garde son acces. */
  LeftCompany = 'LEFT_COMPANY',
  /** Le contact ne porte aucun rattachement vivant. Il reste TROUVABLE (par sa racine) precisement pour qu'on puisse lui afficher ce refus plutot que « adresse inconnue », qui n'appelle pas le meme geste. L'action est de le rattacher a un compte dans la source : le perimetre du portail repose sur les comptes. */
  NoAccount = 'NO_ACCOUNT',
  /** Le contact n'a pas d'adresse e-mail. INATTEIGNABLE par `contactsByEmail`, qui cherche PAR l'adresse : la valeur existe parce que la vue la produit et qu'une autre lecture la rendra. */
  NoEmail = 'NO_EMAIL',
  /** Une ligne `contact_onboarding` existe : la personne a deja un compte portail. Ce n'est PAS un refus, le parcours bifurque en « ajout de comptes », les rattachements existants gardant leur role et leur perimetre. L'etat de ses acces se lit sur sa fiche, compte par compte. */
  Onboarded = 'ONBOARDED',
  /** Le contact a disparu de la source. Ne revoque AUCUN acces (la revocation reste une decision humaine tracee) mais rien ne devrait etre onboarde sur cette base : la personne n'a plus de compte chez l'emetteur, donc plus de perimetre. */
  Vanished = 'VANISHED'
}

/** Pourquoi une habilitation de tableau de bord n'ouvre rien aujourd'hui. Nul des qu'elle ouvre. FAUX ne veut jamais dire « pas accordee » : la ligne est la, elle survit, et c'est cela qu'il faut dire. */
export enum DashboardBlockedReason {
  /** L'entree a ete RETIREE du catalogue depuis qu'elle a ete accordee. L'habilitation survit volontairement (la ligne est ce qui repond a « qui l'avait ») mais elle n'ouvre plus rien : `dashboardEmbed` refuse par DASHBOARD_ARCHIVED. Geste : demander le retablissement de l'entree, ou en declarer une nouvelle. */
  Archived = 'ARCHIVED',
  /** Le module « Tableau de bord » n'est pas ouvert sur le compte dont cette entree est l'objet. Le modele separe deux choses et n'en confond jamais trois : l'ACTIVATION ouvre le module sur le compte, l'HABILITATION lui donne du contenu. Accorder avant d'activer est legitime (configurer precede ouvrir) donc ce n'est pas une anomalie, c'est une configuration inachevee. Geste : activer le module sur ce compte. Inatteignable dans `myDashboards`, qui est borne aux rattachements ou le module est ouvert. */
  ModuleNotEnabled = 'MODULE_NOT_ENABLED',
  /** L'entree ne declare pas le slug du parametre VERROUILLE qui porte le compte, donc le fabricant de jeton REFUSE DE SIGNER : signer sans lui montrerait l'integralite du tableau de bord a qui tient le lien. `declareDashboard` refuse deja une telle declaration ; cette valeur couvre les lignes que cette API n'a pas ecrites, le semis, un INSERT saisi a la main, un futur importeur. Geste : completer l'entree au catalogue. */
  PerimeterNotDeclared = 'PERIMETER_NOT_DECLARED'
}

/** Un lien d'ouverture de tableau de bord, valable quelques minutes. C'est un JETON PORTEUR : il n'est pas « propre a la personne qui l'a demande », quiconque tient l'URL pendant sa duree de vie voit exactement la meme chose. Ce qui le borne est le parametre VERROUILLE, jamais l'identite, ecrire l'inverse conduit a rallonger la duree en croyant que l'identite protege. */
export type DashboardEmbed = {
  __typename?: 'DashboardEmbed';
  /** Quand le lien cesse d'ouvrir, en ISO 8601. Sert a le REFABRIQUER avant l'echeance : un jeton expire ne rend pas une page vide, il rend une erreur Metabase que personne ne sait lire. */
  expiresAt: Scalars['String']['output'];
  /** Les SLUGS effectivement verrouilles dans le jeton, jamais leurs valeurs : les valeurs sont des identifiants de la source, qui ne quittent pas cette API. Toujours au moins un : sans le parametre qui porte le compte, on refuse de signer. */
  lockedParams: Array<Scalars['String']['output']>;
  /** La duree de vie appliquee, en secondes : dix minutes par defaut, configurable par environnement. Elle borne la FENETRE (combien de temps un lien egare reste utilisable) et rien d'autre : elle ne borne aucune PORTEE, et la raccourcir sans verrouiller les parametres ne protegerait rien. */
  ttlSeconds: Scalars['Int']['output'];
  /**
   * L'URL complete a poser dans l'iframe. A TRAITER COMME UN MOT DE PASSE : ne pas la journaliser, ne pas la stocker, ne pas la mettre dans une redirection que quelque chose enregistre.
   *
   * Elle est rendue ENTIERE, et non « le jeton plus de quoi la composer » : la forme du chemin (`/embed/dashboard/<jeton>`) appartient a Metabase, pas a nous, et la recopier dans le front en ferait une seconde definition, celle qui diverge le jour ou l'outil change. Cela evite aussi de faire sortir `metabase_dashboard_id` du schema : ce qui quitte cette API est NOTRE uuid, jamais l'identifiant de l'emetteur.
   *
   * Le FRAGMENT reste au front : `#bordered=…&titled=…&theme=…` ne part vers aucun serveur, donc il ne change rien a la portee et l'apparence n'a rien a faire ici.
   */
  url: Scalars['String']['output'];
};

/** Une entree du catalogue de tableaux de bord, vue de son ADMINISTRATEUR : archivee comprise, la ou `AssignableDashboard` ne rend que les entrees vivantes attribuables. */
export type DashboardEntry = {
  __typename?: 'DashboardEntry';
  /** Non nul des que l'entree est retiree du catalogue. Les habilitations SURVIVENT a l'archivage : c'est ce qui permet de dire qui l'avait, et c'est pourquoi le fabricant de jeton doit lire cette colonne comme il lit le statut du rattachement. */
  archivedAt?: Maybe<Scalars['String']['output']>;
  /** Combien de personnes tiennent ce tableau de bord par un rattachement VIVANT (actif ou invite) : le nombre que l'archivage debranche. Il est rendu plutot que d'etre un motif de refus : archiver ferme reellement, il n'y a pas de demi-effet a proteger, seulement un chiffre a dire. */
  holderCount: Scalars['Int']['output'];
  /** Notre uuid, jamais l identifiant Metabase. */
  id: Scalars['ID']['output'];
  /** Slug du parametre verrouille portant le marche. NON EXIGE, et c'est delibere : §3.11 laisse ouvert le passage de N identifiants de marche dans un jeton signe, tant que l'equipe BI n'a pas repondu. */
  marketParam?: Maybe<Scalars['String']['output']>;
  /** L'identifiant chez Metabase. Il n'est PAS verifie a l'enregistrement : cette API n'a pas de client Metabase, le fabricant de jeton est PCG-26. Un identifiant faux est donc accepte ici et echoue bruyamment a l'ouverture. */
  metabaseDashboardId: Scalars['Int']['output'];
  /** Le libelle vu par le CLIENT, et non le nom de l'objet Metabase. */
  name: Scalars['String']['output'];
  /** Le compte dont le tableau de bord est l'objet. */
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  /** Slug du parametre VERROUILLE portant le compte. Jamais nul sur une entree ecrite par cette API (la declaration le refuse) mais la colonne reste nullable en base, donc une ligne posee a la main peut l'etre. */
  organizationParam?: Maybe<Scalars['String']['output']>;
  /** L'entree declare-t-elle son parametre de perimetre. FAUX veut dire que l'habilitation serait accordee puis n'ouvrirait JAMAIS rien : le fabricant de jeton doit refuser de signer. Il reste expose parce que le controle est APPLICATIF, la base accepte toujours un parametre nul. */
  perimeterLocked: Scalars['Boolean']['output'];
};

/** Etendue des marches visibles par un rattachement. */
export enum DataScope {
  /** Tous les marches accessibles au compte. */
  All = 'ALL',
  /** PCG-305 : les seules ACTIVITES cochees, dans membership_need et membership_service. Le nom de cette valeur parle encore de marche, renomme dans un lot a lui. */
  Restricted = 'RESTRICTED'
}

/** Une colonne du tableau des DC4 d'une prestation. */
export enum Dc4Column {
  Action = 'ACTION',
  SentAt = 'SENT_AT',
  Status = 'STATUS'
}

/** Une page du referentiel des eligibles. Le total voyage a cote precisement parce que la page est bornee : sans lui, une modale montrant cinquante lignes sur 4 444 aurait exactement l air de montrer le referentiel entier. */
export type EligiblePartnerPage = {
  __typename?: 'EligiblePartnerPage';
  items: Array<PartnerRow>;
  /** Le nombre d'eligibles repondant a la recherche, avant bornage. 4 444 sans recherche, mesure du 2026-08-26. */
  totalCount: Scalars['Int']['output'];
};

/** Un rattachement portail que l'adresse cherchee porte DEJA, borne au perimetre de l'acteur. Il n'expose pas un compte de plus : il DESIGNE une ligne de la liste que l'etape 2 propose deja (`accessibleAccounts`), par son identifiant, pour qu'elle soit grisee au lieu d'etre cochable puis refusee a l'envoi. */
export type ExistingAttachment = {
  __typename?: 'ExistingAttachment';
  /** Notre uuid d'organisation. Il se recoupe avec `accessibleAccounts` par CONSTRUCTION : les deux sont bornes par `listAccessibleAccounts`, donc tout identifiant rendu ici est une ligne que l'ecran a deja sous la main, le nom n'a pas a etre redit, et le redire en ferait une seconde source. */
  organizationId: Scalars['ID']['output'];
  /** L'etat STOCKE du rattachement, parce que le geste n'est pas le meme : INVITED ou ACTIVE appellent « changez son role depuis sa fiche », REVOKED ou LEFT appellent une reouverture (`reinstateMembership`). Les quatre refusent l'invitation de la meme facon (MEMBERSHIP_ALREADY_EXISTS ne regarde pas le statut, la ligne existe et l'unique (user_id, organization_id) la protege) donc aucun des quatre ne doit rester cochable. */
  status: MembershipStatus;
};

/** Ancrage d'un objet du portail chez un systeme emetteur. Toujours rendu en LISTE : la correspondance est 0..n, et un scalaire obligerait l'API a en choisir un arbitrairement le jour ou une seconde source arrive. */
export type ExternalRef = {
  __typename?: 'ExternalRef';
  /** L'identifiant de l'objet chez cet emetteur. */
  externalId?: Maybe<Scalars['String']['output']>;
  /** L'emetteur : « salesforce » aujourd'hui. */
  sourceSystem?: Maybe<Scalars['String']['output']>;
};

/** Un tableau de bord detenu par UN rattachement. L'habilitation pend du rattachement et jamais de la personne (§3.4) : quelqu'un rattache a trois comptes peut en detenir trois distinctes, chacune sous son compte. Le cloisonnement est tenu par une cle etrangere COMPOSITE, pas par une regle de service. */
export type GrantedDashboard = {
  __typename?: 'GrantedDashboard';
  /** Nul des que `opens` est vrai. Deux sources pour un fait divergent. */
  blockedReason?: Maybe<DashboardBlockedReason>;
  /** NOTRE uuid d'entree de catalogue, jamais l'identifiant Metabase : c'est lui que `dashboardEmbed` attend. */
  dashboardId: Scalars['ID']['output'];
  /** Quand elle a ete accordee. Le retrait SUPPRIME la ligne : apres lui, cette date ne survit que dans `activity_log`, ou la trace du retrait l'emporte au moment ou elle la detruit. */
  grantedAt: Scalars['String']['output'];
  /** Qui l'a accordee, le nom si on l'a, l'adresse sinon. */
  grantedByName: Scalars['String']['output'];
  /** Le rattachement au titre duquel elle est accordee. Avec l'entree, c'est la cle. */
  membershipId: Scalars['ID']['output'];
  /** Le libelle vu par le CLIENT, et non le nom de l'objet Metabase. */
  name: Scalars['String']['output'];
  /** Cette habilitation ouvre-t-elle quelque chose AUJOURD'HUI ? FAUX ne veut pas dire « pas accordee » : la ligne est la et elle survit. Une entree archivee depuis l'octroi n'ouvre plus rien, et ca se DIT, la masquer repondrait « on ne vous l'a jamais accordee ». */
  opens: Scalars['Boolean']['output'];
  /** Le compte dont l'entree est l'objet. Toujours celui du rattachement : la cle composite ne permet pas qu'il en differe. */
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
};

/**
 * Un commercial referent du perimetre, et les comptes dont il repond.
 *
 * Il vient de l'echelle a quatre barreaux de `membership_account_manager` : derogation sur le rattachement, designation humaine au niveau du compte, proprietaire INGERE du compte, puis rien. Les barreaux 1 et 3 pointent un utilisateur SOURCE, qui n'a pas forcement de compte portail ; le barreau 2 pointe un utilisateur du portail.
 */
export type HomeAccountManager = {
  __typename?: 'HomeAccountManager';
  /** Les comptes du perimetre dont CETTE personne repond, dans l'ordre de la hierarchie. C'est ce qui rend plusieurs commerciaux lisibles : chaque avatar dit de quoi il repond. */
  accountNames: Array<Scalars['String']['output']>;
  /** Prenom et nom recomposes. Nul si la source ne porte ni l'un ni l'autre. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Rempli a 100 % sur le parc : c'est le seul moyen de contact GARANTI, et ce qui porte le bouton « Contacter » en `mailto:` (RG-ACC-27). Aucun formulaire, aucun envoi cote serveur. */
  email?: Maybe<Scalars['String']['output']>;
  /** Stable d'un appel a l'autre : c'est la cle du selecteur d'avatars de la maquette. Ce n'est PAS un identifiant a afficher, et il ne designe pas la meme table selon le barreau. */
  id: Scalars['ID']['output'];
  /**
   * En E.164, ou NUL. Jamais un numero devine : voir `normalizeFrenchPhone`.
   *
   * QUATRE FORMES A LA SOURCE, dont trois se reparent et une non. Le zero parasite apres `+33` touche 106 des 154 mobiles du parc (68,8 %) et rend le numero invalide en E.164 ; le format national et l'E.164 correct se lisent ; les neuf chiffres SANS zero initial, forme que la base de dev porte, sont RENONCES, y remettre un zero fabriquerait un numero.
   *
   * LE MOBILE D'ABORD, LE FIXE ENSUITE. Le mobile est renseigne sur 145 des 256 proprietaires de comptes clients (56,6 %) contre 40 (15,6 %) pour le fixe, mais DIX n'ont que le fixe : preferer sans replier ferait gagner 105 personnes et en perdrait 10 en silence. Ensemble, 60,5 % de couverture, et la normalisation en garde 98,2 %. Deux proprietaires sur cinq n'ont donc AUCUN numero, et l'e-mail reste le seul moyen garanti.
   *
   * La mise en forme, groupee par deux chiffres, appartient a l'ecran : deux formats servis seraient deux verites a tenir d'accord.
   */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   * Le poste, tel que la source le porte.
   *
   * Attention, IL EST VIDE SUR 200 DES 278 PROPRIETAIRES du parc (72 %), et quand il existe il designe rarement un commercial : « Responsable Marketing & Communication », « Chargee de sourcing ». La specification recommande `business_unit__c`, renseigne a 94,6 %, qui N'EST PAS REPLIQUE dans notre miroir : c'est un lot d'ingestion, pas un choix d'ecran.
   */
  title?: Maybe<Scalars['String']['output']>;
};

/**
 * Une carte de la vitrine « Activites » : une prestation en cours et la personne qui la porte.
 *
 * Ce bloc N'EST PAS UNE LISTE : il ne filtre pas, ne trie pas et ne pagine pas. La liste complete et ses vingt colonnes vivent sur « Mon activite », et les definitions y font foi.
 */
export type HomeActivity = {
  __typename?: 'HomeActivity';
  /** Le nom de l'entite SIGNATAIRE du contrat, jamais la tete de hierarchie : un perimetre couvrant plusieurs entites montre donc des noms differents d'une carte a l'autre, ce qui est precisement ce que la carte sert a dire. */
  accountName: Scalars['String']['output'];
  /** Le statut AFFICHE, traduit par `service_status_mapping` : `commande` ou `en_cours`, et jamais autre chose ici, la vitrine ne montrant que ces deux-la. */
  displayStatus: Scalars['String']['output'];
  /** Le nom du contrat d'application, la colonne « Prestation » de Mon activite. Rempli a 100 %. */
  name: Scalars['String']['output'];
  /**
   * Le poste de l'intervenant, verbatim.
   *
   * Attention, CE N'EST PAS UN SECOND TROU : quand la prestation porte un intervenant, sa fonction est la dans 99,95 % des cas (six exceptions sur 12 107). Le cas a ecrire est « pas d'intervenant », pas « intervenant sans fonction ».
   */
  resourceJobTitle?: Maybe<Scalars['String']['output']>;
  /** L'intervenant positionne sur la prestation. NUL sur 594 des 12 701 prestations en cours du perimetre client (4,7 %), et la carte est rendue quand meme (RG-ACC-30) : une prestation sans intervenant existe, la cacher retirerait une prestation reelle de la vitrine. */
  resourceName?: Maybe<Scalars['String']['output']>;
  /** NOTRE uuid de prestation, celui de la fiche vers laquelle la carte ouvre. */
  serviceId: Scalars['ID']['output'];
};

/** Un mois de la chaine financiere. Les douze mois sont TOUJOURS rendus, mois courant inclus, et un mois sans aucune ligne vaut zero sur les trois series (RG-ACC-14) : une serie a trous se lit comme une serie qui s'arrete. */
export type HomeMonth = {
  __typename?: 'HomeMonth';
  /** Somme HT des factures client sur le mois de `invoiceDate` (RG-ACC-12), memes exclusions que la page Factures. La somme des douze mois EST `invoicedOverTwelveMonths`, verifie a l'ecart nul sur donnees reelles. */
  invoiced: Scalars['Float']['output'];
  /** Le PREMIER JOUR du mois, en ISO. C'est un repere de regroupement, jamais une date d'evenement. */
  month: Scalars['String']['output'];
  /**
   * Somme HT des commandes client du perimetre sur le mois de leur date METIER (`order_date`, RG-ACC-11), seul « Annule » etant exclu.
   *
   * Attention, CE N'EST PAS LE MOIS D'ENREGISTREMENT : la date metier et l'horodatage de saisie ne tombent le meme jour que sur 78,66 % des commandes, et 15,4 % sont anterieures de plus de deux jours.
   */
  ordered: Scalars['Float']['output'];
  /**
   * Somme HT des factures reglees sur le mois de `paymentDate` (RG-ACC-13).
   *
   * Attention, LE STATUT EST LE CRITERE ET JAMAIS LA PRESENCE DE LA DATE : 172 factures « Envoyee », 39 « Validee » et 7 « Annulee » portent une date de reglement a la source. Une facture PARTIELLEMENT reglee compte pour son montant HT TOTAL, le HT reellement encaisse n'etant porte par aucun champ.
   *
   * Attention, LE REMPLISSAGE DE `paymentDate` SUIT L'AGE : 99,57 % en 2025-2026 contre 0,31 % en 2019. Sur cette fenetre de douze mois il est de 99,58 %, donc la serie est juste ; un ecran qui remonterait plus loin ne le serait pas.
   */
  paid: Scalars['Float']['output'];
};

/**
 * Les chiffres de l'accueil, calcules cote SERVEUR sur le perimetre de la personne (RG-ACC-21) : le portail n'en derive aucun.
 *
 * ATTENTION, LE PERIMETRE N'EST PAS CELUI QUE LA SPECIFICATION DECRIT, et c'est la specification qui l'ordonne. Elle calcule sur les activites COCHEES dans l'onglet « Activites associees » de la fiche utilisateur du back-office, qui n'existe pas dans ce modele : le perimetre y est (compte, marche), lu par les vues `membership_visible_*`. RG-ACC-08 exige qu'une tuile et la liste qu'elle ouvre donnent le meme perimetre, donc les compteurs reutilisent les vues et les definitions des listes plutot que de rederiver celles de la specification.
 *
 * TROIS DEFINITIONS S'ECARTENT DE LA LETTRE, pour cette raison : `openNeeds` suit l'echelle du portail et non `IsClosed`, `activeMarkets` suit la cloture derivee et non un `Status` que `market` ne porte pas, `servicesInProgress` suit l'echelle AFFICHEE.
 *
 * UN CHAMP NUL VEUT DIRE « LE MODULE N'EST OUVERT SUR AUCUN DE VOS COMPTES », jamais zero, qui est une reponse. C'est ce qui laisse l'ecran masquer la tuile (RG-ACC-22) sans rien affirmer sur le compte.
 */
export type HomeSummary = {
  __typename?: 'HomeSummary';
  /**
   * LES COMMERCIAUX DU PERIMETRE, DEDUPLIQUES PAR PERSONNE (decision produit du 2026-08-25). Un seul quand tous les comptes partagent le meme, autant qu'il y en a sinon, et chacun porte les comptes dont il repond : c'est la rangee d'avatars de la maquette.
   *
   * L'ORDRE EST CELUI DE LA HIERARCHIE, ET LE HASARD A ETE ECARTE. Le produit proposait « le compte le plus haut, ou de facon random ». La vue sert l'AFFICHAGE ET LE ROUTAGE par la meme cle, c'est le choix 16 : un premier tire au sort montrerait deux personnes differentes d'un chargement a l'autre, et le bouton ecrirait a celle qui a gagne ce tour-la. A profondeur EGALE, l'identifiant du compte departage : arbitraire mais stable, le cas que le produit n'avait pas prevu.
   *
   * SUR TOUS LES RATTACHEMENTS ET NON SUR UN MODULE : le commercial n'est pas une donnee de module, c'est la personne a qui ecrire, et la masquer parce qu'un module est ferme retirerait le seul contact de l'ecran.
   *
   * Nul sans rattachement actif ; un tableau VIDE quand il y en a mais qu'aucun ne resout de commercial, ce qui est le cas ORDINAIRE aujourd'hui.
   */
  accountManagers?: Maybe<Array<HomeAccountManager>>;
  /**
   * Combien de comptes du perimetre ne nomment personne, le barreau `none` de l'echelle. La specification en mesure 84 sur le parc (13 %), et ils EXIGENT une designation humaine.
   *
   * L'ECRAN DOIT LE DIRE : sans cette phrase, la carte montre une partie du perimetre en ayant l'air de le montrer entier, ce que ce depot a deja paye sur les tableaux de bord (`accountsInScope < accountsTotal`).
   */
  accountsWithoutManager?: Maybe<Scalars['Int']['output']>;
  /**
   * Marches du perimetre non clos. Un marche actif SANS aucune prestation compte (RG-ACC-04), d'ou la lecture sur `membership_visible_market` et non sur les prestations.
   *
   * Attention, LA CLOTURE EST DERIVEE et non lue : `market` ne porte AUCUNE colonne de statut, contrairement a ce que RG-ACC-04 suppose, et la vue `market_display_status` la deduit de la date de fin.
   *
   * Nul si le module « Mon activite » n'est ouvert sur aucun compte.
   */
  activeMarkets?: Maybe<Scalars['Int']['output']>;
  /**
   * La vitrine des prestations en cours, HUIT AU PLUS, par date de debut decroissante et departagees par le nom a egalite (RG-ACC-29). Le meme perimetre que `servicesInProgress` (RG-ACC-28).
   *
   * LE TRI PAR DATE DE FIN EST EXPLICITEMENT ECARTE : 57,2 % des prestations « En cours » du perimetre de reference ont une echeance depassee, donc l'accueil ouvrirait sur des prestations closes.
   *
   * LE DEPARTAGE PAR LE NOM N'EST PAS DE LA COQUETTERIE : sans second critere, deux chargements successifs rendent deux ecrans differents, ce qu'un lecteur lit comme des cartes qui apparaissent et disparaissent.
   *
   * NUL si le module « Mon activite » n'est ouvert sur aucun compte ; un tableau VIDE s'il l'est mais que rien n'est en cours. Ce ne sont pas la meme nouvelle, et l'ecran doit les dire differemment.
   */
  activities?: Maybe<Array<HomeActivity>>;
  /**
   * Somme HT facturee sur douze mois calendaires glissants, mois courant inclus (RG-ACC-07). Memes exclusions et meme perimetre que la page Factures (RG-ACC-23).
   *
   * Une CHAINE et non un flottant : ce sont des euros au centime, et un montant a huit chiffres passe par un binaire qui ne les represente pas tous. La mise en forme, et le passage en M€ que la maquette demande, appartiennent a l'ecran.
   *
   * Nul si le module « Factures » n'est ouvert sur aucun compte.
   */
  invoicedOverTwelveMonths?: Maybe<Scalars['String']['output']>;
  /**
   * Douze mois, du plus ancien au plus recent.
   *
   * LES SERIES SE VIDENT INDEPENDAMMENT : « Commande » vient du module activite, « Facture » et « Regle » du module factures. Une personne qui n'a que l'un des deux recoit les douze mois avec l'autre serie a zero, et c'est l'ecran qui masque la serie muette (RG-ACC-22). Nul seulement quand AUCUN des deux modules n'est ouvert : rendre la carte entiere nulle pour un module manquant retirerait une serie que la personne a le droit de voir.
   */
  months?: Maybe<Array<HomeMonth>>;
  /**
   * Besoins ouverts du perimetre. C'est EXACTEMENT `myNeeds.totalInProgress`, verifie egal sur donnees reelles : une tuile qui annoncerait un autre nombre que la liste sur laquelle elle ouvre est le defaut que RG-ACC-08 interdit.
   *
   * Nul si le module « Mes besoins » n'est ouvert sur aucun compte.
   */
  openNeeds?: Maybe<Scalars['Int']['output']>;
  /**
   * Prestations dont le statut AFFICHE est « Commande » ou « En cours » (RG-ACC-05) : le statut seul decide, la date de fin n'intervient pas. Les annulees sont deja hors du perimetre.
   *
   * Attention, LA MESURE PORTE UN DEFAUT DE SOURCE ASSUME : 74 % des contrats au statut « En cours » du parc ont une date de fin depassee. Tant que Salesforce ne solde pas le statut, ce nombre inclut des prestations reellement terminees.
   *
   * Nul si le module « Mon activite » n'est ouvert sur aucun compte.
   */
  servicesInProgress?: Maybe<Scalars['Int']['output']>;
};

/** Le commercial referent Freelance.com du compte : la carte « Interlocuteur ». Lu sur membership_account_manager, l'echelle a quatre barreaux, et NON sur Opportunity.OwnerId que le choix 16 ecarte. Il se lit sur le RATTACHEMENT : la carte est donc la meme sur toutes les fiches d'un meme compte. */
export type Interlocutor = {
  __typename?: 'Interlocutor';
  /** Prenom et nom, recomposes. Le bouton « Contacter {Prénom} » prend le premier mot. */
  displayName: Scalars['String']['output'];
  /** Adresse du commercial. ELLE ALIMENTE UN `mailto:` QUE LE FRONT COMPOSE, et rien d'autre : AUCUN e-mail n'est envoye par le portail et RIEN n'est ecrit dans Salesforce. Ce n'est deliberement pas une mutation d'envoi, le client ouvre son propre client de messagerie, et la conversation continue hors du portail. Nulle quand la source ne l'a pas transmise : le bouton disparait, le reste de la carte tient. */
  email?: Maybe<Scalars['String']['output']>;
  /** La FONCTION, RENDUE TELLE QUELLE. TEXTE LIBRE NON NORMALISE a la source : « Ingénieur d'affaires » y coexiste avec sa variante a apostrophe droite, et « DIRECTRICE DES REGIONS » y est en majuscules. LE FRONT NE DOIT PAS LA METTRE EN FORME, ni capitalisation, ni bas de casse, ni remplacement d'apostrophe : ce sont des fonctions reelles, et les corriger a l'affichage en inventerait d'autres. Nulle quand elle est absente, sans repli. (La spec annonce 52 % de remplissage, mesure sur les proprietaires d'OPPORTUNITE ; notre population est celle des gestionnaires de COMPTE, et le taux n'a pas ete remesure dessus.) */
  title?: Maybe<Scalars['String']['output']>;
};

/** Une ligne de la matrice : un compte, et ce que la personne y portera. Role, statut et perimetre appartiennent au couple (personne x compte) et jamais a la personne, d'ou une liste, la ou l'API n'acceptait qu'un role unique pour N comptes. */
export type InviteAttachmentInput = {
  /** Obligatoire, SANS defaut : un « tous » pose par omission etait indiscernable d'un « tous » decide. */
  dataScope: DataScope;
  /**
   * Les BESOINS coches. Vide quand le perimetre est ALL.
   *
   * Attention, ON COCHAIT DES MARCHES JUSQU'A PCG-305 : la branche restreinte des vues joignait sur le marche, donc une activite qui n'en porte aucun sortait de la liste EN SILENCE (16 % des besoins, 27 % des prestations). On coche desormais les objets eux-memes.
   *
   * `dataScope` garde son nom et ne veut plus dire « par marche » : le renommage est un lot a lui.
   */
  needIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  /**
   * Les PRESTATIONS cochees. Vide quand le perimetre est ALL.
   *
   * Attention, ON ENVOIE DES PRESTATIONS ET JAMAIS UN MARCHE, meme quand l'ecran a coche un marche entier : le marche n'est qu'une case qui en coche plusieurs, et l'enregistrer ramenerait le defaut que ce lot corrige.
   *
   * L'UN OU L'AUTRE suffit quand le perimetre est RESTRICTED : un perimetre peut ne porter que des besoins, et les exiger tous les deux refuserait quelqu'un qui ne suit que ceux-la. Les deux vides sur un perimetre restreint est refuse : la personne ne verrait rien.
   */
  serviceIds: Array<Scalars['ID']['input']>;
};

export type InviteCollaboratorInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Comptes clients dont il s'occupe. Peut rester vide. */
  portfolio?: InputMaybe<Array<PortfolioEntryInput>>;
  /** Role de portee backoffice */
  roleId: Scalars['ID']['input'];
};

export type InviteCollaboratorPayload = {
  __typename?: 'InviteCollaboratorPayload';
  activationEmailSent?: Maybe<Scalars['Boolean']['output']>;
  membershipId?: Maybe<Scalars['ID']['output']>;
  portfolioSize?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type InviteUserInput = {
  /** Tous les rattachements en UNE fois : le mail doit partir apres le dernier refus, et le rattachement par defaut n'a de sens qu'une fois tous les comptes connus. */
  attachments: Array<InviteAttachmentInput>;
  /**
   * Le contact INGERE dont cette personne vient : celui que `contactsByEmail` a rendu a l'etape 1.
   *
   *  **OBLIGATOIRE, et c'est ce qui rend la regle stricte tenue plutot qu'affichee.** L'etape 1 refusait deja une adresse qu'aucun contact ingere ne porte ; le serveur, lui, l'acceptait. Toute adresse inconnue echoue desormais a la confrontation contact/adresse, cote API.
   *
   *  Obligatoire ICI seulement : `inviteCollaborator` invite des collaborateurs INTERNES, qui ne sont pas des contacts ingeres, et ne porte pas ce champ.
   *
   * Il est confronte a l'adresse (CONTACT_EMAIL_MISMATCH) et au perimetre de l'acteur (FORBIDDEN_OUT_OF_SCOPE), puis il ECRIT le lien `contact_onboarding` dans la meme transaction que les rattachements, c'est ce lien que `contactsByEmail` relit ensuite en `ONBOARDED`.
   */
  contactId: Scalars['ID']['input'];
  /** Etape facultative. L'absence est l'absence : aucune ligne, et aucun troisieme etat disant « aucun ». */
  dashboardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Etape facultative. Portee par la PERSONNE, l'annuaire des partenaires etant global. */
  partnerListId?: InputMaybe<Scalars['ID']['input']>;
};

export type InviteUserPayload = {
  __typename?: 'InviteUserPayload';
  /** Vrai si le mail est EFFECTIVEMENT parti. Faux quand la personne avait deja un compte actif (aucun mail n'etait du) comme quand l'envoi a echoue : dans ce second cas l'invitation reste dans la file de rejeu, et l'onboarding, lui, est bien enregistre. */
  activationEmailSent?: Maybe<Scalars['Boolean']['output']>;
  membershipIds?: Maybe<Array<Scalars['ID']['output']>>;
  userId?: Maybe<Scalars['ID']['output']>;
};

/** Une facture CLIENT. Attention, LES AVOIRS ET LES ANNULEES N'EN SONT JAMAIS : la lecture les retranche (typologie « Facture », montant strictement positif, statut different d'annule), comme les commandes et les phases annulees. Elles restent en base et se comptent, elles ne s'affichent pas. */
export type Invoice = {
  __typename?: 'Invoice';
  /** Le montant HT (colonne « Total HT »), rempli a 100 %. Attention, UNE CHAINE ET NON UN FLOTTANT : un `Float` perd des centimes sur les montants a sept chiffres, et une facture est le dernier endroit ou arrondir en silence. Toujours strictement positif, la lecture ecartant les avoirs. */
  amount?: Maybe<Scalars['String']['output']>;
  /** L'etablissement A QUI la facture est adressee (colonne « Etablissement »). Attention, CE N'EST PAS LE COMPTE DE RATTACHEMENT et ce n'est pas non plus lui qui cloisonne : les deux different sur 15,6 % des factures du parc. Nul quand l'etablissement facture n'est pas ingere. */
  billedOrganizationName?: Maybe<Scalars['String']['output']>;
  /** La reference du bon de commande emise par LE CLIENT (colonne « N° BdC »), remplie a 100 %. Plusieurs factures peuvent la partager : ce n'est pas un identifiant de facture. */
  clientOrderReference?: Maybe<Scalars['String']['output']>;
  /** Le statut traduit par `invoice_status_mapping`. NUL quand le referentiel ne traduit pas la valeur source : c'est un trou VISIBLE, deliberement, et la passe d'ingestion l'a deja compte au journal. La facture entre quand meme, montrer une facture au statut illisible etant moins grave que d'escamoter une facture vivante. */
  displayStatus?: Maybe<InvoiceDisplayStatus>;
  /**
   * L'URL S3 du PDF de la facture, ou null quand il n'y en a pas.
   *
   * Attention, ELLE SORT DE L'API, ET C'EST UN ARBITRAGE ASSUME (2026-08-13) : le lot precedent la retenait deliberement. Ce qui borne l'acces au document est la POLICY DU SEAU S3, posee sur le stockage et non dans cette API. Tant qu'elle n'est pas en place, ce champ est une porte ouverte, ce qui est le sens de la decision et non un effet de bord.
   *
   * Ce qu'il faut savoir avant de s'en servir : une adresse de stockage servie au navigateur se recopie, se partage et survit a la fermeture du compte. Elle n'est pas un secret que l'API garde. Le jour ou l'on voudra des liens signes et dates, le geste est une mutation sur le modele de `dashboardEmbed`, et ce champ disparait.
   *
   * A lire avec `hasDocument`, qui reste la condition d'affichage du bouton.
   */
  documentUrl?: Maybe<Scalars['String']['output']>;
  /** Date d echeance, remplie a 99,7 %. Attention, ELLE N'EST PAS DANS LA MAQUETTE mais la specification la demande : elle est servie, c'est a l'ecran de decider s'il la montre. */
  dueDate?: Maybe<Scalars['String']['output']>;
  /**
   * Si un PDF existe pour cette facture. Il decide si le bouton de telechargement s'affiche ACTIF ou DESACTIVE, ce que PCG-31 demande dans son enonce.
   *
   * Attention, IL N'EST PAS REDONDANT AVEC `documentUrl` : un ecran qui testerait l'URL elle-meme melerait deux questions, « y a-t-il un document » et « ou est-il », et la seconde n'a pas a etre posee pour dessiner un bouton.
   *
   * Faux sur pres de deux factures sur trois, et l'ecart est CHRONOLOGIQUE : aucune facture anterieure a 2022 n'a de PDF, contre 74 % en 2025. Le bouton desactive est donc l'etat ORDINAIRE de l'historique ancien, pas une anomalie.
   */
  hasDocument: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Date d emission, remplie a 100 %. C est elle que le filtre de periode borne. */
  invoiceDate?: Maybe<Scalars['String']['output']>;
  /** Le numero de la facture, rempli a 100 %. Deux formes coexistent, « FAC-... » et « A25K... ». Attention, LE PREFIXE « A » NE DESIGNE PAS UN AVOIR de facon fiable : 550 avoirs recents portent un numero « FAC-... » depuis le changement de numerotation de 2026. Ne rien deduire de la forme. */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /**
   * La NATURE du marche de la prestation, a lire AVEC `marketName` (PCG-231).
   *
   * ELLE VOYAGE, ELLE NE SE DEDUIT PAS DU NOM : un nom pose a cote d'un marche resolu SANS nom se lirait « sans contrat cadre », alors que la prestation en a un. Meme expression que l'index des sections de « Mon activite », d'ou l'enumeration partagee.
   *
   * `NAMED_MARKET` EST CE QUE CE CHAMP EXISTE POUR DIRE : 295 factures (1,7 %) portent un nom de marche qu'AUCUNE VALEUR DU MENU du filtre n'atteint, `marketIds` portant sur le marche RESOLU. Sans la nature, la colonne nommerait un marche que le lecteur chercherait en vain dans la pastille et il conclurait a un ecran casse. C'est le meme qualificatif court que l'index des sections rend deja, « Marche hors referentiel ».
   */
  marketKind: ServiceSectionKind;
  /**
   * Le nom du marche de la prestation, colonne « Marche » (PCG-231).
   *
   * LA MEME EXPRESSION QUE SUR LA PRESTATION, et c'est tout l'enjeu du champ : la facture ne porte aucun marche, il se lit sur la prestation, donc cette colonne et la fiche ne peuvent pas se contredire. Mesure du 2026-08-26 sur les 17 569 factures affichables : 14 681 resolues (83,6 %), 295 NOMMEES MAIS NON RELIEES (1,7 %), 2 593 sans contrat cadre (14,8 %). Lire le seul marche resolu aurait laisse les 295 blanches dans la liste alors que leur fiche les nomme.
   *
   * NUL VEUT DIRE « AUCUN CONTRAT CADRE », cas ordinaire a 14,8 %, et jamais « nom manquant » : l'ecran ecrit une phrase, il ne laisse pas la cellule vide. Le troisieme cas du modele, marche resolu SANS nom, mesure zero et reste nul plutot que d'emprunter le libelle de la source.
   *
   * C'est `contract_name` et non `reference` : la fiche de prestation affiche le meme, et deux ecrans qui nommeraient un marche de deux facons empecheraient le lecteur de les rapprocher.
   *
   * C'EST LA MEME VALEUR QUE LE MENU DU FILTRE `marketIds`, qui lit `contract_name` lui aussi : une colonne qui nommerait le marche autrement que la pastille empecherait le lecteur de rapprocher les deux. Une nuance, et elle est voulue : le filtre porte sur `market_id`, donc les 295 lignes NOMMEES MAIS NON RELIEES ne sont atteignables par aucune valeur du menu, alors que la colonne les nomme. C'est ce que le menu attendait pour etre honnete, sa propre note demandant que l'ecran dise que ces prestations n'y figurent pas.
   */
  marketName?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  /** Le compte qui porte la prestation, donc celui par lequel le lecteur voit cette facture. Sous l'union des rattachements, deux factures venues de deux comptes seraient sinon indiscernables. */
  organizationName: Scalars['String']['output'];
};

/** Statut affiche d'une facture client, traduit par `invoice_status_mapping`. QUATRE valeurs pour SEPT statuts source. Attention, ANNULE n'est jamais servi : la lecture retranche les factures annulees, comme les commandes et les phases. La valeur reste dans l'echelle parce qu'elle existe en base, pas parce qu'un ecran la montre. */
export enum InvoiceDisplayStatus {
  /** Annulée : 9 factures. Attention, JAMAIS SERVIE PAR `myInvoices`, et le filtre ne doit pas la proposer. Elle existe ici parce que la base la porte. */
  Annule = 'ANNULE',
  /** En cours de facturation : la fusion de QUATRE statuts source (Brouillon, Validée, Générée, Envoyée). 909 factures sur le perimetre de la beta. */
  EnCoursFacturation = 'EN_COURS_FACTURATION',
  /** Partiellement réglée : 107 factures. */
  PartiellementReglee = 'PARTIELLEMENT_REGLEE',
  /** Réglée : 16 919 factures, soit 94,3 % du perimetre. Attention, C'EST CE QUI REND LE FILTRE UTILE A L'ENVERS : il ne sert pas a isoler cet etat, il sert a isoler les 5,7 % restants. */
  Reglee = 'REGLEE'
}

/** Un compte proposable dans le filtre « Entite » de « Factures » : notre uuid et le nom affiche. */
export type InvoiceFilterAccount = {
  __typename?: 'InvoiceFilterAccount';
  /** NOTRE uuid, celui-la meme qu'on renvoie dans `organizationIds`. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Un marche proposable dans le filtre « Marche » de « Factures » : notre uuid et le nom du contrat cadre. */
export type InvoiceFilterMarket = {
  __typename?: 'InvoiceFilterMarket';
  id: Scalars['ID']['output'];
  /** Le nom du contrat CADRE. Attention, il peut etre VIDE : un marche resolu sans nom garde sa place dans le menu plutot que d'en etre ecarte, le retirer ferait disparaitre des factures qui existent. */
  name: Scalars['String']['output'];
};

/** La periode de « Factures ». Elle borne la date de FACTURATION, jamais l'echeance. */
export enum InvoicePeriod {
  /** « Depuis le debut » : aucune borne. C'est le defaut, et l'absence de l'argument dit la meme chose. */
  AllTime = 'ALL_TIME',
  /** Depuis le 1er janvier de l'annee PRECEDENTE, donc deux annees civiles. */
  SinceJanuaryLastYear = 'SINCE_JANUARY_LAST_YEAR',
  /** Depuis le 1er janvier de l'annee EN COURS cote serveur. */
  SinceJanuaryThisYear = 'SINCE_JANUARY_THIS_YEAR'
}

/** Colonne de tri de la liste des factures. */
export enum InvoicesSort {
  /** Nom du compte de rattachement. */
  Account = 'ACCOUNT',
  /** Montant hors taxes. */
  Amount = 'AMOUNT',
  /** Nom de l'etablissement facture, qui n'est pas le compte de rattachement. */
  BilledOrganization = 'BILLED_ORGANIZATION',
  /** Date d'echeance. */
  DueDate = 'DUE_DATE',
  /** Date de facturation. Ordre par defaut, du plus recent au plus ancien. */
  InvoiceDate = 'INVOICE_DATE',
  /** Numero de facture. */
  InvoiceNumber = 'INVOICE_NUMBER',
  /** Reference du bon de commande client. */
  PurchaseOrder = 'PURCHASE_ORDER'
}

/** Un marche ou accord-cadre. */
export type Market = {
  __typename?: 'Market';
  /** Enveloppe contractuelle, en chaine pour ne pas arrondir. Le consomme n'est pas stocke. */
  budgetTotal?: Maybe<Scalars['String']['output']>;
  contractName?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** La formule Est_termine__c recalculee. Un marche termine RESTE VISIBLE : ce drapeau etiquette, il ne filtre pas. */
  isClosed?: Maybe<Scalars['Boolean']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  serviceTypes?: Maybe<Array<MarketServiceType>>;
  /** Statut de la source, VERBATIM et sans traduction : la picklist appartient a l'emetteur. Nul pour un marche cree au back-office. */
  sourceStatus?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  /** Derive de la vue market_display_status, jamais stocke. */
  status?: Maybe<MarketStatus>;
};

/** Nature des prestations. Nomenclature juridique francaise : PORTAGE designe le portage salarial, AT une assistance technique. */
export enum MarketServiceType {
  At = 'AT',
  Forfait = 'FORFAIT',
  Portage = 'PORTAGE'
}

/** Etat affiche d'un marche, DERIVE (vue market_display_status). Un marche termine RESTE VISIBLE : la moitie des marches actifs en source sont deja echus. */
export enum MarketStatus {
  Active = 'ACTIVE',
  /** Annule a la source, quelle que soit sa date de fin. */
  Cancelled = 'CANCELLED',
  /** Termine operationnellement ou facture. */
  Completed = 'COMPLETED',
  /** Echu par sa date. Reste visible : question metier 6.3. */
  Expired = 'EXPIRED',
  /** Regle a la source. */
  Settled = 'SETTLED'
}

/** Un contact INGERE que l'adresse designe. C'est le reflet d'une personne telle que la SOURCE la decrit, pas un compte portail : le compte est `user` + `membership`, cree a l'onboarding. */
export type MatchedContact = {
  __typename?: 'MatchedContact';
  /** Les societes du contact, dans le perimetre de l'acteur, compte principal en tete. VIDE est une reponse juste : c'est le contact NO_ACCOUNT, trouvable par sa racine precisement pour qu'on puisse lui afficher son refus. */
  accounts: Array<MatchedContactAccount>;
  /** La reference METIER que la source transporte (`external_id__c`, « SF-00412 »), celle que la maquette affiche. A NE PAS confondre avec l'ancre technique (source_system, external_id), que rien n'expose : les deux s'appellent « external ID » cote Salesforce. */
  businessReference?: Maybe<Scalars['String']['output']>;
  /** L'adresse telle que la SOURCE l'ecrit, et non celle qui a ete saisie : la comparaison est insensible a la casse (colonne citext), les deux peuvent donc differer d'une majuscule. */
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Notre uuid de contact. */
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  /** Etat du PARCOURS, lu sur la vue contact_onboarding_status et jamais redérive : les quatre refus de l'etape 1 sortent de cette vue, pas de quatre `if` dans un resolveur. Ce n'est pas l'etat d'ACCES, ELIGIBLE ne veut pas dire « autorise », et ONBOARDED n'est pas un refus mais une bifurcation vers l'ajout de comptes. */
  onboardingStatus: ContactOnboardingStatus;
  phone?: Maybe<Scalars['String']['output']>;
  /** Fraicheur de la copie, en ISO 8601. Une donnee repliquee sans date de rafraichissement se lit comme une donnee a jour : c'est une regle de l'ingestion, pas un detail d'affichage. */
  sourceLastModifiedAt: Scalars['String']['output'];
  /** La fonction, rendue VERBATIM. « Ingenieur d'affaires » coexiste avec sa variante a apostrophe droite et « DIRECTRICE DES REGIONS » est en capitales : ce sont de vrais intitules, les normaliser a l'affichage en inventerait que personne ne porte. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Une societe a laquelle le contact est rattache chez la source, BORNEE au perimetre de l'acteur : ce qu'il voit ne depasse pas ce qu'il peut administrer. La liste peut donc etre plus courte que celle de la source (un compte qu'il n'administre pas ne sera pas cochable a l'etape 2 non plus) et elle peut etre VIDE, ce qui est exactement le contact NO_ACCOUNT. */
export type MatchedContactAccount = {
  __typename?: 'MatchedContactAccount';
  /** Notre uuid d'organisation, jamais l'identifiant Salesforce du compte. */
  id: Scalars['ID']['output'];
  /** Compte PRINCIPAL du contact chez la source. AFFICHAGE seul : la liste des comptes se lit sur la seule table de rattachement, l'union avec le compte principal etant mesuree redondante. Ne pilote aucun droit, et n'est pas une valeur par defaut de l'etape 2. */
  isPrimary: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type Membership = {
  __typename?: 'Membership';
  dataScope?: Maybe<DataScope>;
  id?: Maybe<Scalars['ID']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  organization?: Maybe<Organization>;
  role?: Maybe<Role>;
  status?: Maybe<MembershipStatus>;
};

/** Statut affiche, derive par la vue membership_status. */
export enum MembershipDisplayStatus {
  AccessRevoked = 'ACCESS_REVOKED',
  Active = 'ACTIVE',
  ActiveNeverLoggedIn = 'ACTIVE_NEVER_LOGGED_IN',
  /** Le compte de la personne est desactive. */
  Disabled = 'DISABLED',
  HasLeft = 'HAS_LEFT',
  InvitationExpired = 'INVITATION_EXPIRED',
  Invited = 'INVITED'
}

export type MembershipPerimeter = {
  __typename?: 'MembershipPerimeter';
  /** Vide quand le scope vaut all : tout le compte est visible. */
  markets?: Maybe<Array<Market>>;
  membershipId?: Maybe<Scalars['ID']['output']>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  scope?: Maybe<DataScope>;
};

/** Etat d'un rattachement, tel qu'il est stocke. */
export enum MembershipStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED',
  /** La personne a quitte l'entreprise. */
  Left = 'LEFT',
  /** L'acces a ete retire. */
  Revoked = 'REVOKED'
}

export type MembershipSummary = {
  __typename?: 'MembershipSummary';
  membershipId?: Maybe<Scalars['ID']['output']>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  roleCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MembershipStatus>;
  userId?: Maybe<Scalars['ID']['output']>;
};

/** Moment ou le portail a vu un facteur pour la premiere fois. */
export type MfaEnrolment = {
  __typename?: 'MfaEnrolment';
  enabledAt?: Maybe<Scalars['String']['output']>;
};

/** Second facteur d'une personne, tel que le pool Cognito le porte. */
export type MfaState = {
  __typename?: 'MfaState';
  /** Facteurs enregistres, dans le vocabulaire du POOL. Liste VIDE = aucun, ce qui est une reponse : c'est l'objet `mfa` lui-meme qui est nul quand le pool n'a pas repondu. */
  factors: Array<Scalars['String']['output']>;
  /** Celui que le pool reclamera a la connexion. Nul quand il n'y en a aucun. */
  preferred?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Consomme un lien d'activation : pose le mot de passe via inside-api, confirme l'email et ouvre les rattachements. */
  activateAccount?: Maybe<ActivateAccountPayload>;
  /**
   * Ajoute des partenaires eligibles a une liste. **L'ajout est le seul geste GROUPE** : le retrait est unitaire (RG-PTN-13), la modale d'ajout gardant sa multi-selection.
   *
   *  Les partenaires DEJA presents sont ignores plutot que refuses : la modale ne les propose pas, donc un doublon veut dire qu'un autre operateur a ajoute le meme partenaire pendant que l'ecran etait ouvert, et faire echouer les dix-neuf autres pour cela punirait une course.
   *
   *  Un partenaire deja present dans une autre liste garde son `PTN-XXXX` (RG-PTN-07).
   *
   * Refus possibles : NOT_AUTHENTICATED, INTERNAL_STAFF_ONLY, MISSING_PERMISSION, PARTNER_LIST_NOT_FOUND, PARTNER_LIST_ARCHIVED, PARTNER_LIST_EMPTY_SELECTION, PARTNER_NOT_ELIGIBLE.
   */
  addPartnersToList?: Maybe<PartnerListEntry>;
  /**
   * Retire une entree du catalogue **sans la supprimer**. Supprimer debrancherait ses porteurs en silence (`dashboard_membership` cascade) et effacerait la reponse a « qui l'avait ».
   *
   *  **Les habilitations SURVIVENT, et c'est voulu.** Ce qui doit fermer, c'est le CONTENU : le fabricant de jeton de PCG-26 doit lire `archived_at` comme il lit le statut du rattachement. Tant qu'il ne le lit pas, l'archivage retire l'entree du selecteur et d'`inviteUser`, et rien d'autre.
   *
   *  **Cette mutation ne refuse pas** quand des personnes la tiennent, contrairement a `closeAccountToPortal` : fermer un compte ne retirait l'acces de personne, d'ou son refus ; archiver ferme reellement. Ce qui est du a l'operateur est le CHIFFRE, `holderCount`, rendu et journalise.
   *
   * Re-declarer ensuite le meme tableau de bord Metabase sur ce compte reste possible : l'index unique ne couvre que les entrees vivantes.
   *
   * Archiver ce qui est archive est sans effet et n'ecrit aucune ligne de journal.
   *
   * Refus possibles : NOT_AUTHENTICATED, INTERNAL_STAFF_ONLY, MISSING_PERMISSION, FORBIDDEN_OUT_OF_SCOPE, ORGANIZATION_NOT_FOUND, INTERNAL_ORGANIZATION_NOT_ALLOWED, DASHBOARD_NOT_FOUND.
   */
  archiveDashboard?: Maybe<DashboardEntry>;
  /**
   * Retire une liste du catalogue **sans la supprimer**. La base refuse deja l'alternative : `user_partner_list` la reference `ON DELETE RESTRICT`.
   *
   *  **REFUSE tant qu'un utilisateur la tient** (RG-PTN-08), et le nombre ne voyage pas dans une extension : `formatError` ne garde que le code, et l'ecran tient deja `holderCount` sur la liste qu'il affiche. Le detachement se fait depuis la fiche de la personne, jamais ici. Une personne qui a quitte la societe compte toujours : elle bloque donc l'archivage jusqu'a son detachement.
   *
   *  **Le nom reste reserve** apres archivage : `partner_list.name` porte un unique PLEIN, la ou l'unicite du tableau de bord est partielle sur le vivant. Le back-office n'a aucune porte vers une liste archivee, donc ce nom ne se libere en pratique jamais.
   *
   * Archiver ce qui est archive est sans effet et n'ecrit aucune ligne de journal.
   *
   * Refus possibles : NOT_AUTHENTICATED, INTERNAL_STAFF_ONLY, MISSING_PERMISSION, PARTNER_LIST_NOT_FOUND, PARTNER_LIST_HAS_HOLDERS.
   */
  archivePartnerList?: Maybe<PartnerListEntry>;
  /**
   * Change le role portail d'un utilisateur sur un compte.
   *
   * Memes controles que l'invitation, dont la lecture du role : un `roleId` qui ne designe aucune ligne du referentiel repond **ROLE_NOT_FOUND** depuis PCG-121, la ou il repondait MISSING_PERMISSION, soit « demandez le droit » a quelqu'un dont le seul tort etait de citer un role supprime.
   *
   * Refus possibles : NOT_AUTHENTICATED, MEMBERSHIP_NOT_FOUND, MISSING_PERMISSION, FORBIDDEN_OUT_OF_SCOPE, ROLE_NOT_FOUND, BACKOFFICE_ROLE_NOT_ALLOWED, PRIVILEGE_ESCALATION, LAST_ADMINISTRATOR.
   */
  changeMembershipRole?: Maybe<MembershipSummary>;
  /**
   * Referme un compte au portail.
   *
   *  **Ce n'est pas la symetrique de l'ouverture, et le refus qui suit en decoule.** `portal_enabled` est lu par deux regles de service (l'invitation et la reouverture d'un acces) et par AUCUN chemin de lecture : fermer un compte ne retire donc l'acces de personne deja rattachee. La mutation REFUSE tant qu'il reste un rattachement `ACTIVE` ou `INVITED`, plutot que de rendre un compte affiche comme ferme dont les utilisateurs continuent de se connecter. Le geste qui retire un acces est `revokeMembership`, et il se trace personne par personne.
   *
   * `INVITED` compte autant qu'`ACTIVE` : l'activation bascule TOUS les rattachements invites sans relire `portal_enabled`, donc une invitation en cours sur un compte ferme aboutit quand meme.
   *
   * Refus possibles : NOT_AUTHENTICATED, INTERNAL_STAFF_ONLY, MISSING_PERMISSION, FORBIDDEN_OUT_OF_SCOPE, ORGANIZATION_NOT_FOUND, INTERNAL_ORGANIZATION_NOT_ALLOWED, ACCOUNT_HAS_PORTAL_USERS.
   */
  closeAccountToPortal?: Maybe<AccountPortalAccess>;
  /**
   * Cree un role de PORTAIL. Les sept roles etaient figes depuis la mise en service : aucun chemin d'ecriture n'existait. Ce lot ouvre la creation seule, ni modification, ni suppression, qui posent d'autres questions.
   *
   *  **Le role cree est GLOBAL** : `role.organization_id` reste nul, donc il apparait dans le selecteur de TOUS les comptes clients, exactement comme les sept roles semes. Il n'y a pas de role par compte aujourd'hui.
   *
   *  **Aucun argument de portee, et c'est une decision.** Cette mutation ne cree que des roles de portail ; les deux roles back-office suffisent. Un argument qui accepterait BACKOFFICE pour le refuser declarerait dans le contrat une valeur que le serveur ne sert jamais. Le jour ou le besoin existera, un argument FACULTATIF par defaut a PORTAL s'ajoutera sans rien casser.
   *
   *  **Le PERIMETRE DE DONNEES n'entre pas dans un role** : il se pose personne par personne, sur le rattachement (`dataScope`, marches vus). L'ecran le dit, l'API ne le reprend pas.
   *
   * **Le CODE technique nait du NOM** (sans accents, en minuscules, separateurs reduits a `_`) parce que l'ecran ne saisit qu'un nom. Deux noms differents qui produisent le meme code sont REFUSES et non suffixes : un identifiant que personne n'a demande ne nomme rien, et il est lu ensuite par le support. Le prefixe `bo_` est reserve aux roles back-office.
   *
   * **Les DEPENDANCES sont refusees, jamais completees.** Cocher un droit d'action implique la consultation du meme module (`Permission.requiresPermissionCode`), et le telechargement de masse implique l'unitaire. Envoyer l'action sans sa consultation est refuse EN NOMMANT ce qui manque : completer tout seul serait un elargissement muet, sur un role qui vaut pour tous les comptes.
   *
   * **Un role sans aucun droit est refuse par le serveur**, pas seulement par l'ecran.
   *
   * Reserve au **back-office** avec **`manage_referential`**, le droit du referentiel de plateforme, porte par `bo_admin` seul, le meme qui borne les listes de partenaires : un role n'appartient a aucun compte. La portee du role de l'acteur est verifiee AVANT la permission, un role portail sur mesure pouvant porter ce droit.
   *
   * Refus possibles : NOT_AUTHENTICATED, INTERNAL_STAFF_ONLY, MISSING_PERMISSION, EMPTY_ROLE_NAME, ROLE_NAME_TAKEN, EMPTY_ROLE_PERMISSIONS, PERMISSION_NOT_FOUND, PERMISSION_DEPENDENCY_MISSING.
   */
  createRole?: Maybe<Role>;
  /**
   * Fabrique le lien qui ouvre UN tableau de bord habilite, pour quelques minutes.
   *
   *  **A appeler au moment ou la personne AFFICHE son tableau de bord, jamais a sa connexion.** Fabrique a la connexion et valable dix minutes, le jeton est expire quand elle ouvre sa page un quart d'heure plus tard, et l'encart rend une erreur Metabase que personne ne sait lire. Allonger la duree pour qu'il survive a la session detruirait la fenetre courte, c'est-a-dire reconstruirait le lien de longue vie que le modele a ecarte.
   *
   *  **Le jeton rendu est un JETON PORTEUR.** Ce n'est pas le lien qui rend le contenu propre a la personne, ce sont les PARAMETRES VERROUILLES : le compte toujours, et les marches des que le rattachement est restreint. **Si la valeur a verrouiller n'est pas calculable, l'API REFUSE DE SIGNER**, pas de repli « on verrouille ce qu'on peut », un parametre nul montrant l'integralite du tableau de bord a qui tient le lien.
   *
   * Les controles, dans cet ordre : le module actif sur au moins un de vos comptes (avant le perimetre, comme partout), puis une habilitation VIVANTE sur cette entree, puis l'entree non archivee, puis les slugs declares, puis les valeurs calculables, puis la configuration de signature.
   *
   *  Ce que cette API ne peut PAS verifier : que Metabase verrouille reellement ces parametres. Un parametre publie « editable » se comporte comme un parametre verrouille jusqu'a ce que quelqu'un le modifie. C'est le prerequis P14, et il se constate dans Metabase, par un humain.
   *
   * Refus : NOT_AUTHENTICATED, MODULE_NOT_ENABLED, DASHBOARD_NOT_FOUND, DASHBOARD_ARCHIVED, DASHBOARD_PERIMETER_PARAM_REQUIRED, DASHBOARD_PERIMETER_UNRESOLVED, DASHBOARD_EMBED_NOT_CONFIGURED.
   */
  dashboardEmbed?: Maybe<DashboardEmbed>;
  /**
   * Declare un tableau de bord dans le catalogue d'un compte. **DECLARER L'ENTREE EST L'AUTORISATION** : le catalogue est une LISTE BLANCHE saisie a la main, jamais un reflet de Metabase, un reflet listerait des centaines de tableaux de bord internes et le back-office devrait FILTRER ce qu'il propose ; un filtre s'oublie, et son oubli est une fuite.
   *
   *  **Aucune URL n'est saisie, et il ne faut pas en ajouter.** Une URL se transfere, et qui la recoit voit les chiffres du client sans compte ni mot de passe. On declare une entree, l'API deduit le lien.
   *
   *  **`organizationParam` est OBLIGATOIRE.** Sans le slug du parametre verrouille qui porte le compte, le fabricant de jeton refuse de signer : l'habilitation serait accordee et n'ouvrirait jamais rien. Le controle est APPLICATIF, la colonne reste nullable en base, donc `perimeterLocked` reste la garde du lecteur pour les lignes posees autrement.
   *
   * `marketParam` n'est PAS exige : le passage de N identifiants de marche dans un jeton signe reste ouvert cote BI.
   *
   *  L'identifiant Metabase n'est pas verifie ici : cette API n'a pas de client Metabase. Un identifiant faux echoue a l'ouverture.
   *
   * Reserve au **back-office**, meme droit et meme perimetre que l'ouverture du compte : `manage_accounts`.
   *
   * Refus possibles : NOT_AUTHENTICATED, INTERNAL_STAFF_ONLY, MISSING_PERMISSION, FORBIDDEN_OUT_OF_SCOPE, ORGANIZATION_NOT_FOUND, INTERNAL_ORGANIZATION_NOT_ALLOWED, EMPTY_CATALOGUE_NAME, INVALID_METABASE_DASHBOARD_ID, DASHBOARD_PERIMETER_PARAM_REQUIRED, DASHBOARD_ALREADY_DECLARED.
   */
  declareDashboard?: Maybe<DashboardEntry>;
  /**
   * Declare une liste de partenaires. **SON NOM EST LE THEME** : aucune source ne porte l'expertise, pourtant axe de recherche n°1 du portail, « Partenaires IA » n'existe qu'a cet endroit. Regle de gouvernance qu'aucune contrainte ne peut tenir : le catalogue est GLOBAL, donc le nom est partage par tous les clients et n'en nomme jamais un (RG-PTN-10).
   *
   *  **`sourcePartnerIds` est OBLIGATOIRE et non vide** : une liste ne se declare pas vide, l'ecran gardant son bouton desactive a zero selection. Le serveur le refuse aussi, un bouton n'etant pas un controle.
   *
   *  **Aucun mode de composition en argument, et c'en est une decision.** Le MVP ne compose qu'a la main (RG-PTN-06) ; le mode « tous les eligibles, actuels et futurs » est post-MVP. Un argument qui accepterait la valeur automatique pour la refuser declarerait dans le contrat une valeur que le serveur ne sert jamais.
   *
   *  **L'eligibilite est verifiee ICI et pas seulement a l'affichage** : la modale a pu rester ouverte le temps qu'une passe radie l'un des choix, et le front ne filtre rien.
   *
   * Reserve au **back-office** avec **`manage_referential`**, le droit du referentiel de plateforme, porte par `bo_admin` seul. La portee du role est verifiee AVANT la permission : un role portail sur mesure pourrait porter ce droit, et un compte client curerait alors un catalogue partage par tous les autres.
   *
   *  Ce resserrement porte sur l'ECRITURE seule. La LECTURE d'attribution (`assignablePartnerLists`) borne toujours sur `manage_users` : un `account_admin` portail voit tout le catalogue global. Arbitrage metier ouvert, pas un oubli, le refermer deplacerait aussi `inviteUser`.
   *
   * Refus possibles : NOT_AUTHENTICATED, INTERNAL_STAFF_ONLY, MISSING_PERMISSION, EMPTY_CATALOGUE_NAME, PARTNER_LIST_NAME_TAKEN, PARTNER_LIST_EMPTY_SELECTION, PARTNER_NOT_ELIGIBLE.
   */
  declarePartnerList?: Maybe<PartnerListEntry>;
  /**
   * Eteint un module sur un compte : **la ligne est supprimee**.
   *
   *  **Contrairement a `closeAccountToPortal`, cette mutation ne refuse rien.** Fermer un compte au portail ne retirerait l'acces de personne, d'ou son refus tant qu'il reste des rattachements vivants ; eteindre un module, lui, FERME REELLEMENT : le menu, chaque chemin de lecture et chaque mutation du module lisent l'activation. Il n'y a donc pas de demi-effet a proteger.
   *
   * Ce que voient les utilisateurs du compte, immediatement : l'entree disparait du menu, et toute lecture du module repond MODULE_NOT_ENABLED, explicitement, jamais un 404 muet.
   *
   * Rejouer l'extinction est sans effet et n'ecrit aucune ligne de journal. L'historique du geste vit dans `activity_log`.
   *
   *  **Elle ne connait PAS MODULE_NOT_DELIVERED**, contrairement a l'activation, et c'est deliberé : si une ligne existe sur un module non livre (un `INSERT` a la main, que le controle applicatif de l'activation ne couvre pas) il faut pouvoir la retirer. Une garde symetrique la rendrait ineffacable.
   *
   * Refus possibles : NOT_AUTHENTICATED, INTERNAL_STAFF_ONLY, MISSING_PERMISSION, FORBIDDEN_OUT_OF_SCOPE, ORGANIZATION_NOT_FOUND, INTERNAL_ORGANIZATION_NOT_ALLOWED, MODULE_NOT_FOUND.
   */
  disableAccountModule?: Maybe<Array<AccountModule>>;
  /**
   * Active un module sur un compte. **La ligne cree EST l'activation** : il n'existe aucune colonne `enabled`, donc aucun troisieme etat et aucune branche a ajouter aux lecteurs.
   *
   *  **Elle n'accorde de droit a personne.** Elle ouvre le module SUR LE COMPTE ; qui y accede reste decide par les roles. Un droit accorde la ou le module est eteint reste accorde et **sans effet** : la conjonction « droit ∧ module actif » se calcule au moment de l'acte, elle n'est jamais stockee, la fiche d'un role ne change donc pas.
   *
   *  **Rien ne descend l'arbre.** Activer sur le compte parent n'active RIEN chez ses filles ; un geste « appliquer a tout l'arbre » ecrira N lignes, retirables une par une, et ne creera pas d'heritage.
   *
   * Le compte n'a pas besoin d'etre ouvert au portail : `portalEnabled` decide de qui ENTRE, pas de ce que le compte contient. Rejouer l'activation est sans effet et n'ecrit aucune ligne de journal.
   *
   *  **Elle refuse les modules NON LIVRES** (MODULE_NOT_DELIVERED, PCG-98). Le referentiel nommant les six entrees du menu, dont quatre sans ecran, ce refus est desormais la SEULE chose qui empeche d'ouvrir « Factures » sur un ecran vide a perpetuite, jusqu'a PCG-98 c'etait l'absence de la ligne au referentiel qui s'en chargeait. `accountModules.activatable` l'annonce avant le clic.
   *
   * Refus possibles : NOT_AUTHENTICATED, INTERNAL_STAFF_ONLY, MISSING_PERMISSION, FORBIDDEN_OUT_OF_SCOPE, ORGANIZATION_NOT_FOUND, INTERNAL_ORGANIZATION_NOT_ALLOWED, MODULE_NOT_FOUND, MODULE_NOT_DELIVERED, MARKET_RESTRICTION_INCOMPATIBLE.
   */
  enableAccountModule?: Maybe<Array<AccountModule>>;
  /**
   * Accorde un tableau de bord a UN rattachement, apres l'invitation. Rend ce que ce rattachement detient ensuite, relu et non deduit.
   *
   * Le droit est **`manage_users`** et non `manage_accounts` : declarer une entree au catalogue est un acte sur le COMPTE (`declareDashboard`), l'accorder a quelqu'un est un acte d'ADMINISTRATION DES UTILISATEURS, la meme garde que `assignableDashboards`, qui alimente le selecteur, et que `inviteUser`, qui pose l'habilitation initiale. Deux droits pour un geste que le parcours d'onboarding fait deja sous le premier seraient deux regles.
   *
   *  **Elle ne refuse NI le module eteint NI le parametre de perimetre manquant**, et c'est une decision. Le modele separe deux choses : l'ACTIVATION ouvre le module sur le compte, l'HABILITATION lui donne du contenu (§3.4). Configurer avant d'ouvrir est le sens de la marche, donc accorder sur un compte dont le module est ferme est legitime, et l'annoncer est le travail de la LECTURE, `blockedReason`, a cote de l'habilitation.
   *
   *  Elle refuse en revanche une entree ARCHIVEE : `assignableDashboards` ne la propose plus et `inviteUser` la refuse deja, donc l'accorder poserait une ligne dont on sait deja qu'elle n'ouvrira jamais rien. Trois chemins d'octroi, un seul verdict.
   *
   * Idempotente et SANS ligne de journal quand l'habilitation existe deja : un journal qui enregistre des non-gestes est illisible le jour ou on le lit vraiment.
   *
   * Refus : NOT_AUTHENTICATED, MEMBERSHIP_NOT_FOUND, MISSING_PERMISSION, FORBIDDEN_OUT_OF_SCOPE, DASHBOARD_NOT_FOUND, DASHBOARD_NOT_ON_ACCOUNT, DASHBOARD_ARCHIVED.
   */
  grantDashboard: Array<GrantedDashboard>;
  /** Cree un collaborateur interne : rattachement a Freelance.com avec un role back-office, plus son portefeuille de comptes. */
  inviteCollaborator?: Maybe<InviteCollaboratorPayload>;
  /**
   * Cree un utilisateur et TOUS ses rattachements en une transaction, puis declenche l'activation du compte (M12-04, M12-05).
   *
   *  **Le contact choisi a l'etape 1 part avec l'invitation** (PCG-85) : `contactId` est obligatoire, confronte a l'adresse et au perimetre, et le lien `contact_onboarding` s'ecrit dans LA MEME transaction que les rattachements, une personne a demi rattachee est pire qu'une personne non creee.
   *
   * Refus propres au contact : CONTACT_NOT_FOUND, CONTACT_EMAIL_MISMATCH, FORBIDDEN_OUT_OF_SCOPE, CONTACT_ALREADY_LINKED.
   *
   *  **Trois refus ont change de nom en PCG-121, et aucun n'a change de cause.** Un `roleId` inconnu du referentiel repondait MISSING_PERMISSION et repond **ROLE_NOT_FOUND** ; un `dashboardIds` inconnu du catalogue repondait ORGANIZATION_NOT_FOUND et repond **DASHBOARD_NOT_FOUND** ; une entree ARCHIVEE, qui sortait sous le meme ORGANIZATION_NOT_FOUND, repond desormais **DASHBOARD_ARCHIVED** et se distingue donc de la precedente. ORGANIZATION_NOT_FOUND ne parle plus que d'un compte de la matrice. L'archivage n'est lu qu'APRES l'appartenance au compte : le dire avant apprendrait qu'une entree existe hors de la selection.
   */
  inviteUser?: Maybe<InviteUserPayload>;
  /**
   * Ouvre un compte au portail : le geste qui manquait : `portal_enabled` n'etait ecrit par personne, l'import n'en a pas le droit (privileges de colonne) et aucun ecran ne le portait.
   *
   *  **Ouvrir un compte n'accorde aucun acces a personne.** Le compte devient ELIGIBLE a recevoir des utilisateurs du portail ; qui entre se decide ensuite, rattachement par rattachement, par une invitation portant son role et son perimetre. Le nom laisse croire l'inverse, d'ou cette phrase.
   *
   * Une condition : le **commercial referent doit resoudre** (P15). L'echelle du compte (designation humaine (`organization_assignment`), a defaut proprietaire ingere) doit rendre autre chose que `none`, sans quoi le client ouvert se retrouve devant un bloc Interlocuteur qui ne nomme personne et une demande routee vers la boite de repli.
   *
   * Reserve au **back-office** : le geste est une decision Freelance.com.
   *
   * Refus possibles : NOT_AUTHENTICATED, INTERNAL_STAFF_ONLY, MISSING_PERMISSION, FORBIDDEN_OUT_OF_SCOPE, ORGANIZATION_NOT_FOUND, INTERNAL_ORGANIZATION_NOT_ALLOWED, ACCOUNT_MANAGER_UNRESOLVED.
   */
  openAccountToPortal?: Maybe<AccountPortalAccess>;
  /**
   * Enregistre sur SA PROPRE fiche que la personne vient de poser un second facteur pour la premiere fois (PCG-303).
   *
   * **UN EVENEMENT, PAS UN ETAT, et c'est toute la conception.** Savoir si quelqu'un porte un facteur MAINTENANT est une propriete vivante du pool : elle change sans nous, donc une colonne qui la porte se trompe en silence. Cet etat se lit sur `PortalUser.mfa`, jamais en base. Ce qui est stocke ici est le moment de la mise en conformite, que le pool ne sait PAS dire : `AdminGetUser` dit ce qui est enregistre, jamais depuis quand.
   *
   * **Ecrit une fois, jamais efface.** Un evenement ne se de-produit pas : quelqu'un qui retire son facteur s'est bien mis en conformite a cette date, et effacer perdrait la seule trace qu'une lecture 27001 cherche. Le retrait est un evenement a lui, et sa place est le journal d'activite.
   *
   * **Sur sa propre fiche uniquement**, sans argument d'utilisateur : declarer la conformite de quelqu'un d'autre serait un moyen d'ecrire un chiffre sur une personne qu'on ne controle pas.
   *
   * Idempotente par construction. Rend `null` quand l'appelant n'a aucune fiche chez nous, cas le plus frequent sur ce portail et qui n'est pas une erreur.
   *
   * Refus possibles : NOT_AUTHENTICATED.
   */
  recordMfaEnrolment?: Maybe<MfaEnrolment>;
  /**
   * Rouvre un acces ferme : le troisieme seau « acces a reactiver ». La cible depend de la personne : `ACTIVE` si elle a deja active son compte, `INVITED` sinon.
   *
   *  **`INVITED` ne renvoie AUCUN courriel.** Rouvrir ne fabrique pas d'invitation, et la revocation avait annule celle qui restait en attente quand elle fermait le DERNIER acces de la personne. Un `INVITED` en retour veut donc dire : le geste n'est pas fini, appelez `resendInvitation`. Un `ACTIVE` se suffit a lui-meme.
   *
   * **Le motif et la date de la derniere fermeture se lisent AVANT de rouvrir**, sur `portalUser` → `memberships` → `revokedReason` / `revokedBy` / `revokedAt` : sans eux le back-office rouvrirait a l'aveugle un acces que quelqu'un avait ferme pour une raison. Ils ne sont pas effacees par la reouverture et restent donc lisibles apres.
   *
   *  **Le role et le perimetre reviennent tels qu'ils etaient** : la mutation ne prend pas de role, il appartient au rattachement. Restaurer restant accorder, la regle d'anti-escalade s'applique, d'ou `PRIVILEGE_ESCALATION`.
   *
   * Refus possibles : MEMBERSHIP_NOT_FOUND, MEMBERSHIP_NOT_REVOKED, PORTAL_CLOSED_ON_ACCOUNT, ACCOUNT_DISABLED, PRIVILEGE_ESCALATION, DIFFERENT_ROOT_ORGANIZATION, MISSING_PERMISSION, FORBIDDEN_OUT_OF_SCOPE.
   */
  reinstateMembership?: Maybe<MembershipSummary>;
  /**
   * Retire UN partenaire de CETTE liste, sans confirmation (RG-PTN-13). Il reste dans les autres listes ou il figure, et **garde son `PTN-XXXX`** (RG-PTN-07), qui vit sur le partenaire et non sur le rattachement : c'est ce qui rend l'« Annuler » du bandeau exact, un ajout refait rendant la liste a l'identique.
   *
   *  Le rattachement est SUPPRIME et non ferme, sa presence etant le fait ; ce qui subsiste est la ligne de journal, qui emporte la date et l'auteur au moment ou la suppression les detruit. Meme precedent que `revokeDashboard`, pas celui d'un rattachement de compte, qui porte un etat.
   *
   *  Un retrait qui ne trouve rien est SILENCIEUX : c'est l'etat demande, et deux operateurs qui retirent la meme ligne ne doivent pas voir d'erreur.
   *
   * Refus possibles : NOT_AUTHENTICATED, INTERNAL_STAFF_ONLY, MISSING_PERMISSION, PARTNER_LIST_NOT_FOUND, PARTNER_LIST_ARCHIVED.
   */
  removePartnerFromList?: Maybe<PartnerListEntry>;
  /**
   * Renomme une liste. Le nom EST le theme : le changer change ce que la liste veut dire pour tous ceux qui la tiennent, d'ou l'avant et l'apres dans le journal.
   *
   *  **Aucun ecran ne l'appelle aujourd'hui** : le menu « Actions » du detail ne porte que la bascule d'affichage et l'archivage. Elle reste exposee parce qu'elle est le seul chemin qui libere le nom d'une liste archivee, lequel est reserve a jamais.
   *
   * Un nom inchange n'ecrit aucune ligne de journal.
   *
   * Refus possibles : NOT_AUTHENTICATED, INTERNAL_STAFF_ONLY, MISSING_PERMISSION, PARTNER_LIST_NOT_FOUND, EMPTY_CATALOGUE_NAME, PARTNER_LIST_NAME_TAKEN.
   */
  renamePartnerList?: Maybe<PartnerListEntry>;
  /**
   * ENREGISTRE une demande de mise en relation (RG-PAR-10). **Rien n'est envoye, et la confirmation doit le dire** (RG-PAR-14) : un CRON quotidien regroupera les demandes par commercial en un seul courriel, et ce CRON n'existe pas encore, donc `transmission_status` vaut `pending` pour tout le monde. Une confirmation au present serait une phrase sur un fait qui n'a pas eu lieu. Rien n'est ecrit dans Salesforce.
   *
   *  **`organizationId` est VERIFIE et pas seulement recu** : c'est lui qui decide du commercial destinataire (`Account.OwnerId`), donc accepter celui qu'on nous envoie ferait ecrire a l'interlocuteur d'un compte que la personne ne porte pas. Un seul compte ne dispense pas de l'envoyer : le choix est implicite a l'ecran, jamais dans le contrat.
   *
   *  **Le partenaire est verifie PAR LA LISTE**, et la jointure passe par la vue d'eligibilite : un partenaire retire du reseau a quitte l'affichage sans que sa ligne soit supprimee, et demander a etre recontacte a son sujet est exactement ce que le retrait automatique existe pour eviter.
   *
   *  **Aucune protection contre la demande repetee**, et c'est delibere : deux demandes le meme jour sur le meme partenaire sont deux faits, le CRON les regroupe, et refuser la seconde obligerait a decider au bout de combien de temps une demande est neuve.
   *
   * Refus possibles : NOT_AUTHENTICATED, MODULE_NOT_ENABLED, FORBIDDEN_OUT_OF_SCOPE, PARTNER_LIST_NOT_FOUND, PARTNER_NOT_ELIGIBLE.
   */
  requestPartnerContact?: Maybe<PartnerContactRequestRecorded>;
  /**
   * Renvoie le lien d'activation en FAISANT TOURNER LE JETON : le lien precedent est revoque et un nouveau est emis, avec une echeance neuve.
   *
   *  Un jeton d'invitation est un jeton PORTEUR, prolonger son echeance a chaque relance produirait un porteur a duree non bornee. La course « la personne ouvre l'ancien lien pendant la relance » se traite par le MESSAGE affiche, jamais par une duree qui s'etire.
   *
   * Refus possibles : MEMBERSHIP_NOT_FOUND, INVITATION_NOT_FOUND, INVITATION_NOT_PENDING, ACCOUNT_DISABLED, MISSING_PERMISSION, FORBIDDEN_OUT_OF_SCOPE.
   */
  resendInvitation?: Maybe<ResendInvitationPayload>;
  /**
   * Retire un tableau de bord a UN rattachement. Rend ce qu'il detient ensuite.
   *
   *  **LA LIGNE EST SUPPRIMEE, la ou ce depot revoque ailleurs plutot que de supprimer**, et la difference tient a la nature de l'objet. Un `membership` porte un ETAT : un statut que `membership_status` derive, une date et un auteur de fermeture que la fiche relit, un geste de reouverture qui a besoin de la ligne. Une `dashboard_membership` ne porte aucun etat : ni statut, ni colonne de revocation, ni vue qui la derive, et SA PRESENCE EST LE FAIT. Le precedent qui lui ressemble n'est donc pas `revokeMembership` mais `disableAccountModule`. Il n'y a rien a rouvrir : re-accorder n'est pas une reouverture, c'est le meme geste que le premier octroi, aux memes conditions.
   *
   *  Ce que ca coute est dit plutot que taise : apres un retrait, « qui l'avait » ne se repond plus par la ligne mais par le journal. La trace emporte donc CE QUE LA SUPPRESSION DETRUIT (depuis quand l'habilitation existait, et qui l'avait accordee) au moment ou elle le detruit.
   *
   * Elle ne refuse PAS une entree archivee : il faut pouvoir debrancher quelqu'un d'une entree retiree du catalogue, sans quoi la ligne serait indelogeable. Meme asymetrie que `disableAccountModule`, capable d'eteindre ce que `enableAccountModule` refuserait d'allumer.
   *
   * Sans effet et sans journal quand il n'y a rien a retirer.
   *
   * Refus : NOT_AUTHENTICATED, MEMBERSHIP_NOT_FOUND, MISSING_PERMISSION, FORBIDDEN_OUT_OF_SCOPE, DASHBOARD_NOT_FOUND, DASHBOARD_NOT_ON_ACCOUNT.
   */
  revokeDashboard: Array<GrantedDashboard>;
  /** Retire l'acces d'une personne a un compte. L'historique est conserve, le rattachement n'est jamais supprime. */
  revokeMembership?: Maybe<MembershipSummary>;
  /**
   * Pose ou leve l'exigence de MFA sur un compte.
   *
   * **Sur le COMPTE et non sur l'utilisateur un a un** : la demande reelle d'un client est « le MFA pour tout mon monde », et par personne obligerait l'operateur a y penser a chaque invitation. Il n'y a **aucune derogation par utilisateur**, c'est justement l'administration au cas par cas que cette granularite ecarte.
   *
   * **UNE SEULE MUTATION POUR LES DEUX SENS, parce que ce geste EST symetrique**, la ou ses voisins ne le sont pas : poser l'exigence ne cree aucune ligne dependante et n'interdit rien, la lever ne retire rien a personne, un facteur deja enregistre restant enregistre dans le pool. Comparer avec `enableAccountModule`, refuse sur un module non livre quand `disableAccountModule` ne l'est jamais, et avec l'ouverture au portail, qui seme les modules par defaut : ces asymetries-la ont une raison, celle-ci n'en aurait pas.
   *
   * **Ce que l'exigence ne tient pas toute seule, et il faut le savoir avant de s'y fier.** Tant qu'une personne n'a pas enregistre de facteur, elle est appliquee par l'INTERFACE de l'application de compte : qui garde son jeton peut appeler cette API directement. C'est un controle d'onboarding et de conformite, pas une frontiere de securite. A partir de l'enregistrement, c'est Cognito qui reclame le facteur a chaque connexion, et la barriere devient reelle.
   *
   * **Le moment ou elle s'applique n'est pas l'activation** : l'ecran d'activation finit non authentifie et poser un TOTP exige une session. La barriere est au premier chargement authentifie.
   *
   * Idempotente : rejouee, elle n'ecrit aucune seconde ligne de journal, un acte qui n'a rien change n'etant pas un acte.
   *
   * Reserve au **back-office** : la configuration d'un compte est une decision Freelance.com.
   *
   * Refus possibles : NOT_AUTHENTICATED, INTERNAL_STAFF_ONLY, MISSING_PERMISSION, FORBIDDEN_OUT_OF_SCOPE, ORGANIZATION_NOT_FOUND, INTERNAL_ORGANIZATION_NOT_ALLOWED.
   */
  setAccountMfaRequirement?: Maybe<AccountMfaRequirement>;
  /**
   * Bascule l'affichage de la liste cote client (RG-PTN-05), sans confirmation, avec effet a la lecture suivante. C'est la SEULE des deux natures d'une liste qui se change : le mode de composition est fixe a la declaration, et le menu « Actions » ne propose donc pas de bascule pour lui.
   *
   *  Passer en nominatif DECOUVRE des raisons sociales a tous les porteurs de la liste : le journal garde donc le nombre de partenaires et de porteurs concernes le jour ou ca arrive, parce que rien d'autre ne le dira ensuite.
   *
   * Une valeur inchangee n'ecrit aucune ligne de journal. Une liste ARCHIVEE est refusee : plus personne ne la lit, la bascule serait sans objet.
   *
   * Refus possibles : NOT_AUTHENTICATED, INTERNAL_STAFF_ONLY, MISSING_PERMISSION, PARTNER_LIST_NOT_FOUND, PARTNER_LIST_ARCHIVED.
   */
  setPartnerListAnonymity?: Maybe<PartnerListEntry>;
  /** Depose une demande de besoin AU TITRE D'UN COMPTE, que l'appelant designe. Insert en base d'abord, e-mail au commercial ensuite : une transaction se rollback, un e-mail parti ne se rappelle pas. La demande n'apparait pas dans myNeeds tant qu'elle n'est pas redescendue de Salesforce. */
  submitNeed?: Maybe<SubmittedNeed>;
  /** Remplace le portefeuille d'un collaborateur par la liste fournie : ce qui n'y figure plus est retire. */
  updateCollaboratorPortfolio?: Maybe<CollaboratorPortfolio>;
  /**
   * Modifie une entree declaree. **Un argument absent ne touche a rien** : ce n'est jamais « mettre a nul ».
   *
   *  **`organizationParam` ne peut pas etre vide.** Le vider laisserait une entree qui garde ses habilitations et cesse d'ouvrir : pire que jamais declaree, personne n'allant chercher.
   *
   * Une entree archivee reste modifiable (c'est aujourd'hui la seule facon de liberer le nom d'une liste archivee du cote partenaires) mais la modification ne la fait PAS revenir au catalogue.
   *
   * Un patch qui ne change rien n'ecrit aucune ligne de journal.
   *
   * Refus possibles : NOT_AUTHENTICATED, INTERNAL_STAFF_ONLY, MISSING_PERMISSION, FORBIDDEN_OUT_OF_SCOPE, ORGANIZATION_NOT_FOUND, INTERNAL_ORGANIZATION_NOT_ALLOWED, DASHBOARD_NOT_FOUND, EMPTY_CATALOGUE_NAME, INVALID_METABASE_DASHBOARD_ID, DASHBOARD_PERIMETER_PARAM_REQUIRED, DASHBOARD_ALREADY_DECLARED.
   */
  updateDashboard?: Maybe<DashboardEntry>;
  /**
   * Definit ce qu'un utilisateur voit. Les listes sont l'ETAT VOULU et non un differentiel : ce qui n'y figure plus est retire.
   *
   * Attention, ON COCHAIT DES MARCHES JUSQU'A PCG-305, ET LE NOM DE CETTE MUTATION N'A PAS SUIVI. La branche restreinte des vues joignait sur le marche : une activite qui n'en porte aucun sortait de la liste EN SILENCE (16 % des besoins, 27 % des prestations). On envoie desormais des BESOINS et des PRESTATIONS. Le renommage est un lot a lui.
   *
   * L'UN OU L'AUTRE suffit sur une portee RESTRICTED : un perimetre peut ne porter que des besoins. Les deux vides est refuse, la personne ne verrait rien.
   *
   * Attention, LES MARCHES RENDUS SONT UN AFFICHAGE ET NON LE PERIMETRE : ce sont ceux des prestations cochees, donc ils ne disent rien des besoins ni des prestations sans marche. Ne pas s'en servir pour reconstituer ce qui est coche.
   */
  updateMembershipPerimeter?: Maybe<MembershipPerimeter>;
};


export type MutationActivateAccountArgs = {
  input: ActivateAccountInput;
};


export type MutationAddPartnersToListArgs = {
  partnerListId: Scalars['ID']['input'];
  sourcePartnerIds: Array<Scalars['ID']['input']>;
};


export type MutationArchiveDashboardArgs = {
  dashboardId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationArchivePartnerListArgs = {
  partnerListId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationChangeMembershipRoleArgs = {
  membershipId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};


export type MutationCloseAccountToPortalArgs = {
  organizationId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateRoleArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  permissionCodes: Array<Scalars['String']['input']>;
};


export type MutationDashboardEmbedArgs = {
  dashboardId: Scalars['ID']['input'];
};


export type MutationDeclareDashboardArgs = {
  marketParam?: InputMaybe<Scalars['String']['input']>;
  metabaseDashboardId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  organizationParam: Scalars['String']['input'];
};


export type MutationDeclarePartnerListArgs = {
  isAnonymous: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  sourcePartnerIds: Array<Scalars['ID']['input']>;
};


export type MutationDisableAccountModuleArgs = {
  moduleCode: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEnableAccountModuleArgs = {
  moduleCode: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationGrantDashboardArgs = {
  dashboardId: Scalars['ID']['input'];
  membershipId: Scalars['ID']['input'];
};


export type MutationInviteCollaboratorArgs = {
  input: InviteCollaboratorInput;
};


export type MutationInviteUserArgs = {
  input: InviteUserInput;
};


export type MutationOpenAccountToPortalArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationReinstateMembershipArgs = {
  membershipId: Scalars['ID']['input'];
};


export type MutationRemovePartnerFromListArgs = {
  partnerListId: Scalars['ID']['input'];
  sourcePartnerId: Scalars['ID']['input'];
};


export type MutationRenamePartnerListArgs = {
  name: Scalars['String']['input'];
  partnerListId: Scalars['ID']['input'];
};


export type MutationRequestPartnerContactArgs = {
  organizationId: Scalars['ID']['input'];
  sourcePartnerId: Scalars['ID']['input'];
};


export type MutationResendInvitationArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationRevokeDashboardArgs = {
  dashboardId: Scalars['ID']['input'];
  membershipId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRevokeMembershipArgs = {
  membershipId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetAccountMfaRequirementArgs = {
  organizationId: Scalars['ID']['input'];
  required: Scalars['Boolean']['input'];
};


export type MutationSetPartnerListAnonymityArgs = {
  isAnonymous: Scalars['Boolean']['input'];
  partnerListId: Scalars['ID']['input'];
};


export type MutationSubmitNeedArgs = {
  extractedDailyRate?: InputMaybe<Scalars['String']['input']>;
  extractedJobTitle?: InputMaybe<Scalars['String']['input']>;
  extractedLocation?: InputMaybe<Scalars['String']['input']>;
  extractedStartDate?: InputMaybe<Scalars['String']['input']>;
  extractionModel?: InputMaybe<Scalars['String']['input']>;
  isPortageCommercial?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  rawBrief: Scalars['String']['input'];
  requestedType: NeedType;
};


export type MutationUpdateCollaboratorPortfolioArgs = {
  membershipId: Scalars['ID']['input'];
  portfolio: Array<PortfolioEntryInput>;
};


export type MutationUpdateDashboardArgs = {
  dashboardId: Scalars['ID']['input'];
  marketParam?: InputMaybe<Scalars['String']['input']>;
  metabaseDashboardId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationParam?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMembershipPerimeterArgs = {
  membershipId: Scalars['ID']['input'];
  needIds: Array<Scalars['ID']['input']>;
  scope: DataScope;
  serviceIds: Array<Scalars['ID']['input']>;
};

/** Une entree du module « Tableau de bord » telle que la personne connectee la voit. La liste rend N entrees NOMMEES PAR LEUR COMPTE, et jamais un selecteur de compte : le portail affiche l'union des rattachements, sans exception. */
export type MyDashboard = {
  __typename?: 'MyDashboard';
  /** Nul des que `openable` est vrai. MODULE_NOT_ENABLED n'y est pas atteignable : cette liste est bornee aux rattachements ou le module est ouvert. */
  blockedReason?: Maybe<DashboardBlockedReason>;
  /** A passer tel quel a `dashboardEmbed`. C'est notre uuid, jamais l'identifiant Metabase. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**  FAUX veut dire « vous la detenez et elle n'ouvre plus », jamais « vous ne l'avez pas ». La tuile reste affichee avec son motif : la retirer ferait disparaitre sans explication ce qui s'ouvrait hier, et rendrait DASHBOARD_ARCHIVED inatteignable depuis l'ecran. */
  openable: Scalars['Boolean']['output'];
  organizationId: Scalars['ID']['output'];
  /** Le compte, pour l'en-tete du regroupement. Le cas « une seule vue pour tout le groupe » se dit sans rien ajouter : une entree declaree sur le compte parent, accordee a qui tient un rattachement sur le parent. */
  organizationName: Scalars['String']['output'];
};

/** Les tableaux de bord ouverts a la personne connectee, tous comptes confondus. */
export type MyDashboards = {
  __typename?: 'MyDashboards';
  /** Sur combien de comptes cette liste porte. INFERIEUR a `accountsTotal` quand le module n'est ouvert que sur une partie des comptes de la personne : l'ecran DOIT alors le dire, sinon il montre une part de ce qu'elle detient en pretendant la montrer toute. */
  accountsInScope: Scalars['Int']['output'];
  /** Nombre de rattachements actifs de la personne. */
  accountsTotal: Scalars['Int']['output'];
  dashboards: Array<MyDashboard>;
  /** Pourquoi la liste est vide. Nul des qu'elle ne l'est pas. Ce n'est PAS une erreur : la requete a reussi, et le vide est le cas NORMAL, le catalogue est saisi a la main et l'habilitation se pose personne par personne. Le §3.4 exige un etat vide EXPLICITE, jamais un cadre blanc. */
  emptyReason?: Maybe<MyDashboardsEmptyReason>;
};

/** Pourquoi la liste des tableaux de bord de la personne est vide. Nul des qu'elle ne l'est pas. */
export enum MyDashboardsEmptyReason {
  /** Aucun tableau de bord ne vous est ouvert. Le catalogue est une LISTE BLANCHE saisie a la main, compte par compte, et l'habilitation se pose personne par personne : le vide est donc le cas NORMAL tant que rien n'a ete declare ni accorde. */
  NoDashboardGranted = 'NO_DASHBOARD_GRANTED'
}

/** Une page de factures, son total et le referentiel du filtre « Entite ». */
export type MyInvoicesPage = {
  __typename?: 'MyInvoicesPage';
  /** Les comptes ou « Factures » est ouvert, pour le menu « Entite ». Attention, IL NE SUIT AUCUN FILTRE : un menu deduit des lignes rendues se raccourcirait au premier clic, et plus rien ne permettrait d'y revenir. Un compte sans aucune facture y figure donc aussi. */
  accounts: Array<InvoiceFilterAccount>;
  /** Sur combien de comptes cette liste porte. */
  accountsInScope: Scalars['Int']['output'];
  /** Combien de comptes la personne detient en tout. Quand il depasse `accountsInScope`, l'ecran DOIT le dire : sans cette phrase il montre une part de ce que la personne detient en ayant exactement l'air de le montrer tout entier. */
  accountsTotal: Scalars['Int']['output'];
  items: Array<Invoice>;
  /**
   * Les marches proposables dans le filtre « Marche ». Attention, IL NE SUIT AUCUN FILTRE, comme `accounts` : un menu deduit des lignes rendues se raccourcirait au premier clic.
   *
   * Il porte les marches qui ont AU MOINS UNE FACTURE VISIBLE, et non tous ceux du perimetre : un marche sans facture serait une option qui ne peut rien rendre, ce qui se lit comme une panne.
   */
  markets: Array<InvoiceFilterMarket>;
  /** Le nombre COMPLET de factures retenues, jamais celui de la page : c'est lui que le compteur de l'ecran affiche. Il SUIT la recherche et les filtres, sans quoi il annoncerait « 400 factures » au-dessus d'une liste qui en montre trois. */
  totalInvoices?: Maybe<Scalars['Int']['output']>;
};

/** Une page de la liste « Mes besoins ». Le compteur porte le nom de son perimetre : il ne compte PAS tous les besoins du compte. */
export type MyNeedsPage = {
  __typename?: 'MyNeedsPage';
  /**
   * Les operationnels proposables dans le filtre « Operationnel » (PCG-170). MEME REGLE QUE `markets` : aucun filtre ne le raccourcit, et il est servi meme quand la page est vide.
   *
   * Il porte les operationnels qui ont AU MOINS UN besoin en cours visible, et il ecarte les contacts que la source ne renvoie plus (`vanished_at`) : la MEME garde qu'a la lecture d'une ligne, sans quoi le menu proposerait une personne que la colonne n'affiche plus.
   *
   * ATTENTION, IL PEUT ETRE LONG, et c'est ce qui decide du controle a l'ecran : mesure par lecteur le 2026-08-26, cinq personnes en verraient 2 a 5, une en verrait 395 sur ses 1 200 besoins. Une liste a cases sans recherche interne est inutilisable pour cette derniere. Le tri est alphabetique pour la meme raison.
   */
  contacts: Array<NeedFilterContact>;
  items?: Maybe<Array<Need>>;
  /** Les marches proposables dans le filtre « Marche » (PCG-170).\n\nATTENTION, IL NE SUIT AUCUN FILTRE, comme le menu « Entite » des factures : un menu deduit des lignes rendues se raccourcirait au premier clic, et plus rien ne permettrait d'y revenir. Il est servi meme quand la page est VIDE, sans quoi une recherche infructueuse retirerait le menu qui permet de la defaire.\n\nIl porte les marches qui ont AU MOINS UN besoin en cours visible, et non tous ceux du perimetre : un marche sans besoin serait une option qui ne peut rien rendre, ce qui se lit comme une panne. */
  markets: Array<NeedFilterMarket>;
  /** Besoins EN COURS du perimetre, avant pagination et APRES recherche et filtre : commandes et perdus exclus. Il compte donc l'ensemble que la liste montre : un total qui ignorerait le filtre afficherait « 1–3 sur 142 » et se lirait comme un bug. A ne pas confondre avec le nombre de besoins du compte : mesure, le rapport est de 22. */
  totalInProgress?: Maybe<Scalars['Int']['output']>;
};

/** La liste de partenaires de la personne connectee, paginee et triee. */
export type MyPartnersPage = {
  __typename?: 'MyPartnersPage';
  accounts: Array<PortalPartnerAccount>;
  /**
   * Les expertises proposables au filtre, par ordre alphabetique. **Elles ne suivent AUCUN filtre**, meme regle que le menu « Entite » de « Mon activite » : un menu deduit des lignes rendues se raccourcirait au premier clic, et plus rien ne permettrait d'y revenir. Il se lit sur la LISTE ENTIERE de la personne, avant recherche et avant filtre.
   *
   *  **Ce sont les expertises presentes dans SA liste**, jamais le referentiel des 1 391 : un menu de 1 391 cases dont la plupart ne rendraient rien n'est pas un filtre.
   *
   *  **C'est la SEULE des trois pastilles de la spec qui soit construisible**, et c'est une mesure : 1 391 libelles pour 27 561 liens, soit ~20 partenaires par libelle, un referentiel ferme et repete. Les certifications et les partenariats sont du texte libre a 1 282 valeurs distinctes pour 1 514 lignes, donc presque une par ligne : un menu y offrirait des options qui ne selectionnent qu'une ligne chacune.
   */
  expertiseOptions: Array<Scalars['String']['output']>;
  /** Vrai : `name` est nul sur chaque ligne et la recherche ne porte pas dessus. L'ecran en a besoin pour savoir quoi mettre dans sa premiere colonne, et pour ne pas offrir un tri sur un champ qu'il n'a pas. */
  isAnonymous: Scalars['Boolean']['output'];
  items: Array<PortalPartner>;
  /** Le THEME de la liste (« Partenaires IA »), qui ne nomme jamais un client (RG-PTN-10). **NUL VEUT DIRE « AUCUNE LISTE RATTACHEE »**, ce qui n'est PAS une liste vide : la premiere se repare a l'onboarding de la personne, la seconde en ajoutant des partenaires au back-office. Deux gestes, deux guichets, deux phrases (Q-PAR-04). Il est rendu pour que l'ecran puisse nommer la selection qu'il montre : une sous-partie curee presentee comme « les partenaires » montre une part en ayant l'air de montrer le tout. */
  listName?: Maybe<Scalars['String']['output']>;
  /** Le nombre de partenaires de la liste repondant a la recherche, avant pagination. Le compteur du pied de tableau vient de la et jamais de `items.length`, qui compte une PAGE. */
  totalCount: Scalars['Int']['output'];
};

/** Une page de la liste « Mon activite », onglet Prestations. */
export type MyServicesPage = {
  __typename?: 'MyServicesPage';
  /**
   * Les comptes proposables dans le filtre « Entite » : ceux ou « Mon activite » est ouvert, y compris ceux qui ne portent aucune prestation.
   *
   * Attention, IL NE SUIT AUCUN FILTRE, et c'est sa raison d'etre. Un menu deduit des lignes rendues se raccourcirait au premier clic : on coche un compte, les autres quittent le menu, et plus rien ne permet d'y revenir. Sa longueur EST `accountsInScope`, les deux venant de la meme lecture.
   *
   * Servi ici AUSSI parce que la lecture A PLAT existe toujours : `section` restreint, il ne remplace pas la liste, et un ecran qui lirait a plat n'aurait sinon aucune source pour son menu.
   */
  accounts: Array<ServiceFilterAccount>;
  /** Sur combien de comptes cette page porte. INFERIEUR a `accountsTotal` quand le module est ouvert sur une partie seulement des comptes de la personne : l'ecran DOIT alors le dire, sinon il montre une part de l'activite en pretendant la montrer toute, le defaut exact que l'union corrige. */
  accountsInScope: Scalars['Int']['output'];
  /** Nombre de rattachements actifs de la personne. */
  accountsTotal: Scalars['Int']['output'];
  items?: Maybe<Array<Service>>;
  /**
   * Prestations du perimetre, avant pagination et APRES recherche ET filtres (PCG-130). Le nom dit ce qu'il compte : la liste ne retranche rien, contrairement a `myNeeds` dont le compteur s'appelle `totalInProgress`. Il SUIT la recherche et les trois filtres, sans quoi l'ecran afficherait « 1-25 sur 312 » sous une liste filtree a 4.
   *
   * Attention, avec `section` il compte LA SECTION, et sous filtre il compte la section FILTREE : c'est exactement le `serviceCount` que `myServiceSections` annonce pour les memes arguments.
   */
  totalServices?: Maybe<Scalars['Int']['output']>;
  /** Les colonnes de l'ecran qu'aucune source n'alimente, avec leur motif. Le front y lit de quoi ecrire « non disponible » plutot que de laisser un blanc qui se lirait « zero ». Vide le jour ou tout sera servi. */
  unavailableColumns?: Maybe<Array<UnavailableServiceColumn>>;
};

/** Un besoin, REFLET d'une opportunite Salesforce : l'API le lit, l'ingestion l'ecrit. Les identifiants exposes sont nos uuid, jamais une reference metier. */
export type Need = {
  __typename?: 'Need';
  candidacyCount?: Maybe<Scalars['Int']['output']>;
  /** Reference du besoin dans le SI du client. Renseignee sur ~13 % des besoins. */
  clientReference?: Maybe<Scalars['String']['output']>;
  /** L'operationnel : colonne « Opérationnel ». Nul quand le besoin n'en a pas (9 mesures), quand le contact n'est pas dans notre perimetre, ou quand la source ne l'envoie plus. Une absence reste une absence : aucune valeur de repli. */
  contact?: Maybe<NeedContact>;
  /** Le plus eleve des phases non optionnelles exprimees en jours. Null si aucune : la colonne source melange taux et forfaits. */
  dailyRate?: Maybe<Scalars['String']['output']>;
  /** Etape DERIVEE. Null quand Salesforce remonte un statut absent du referentiel : un trou visible, pas une erreur. */
  displayStep?: Maybe<NeedDisplayStep>;
  id?: Maybe<Scalars['ID']['output']>;
  isPortageCommercial?: Maybe<Scalars['Boolean']['output']>;
  /** Fraicheur du reflet. Une donnee repliquee sans date de rafraichissement se lit comme une donnee a jour. */
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  market?: Maybe<NeedMarket>;
  publishedAt?: Maybe<Scalars['String']['output']>;
  stepPosition?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['String']['output']>;
  /** A croiser avec isPortageCommercial : AT + portage se lit « RM ». */
  type?: Maybe<NeedType>;
};

/** Fil d'Ariane de la fiche. TOUJOURS rendu ; c'est le pas qui peut etre vide. Les deux pas nuls se lisent « progression inconnue », jamais « progression a zero ». */
export type NeedBreadcrumb = {
  __typename?: 'NeedBreadcrumb';
  /** Le besoin est sorti de l echelle (annule, perdu). Faux quand le pas est inconnu. */
  isTerminal: Scalars['Boolean']['output'];
  /** Position sur l echelle COURANTE : les deux ne comptent pas le meme nombre de barreaux. Nulle sur un pas terminal comme sur un pas inconnu : isTerminal les separe. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Echelle qui fait foi, arbitree par le marche dans la vue need_breadcrumb. Elle commande les LIBELLES des barreaux, donc elle sort meme quand le pas est vide. */
  process: NeedProcess;
  /** Pas du parcours client. TOUJOURS nul quand process vaut STRICT : sur un besoin cadre, le referentiel ordinaire n est pas joint, il ne peut donc rien preter. */
  standardStep?: Maybe<NeedDisplayStep>;
  /** Pas de la procedure d achat. TOUJOURS nul quand process vaut STANDARD. Vocabulaire disjoint de standardStep, pour qu une fuite d une echelle a l autre ne soit pas serialisable. */
  strictStep?: Maybe<NeedProcessStep>;
};

/** Candidature proposee au client. Les statuts internes de sourcing ne sortent jamais : le filtre est une regle de confidentialite, portee par le referentiel. */
export type NeedCandidacy = {
  __typename?: 'NeedCandidacy';
  availableFrom?: Maybe<Scalars['String']['output']>;
  candidateName?: Maybe<Scalars['String']['output']>;
  /** En chaine pour ne pas arrondir un decimal. */
  dailyRate?: Maybe<Scalars['String']['output']>;
  /** Decision du client. N'ecrit rien dans Salesforce. */
  decision?: Maybe<CandidacyDecision>;
  /** Un CV est-il rattache au candidat ? UN BOOLEEN, ET JAMAIS UNE URL. La specification est formelle : « Ne porte aucun lien : le fichier est sur AWS S3 et la table qui porte sa reference n'est pas repliquee. » En faire un lien produirait un lien MORT, pas un lien absent, ouvrir un CV depuis le portail demanderait un flux de fichiers qui n'existe pas, pas un champ de plus ici. Vrai sur 93 % des candidatures vues par le client. NUL = la ressource du vivier n'a pas resolu, donc on ne SAIT pas : ce n'est pas « pas de CV ». */
  hasCv?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  proposedAt?: Maybe<Scalars['String']['output']>;
  /** Statut affiche. NE SE DEDUIT PAS de la valeur source : « Proposition au client » sort CV_A_VALIDER, « Soutenance » sort A_VALIDER_POUR_SOUTENANCE. Le referentiel porte le libelle, la source porte la cle. NUL quand le statut source est absent du referentiel : la candidature est rendue quand meme, sans etiquette, et candidacyCount la compte, c'est un TROU VISIBLE, pas une ligne ecartee. Les quatre statuts internes de sourcing, eux, ne sortent jamais : ni ici, ni dans le compteur. */
  status?: Maybe<CandidacyStatus>;
};

/** L'operationnel cote client. Peut appartenir a un AUTRE compte du groupe : cas normal, mesure sur un besoin sur huit. Affichage seul : ce n'est jamais un droit d'acces. */
export type NeedContact = {
  __typename?: 'NeedContact';
  /** Le « mailto » de la tuile de la fiche. Nul quand la source ne l'a pas transmis. */
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Notre uuid, jamais un identifiant Salesforce. */
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

/** Fiche d'un besoin : la vue d'ensemble, les candidatures et l'historique. */
export type NeedDetail = {
  __typename?: 'NeedDetail';
  /** Progression du besoin sur l'echelle que son marche impose. Remplace displayStep/stepPosition sur la fiche : ceux-la restent l'echelle de la liste. */
  breadcrumb: NeedBreadcrumb;
  candidacies?: Maybe<Array<NeedCandidacy>>;
  candidacyCount?: Maybe<Scalars['Int']['output']>;
  clientReference?: Maybe<Scalars['String']['output']>;
  /** L'operationnel, meme resolution que dans la liste : la fiche n'est ni plus ni moins large. */
  contact?: Maybe<NeedContact>;
  dailyRate?: Maybe<Scalars['String']['output']>;
  /** Brief du besoin, tel que qualifie par le commercial. */
  description?: Maybe<Scalars['String']['output']>;
  desiredStartDate?: Maybe<Scalars['String']['output']>;
  durationMonths?: Maybe<Scalars['String']['output']>;
  history?: Maybe<Array<NeedEvent>>;
  id?: Maybe<Scalars['ID']['output']>;
  /** L'interlocuteur Freelance.com : la carte « Interlocuteur » de la fiche. Nul quand l'echelle du commercial referent ne resout pas : proprietaire non ingere, desactive ou parti, et aucune designation humaine posee sur le compte. Une absence reste une absence, aucun objet vide, aucun nom de repli. */
  interlocutor?: Maybe<Interlocutor>;
  isPortageCommercial?: Maybe<Scalars['Boolean']['output']>;
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  market?: Maybe<NeedMarket>;
  /** PLAFOND demande par le client, a ne pas confondre avec dailyRate, le prix propose. */
  maxDailyRate?: Maybe<Scalars['String']['output']>;
  minExperience?: Maybe<Scalars['String']['output']>;
  positionsCount?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['String']['output']>;
  /** Reference Freelance.com, STOCKEE et jamais recomposee : la recomposition est fausse sur 17,6 % des lignes. */
  reference?: Maybe<Scalars['String']['output']>;
  remoteAllowed?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** Le « MONTANT ESTIMÉ » de la maquette, celui de la fiche Forfait : Opportunity.Amount, en chaine pour ne pas arrondir un decimal. A ne pas confondre avec dailyRate, agrege depuis les phases : ce sont deux montants voisins a l'ecran et de natures differentes. */
  totalAmount?: Maybe<Scalars['String']['output']>;
  type?: Maybe<NeedType>;
};

/** Etape affichee d'un besoin, derivee du statut Salesforce. */
export enum NeedDisplayStep {
  /** Bascule dans Mon activite : hors liste. */
  Commandee = 'COMMANDEE',
  EnAttenteQualification = 'EN_ATTENTE_QUALIFICATION',
  EnAttenteValidation = 'EN_ATTENTE_VALIDATION',
  PropositionTransmise = 'PROPOSITION_TRANSMISE',
  RechercheEnCours = 'RECHERCHE_EN_COURS',
  Recu = 'RECU',
  ShortlistAValider = 'SHORTLIST_A_VALIDER',
  /** Terminal, hors echelle. */
  SolutionRejetee = 'SOLUTION_REJETEE',
  SolutionValidee = 'SOLUTION_VALIDEE',
  SoutenancePlanifiee = 'SOUTENANCE_PLANIFIEE'
}

/** Evenement de l'historique. Partiel par construction : la table Salesforce des changements de statut n'est pas repliquee, l'historique se construit depuis la mise en service. */
export type NeedEvent = {
  __typename?: 'NeedEvent';
  /** Null quand le changement a ete observe par la synchronisation, pas par une personne. */
  authorName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  occurredAt?: Maybe<Scalars['String']['output']>;
};

/** Un operationnel proposable dans le filtre « Operationnel » de « Mes besoins » : la personne COTE CLIENT qui porte le besoin, jamais le commercial referent de Freelance.com. */
export type NeedFilterContact = {
  __typename?: 'NeedFilterContact';
  /** L'adresse, A COTE du nom et jamais a sa place. Elle sert deux fois : elle identifie la personne quand `name` est vide, et elle departage deux homonymes dans un menu qui peut porter des centaines d'options. */
  email?: Maybe<Scalars['String']['output']>;
  /** NOTRE uuid du contact, celui-la meme qu'on renvoie dans `contactIds`. */
  id: Scalars['ID']['output'];
  /** Prenom et nom. Chaine VIDE quand la source a envoye une adresse sans nom : l'option existe alors sans intitule, et c'est a l'ecran d'ecrire son libelle plutot que de la retirer d'un menu ou elle correspond a des besoins reels. Le service ne fabrique aucun repli. */
  name: Scalars['String']['output'];
};

/** Un marche proposable dans le filtre « Marche » de « Mes besoins » : notre uuid et le nom du CADRE tel que le referentiel le porte. */
export type NeedFilterMarket = {
  __typename?: 'NeedFilterMarket';
  /** NOTRE uuid, celui-la meme qu'on renvoie dans `marketIds`. */
  id: Scalars['ID']['output'];
  /** Le nom du contrat cadre. Chaine VIDE quand le referentiel n'en porte pas : l'option existe alors sans intitule, et c'est a l'ecran de le dire plutot que de la retirer d'un menu ou elle correspond a des besoins reels. */
  name: Scalars['String']['output'];
};

/** Rattachement au marche, en QUATRE etats. Salesforce ne renseigne la cle qu'a la contractualisation : l'absence est le cas normal, pas une exception. */
export type NeedMarket = {
  __typename?: 'NeedMarket';
  /** Hors accord-cadre DECLARE, a distinguer d une absence d information. */
  declaredOutOfFramework?: Maybe<Scalars['Boolean']['output']>;
  /** Seule source d'autorisation. Null sur la quasi-totalite des besoins en cours. */
  id?: Maybe<Scalars['ID']['output']>;
  /** NOM A AFFICHER du marche : celui du marche rattache des qu'il resout, le texte brut de la source seulement a defaut, un besoin peut citer un marche non ingere. Affichage seul, jamais cliquable et jamais un droit d'acces. */
  label?: Maybe<Scalars['String']['output']>;
};

/** Echelle applicable a la fiche d'un besoin, arbitree par le marche. */
export enum NeedProcess {
  /** Parcours client, l'echelle des neuf barreaux. */
  Standard = 'STANDARD',
  /** Processus cadre, la procedure d'achat du marche. */
  Strict = 'STRICT'
}

/** Pas de la procedure d'achat d'un marche a processus cadre. Trois pas et un terminal, la ou NeedDisplayStep en compte neuf : les deux echelles ne viennent pas de la meme source. */
export enum NeedProcessStep {
  /** Terminal, hors echelle. */
  Annule = 'ANNULE',
  /**  Inclut « Commandé » : c'est ce que la specification ecrit, donc un besoin deja commande (et deja bascule dans « Mon activite ») porte ce pas. L'ecart est consigne, pas corrige. */
  PropositionEnAttenteCommande = 'PROPOSITION_EN_ATTENTE_COMMANDE',
  /** Replie huit statuts source, dont les cinq etapes de validation interne (ope, partenaire) : notre circuit, pas l'avancement du client. */
  PropositionEnElaboration = 'PROPOSITION_EN_ELABORATION',
  PropositionValideeBeneficiaire = 'PROPOSITION_VALIDEE_BENEFICIAIRE'
}

/** Type de prestation d'un besoin. A croiser avec isPortageCommercial : AT + portage se lit « RM » a l'ecran. */
export enum NeedType {
  /** Assistance technique. */
  At = 'AT',
  /** AT forfaitisee. */
  Atf = 'ATF',
  Forfait = 'FORFAIT'
}

/** Colonne de tri de la liste des besoins. */
export enum NeedsSort {
  /** Reference client. */
  ClientReference = 'CLIENT_REFERENCE',
  /** Nom du contrat cadre. Les besoins sans accord cadre portent un marche nul : ils partent en fin de liste dans les deux sens plutot que de s'intercaler. */
  Market = 'MARKET',
  /** Nom de l'interlocuteur operationnel COTE CLIENT, celui qui porte le besoin, et non le commercial referent de Freelance.com. */
  Operational = 'OPERATIONAL',
  /** Date de publication. Ordre par defaut, du plus recent au plus ancien. */
  PublishedAt = 'PUBLISHED_AT',
  /** Statut, sur le RANG de l'echelle d'affichage et non sur son code : c'est la progression que la fiche dessine, pas l'alphabet. */
  Status = 'STATUS',
  /** Intitule du besoin. */
  Title = 'TITLE'
}

/** Un bloc de la carte d'une commande d'une prestation. */
export enum OrderColumn {
  LinesTotal = 'LINES_TOTAL',
  OrderedDays = 'ORDERED_DAYS',
  Period = 'PERIOD',
  Progress = 'PROGRESS',
  PurchaseOrderReference = 'PURCHASE_ORDER_REFERENCE',
  RemainingToInvoice = 'REMAINING_TO_INVOICE',
  Resources = 'RESOURCES',
  Status = 'STATUS',
  TotalInvoiced = 'TOTAL_INVOICED',
  WorkedDays = 'WORKED_DAYS'
}

/** Statut affiche d'une commande client, traduit par `service_order_status_mapping`. SIX valeurs fermees par un CHECK, pour SEPT cles source : `Validé` et `VALIDATION` sont le MEME etat. Attention, NUL quand le referentiel ne traduit pas le statut : c'est un trou VISIBLE, et la valeur source ne sort jamais du schema. Attention, L'ORDRE N'EST PAS UN CONTRAT et les libelles francais appartiennent a l'ecran. */
export enum OrderDisplayStatus {
  /**
   * Annulé : 867. Attention, C'EST LA SEULE DEFINITION D'UNE COMMANDE ANNULEE depuis PCG-146, la ou un motif textuel la tenait.
   *
   * Attention, PLUS AUCUNE COMMANDE PORTANT CETTE VALEUR N'EST SERVIE depuis PCG-149 : `serviceOrders` la retranche, et `Service.totalOrdered` la retranchait deja. Elle reste dans l'enumeration parce que celle-ci decrit le REFERENTIEL, qui les traduit toujours, et non ce que telle requete rend ; elle est en revanche INATTEIGNABLE par `ServiceOrder.displayStatus`, dont c'est le seul cas.
   */
  Annule = 'ANNULE',
  /** Brouillon : 102. Attention, TRADUIRE N'EST PAS EXCLURE : le brouillon reste COMPTE dans « Total commandé », et c'est mesure : le retrancher ferait tomber la concordance avec le total de Salesforce de 100 % a 99,3 % (PCG-115). */
  Brouillon = 'BROUILLON',
  /** Commandé : 5 461. Attention, A NE PAS CONFONDRE avec la valeur homonyme de `ServiceDisplayStatus`, qui qualifie une PRESTATION. */
  Commande = 'COMMANDE',
  /** Partiellement facturé : 25 520. */
  PartiellementFacture = 'PARTIELLEMENT_FACTURE',
  /** Totalement facturé : 35 473 commandes, le cas le plus frequent. */
  TotalementFacture = 'TOTALEMENT_FACTURE',
  /**
   * Validé : 809 commandes, et c'est LA LIGNE QUI JUSTIFIE LE REFERENTIEL. La source porte DEUX cles pour cet etat, `Validé` (541) et `VALIDATION` (268), aucune regle ne mene de l'une a l'autre, et le produit a tranche qu'il s'agit du MEME etat.
   *
   * Attention, CE LIBELLE NE PREDIT PAS LA PERIODE, et c'est la mesure qui le dit plutot que l'intuition. « Une commande validee n'est pas encore commandee, donc elle n'a pas de periode » est vrai de la premiere cle et FAUX de la seconde : `Validé` est sans date de debut sur 539 de ses 541 lignes (99,6 %), `VALIDATION` sur ZERO de ses 268. Sous le libelle fusionne cela fait 539 sur 809, soit 66,6 %, et la cle qui departage NE SORT PAS DU SCHEMA. Un ecran qui deduirait l'absence de periode de ce statut se tromperait une fois sur trois : c'est `startDate` et `endDate` qu'il faut lire, jamais ce libelle.
   */
  Valide = 'VALIDE'
}

export type Organization = {
  __typename?: 'Organization';
  id?: Maybe<Scalars['ID']['output']>;
  kind?: Maybe<OrganizationKind>;
  /** Ce compte exige le MFA de ses utilisateurs (PCG-303). Expose ici pour que l'ecran puisse NOMMER le compte qui l'exige : « votre acces a ACME demande une double authentification » se lit, « votre acces demande » laisse chercher lequel. L'exigence effective d'une personne se lit sur `viewer.mfaRequired`, jamais en repliant cette liste soi-meme. */
  mfaRequired?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  portalEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** Place d'une organisation dans l'arbre du portail. */
export enum OrganizationKind {
  /** Un compte client, ou un noeud de son arbre. */
  Client = 'CLIENT',
  /** Freelance.com elle-meme. */
  Internal = 'INTERNAL'
}

/** Ce que l'ENREGISTREMENT d'une demande rend. Attention, RIEN N'A ETE ENVOYE (RG-PAR-14) : un CRON quotidien regroupera les demandes par commercial, et ce CRON n'existe pas encore. Une confirmation au present serait une phrase sur un fait qui n'a pas eu lieu. */
export type PartnerContactRequestRecorded = {
  __typename?: 'PartnerContactRequestRecorded';
  /** Le compte retenu, a reprendre dans la confirmation : c'est lui qui decide du commercial. */
  accountName: Scalars['String']['output'];
  /** Le partenaire tel que le lecteur le nomme : sa reference, JAMAIS son nom. Une liste anonyme ne doit pas apprendre le nom par la confirmation de sa propre demande. */
  publicReference: Scalars['String']['output'];
  requestedAt: Scalars['String']['output'];
};

/** Nature du porteur d'une prestation, telle que la liste l'affiche. */
export enum PartnerKind {
  /** Independant, en direct. */
  Freelance = 'FREELANCE',
  /** Societe de prestation. */
  Partner = 'PARTNER',
  /** Salarie porte. AIGUILLAGE d'affichage : il l'emporte sur les deux autres, quel que soit le type de base. */
  Portage = 'PORTAGE',
  /**
   * Rien a lire pour trancher : aucune ressource rattachee, ou une ressource dont le partenaire ne porte pas de type de structure. Une ABSENCE, jamais une quatrieme nature, et surtout pas un repli silencieux vers FREELANCE ou PARTNER.
   *
   * Attention, LA SOURCE DE CETTE NATURE A CHANGE (PCG-232) : elle se lisait sur `Est_Freelance__c`, elle se lit desormais sur le TYPE DE STRUCTURE du partenaire. Le booleen est repliqué a tort, 1 093 vrais au miroir contre 7 009 ressources dont le partenaire est de structure « Freelance », donc 203 independants sur 276 s'affichaient « Partenaire » sur notre perimetre. Le booleen est un sous-ensemble STRICT de la structure, jamais un faux positif, et la structure est la verite terrain que la spec utilise elle-meme pour le juger. HYPOTHESE A CONFIRMER, voir `FREELANCE_STRUCTURE_TYPE`.
   */
  Unknown = 'UNKNOWN'
}

/** Le detail d'une liste : son en-tete, ses partenaires et ses porteurs. */
export type PartnerListDetail = {
  __typename?: 'PartnerListDetail';
  archivedAt?: Maybe<Scalars['String']['output']>;
  holderCount: Scalars['Int']['output'];
  /** Les porteurs, jamais filtres par la recherche du bloc des partenaires. */
  holders: Array<PartnerListHolder>;
  id: Scalars['ID']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Le compteur de l'en-tete : la liste ENTIERE, eligibles seulement, et il **ignore la recherche**. `partners` est ce que la recherche retient. Deux champs pour deux faits : sans quoi le compteur et les lignes se contrediraient des la premiere frappe. */
  partnerCount: Scalars['Int']['output'];
  /** Les membres eligibles retenus par `search`, non bornes. Le filtrage est COTE SERVEUR, ce qui est ce qui autorise l'absence de pager : la reponse est l'ensemble retenu et non une tranche. Le plafond theorique est le nombre d'eligibles, une liste declaree en cochant tout les portant tous. */
  partners: Array<PartnerRow>;
};

/** Une liste de partenaires vue de son ADMINISTRATEUR. Referentiel de PLATEFORME : aucun `organization_id`, parce que son contenu n'isole rien. */
export type PartnerListEntry = {
  __typename?: 'PartnerListEntry';
  /** Non nul des que la liste est retiree du catalogue. Le nom reste RESERVE apres archivage : `partner_list.name` porte un unique PLEIN, contrairement au tableau de bord dont l'unicite est partielle sur le vivant. */
  archivedAt?: Maybe<Scalars['String']['output']>;
  /** Combien de personnes tiennent cette liste. Non nul, l'archivage est REFUSE (RG-PTN-08) : le detachement se fait depuis la fiche de la personne, jamais depuis cet ecran, qui ne fait que compter. */
  holderCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Vrai : le client ne voit que `PTN-XXXX`, modale comprise. Faux : il voit la raison sociale. Choisi a la declaration, modifiable a tout moment par `setPartnerListAnonymity` (RG-PTN-05). **LE BACK-OFFICE VOIT TOUJOURS LE NOM**, quelle que soit sa valeur. */
  isAnonymous: Scalars['Boolean']['output'];
  /** SON NOM EST LE THEME : aucune source ne porte l'expertise, pourtant axe de recherche n°1 du portail. Regle de gouvernance qu'aucune contrainte ne tient, un nom est partage par tous les clients et n'en nomme jamais un. */
  name: Scalars['String']['output'];
  /** Le nombre de partenaires ELIGIBLES de la liste, calcule a la lecture. **Ce n'est pas le nombre de lignes de rattachement**, et l'ecart est le sujet : un membre devenu radie ou « contacter le channel » quitte l'affichage sans que sa ligne soit supprimee (RG-PTN-03), donc le compter ferait annoncer « 12 partenaires » au-dessus de onze lignes. Il ignore la recherche du detail. */
  partnerCount: Scalars['Int']['output'];
};

/** Une personne du portail qui tient cette liste. Le rattachement se fait a l'onboarding depuis la fiche de la personne (RG-PTN-04) : cet ecran ne fait que compter et nommer. */
export type PartnerListHolder = {
  __typename?: 'PartnerListHolder';
  /** Les comptes clients de la personne, au PLURIEL. La maquette n'a qu'une cellule « Compte », mais une personne peut porter plusieurs rattachements sous une meme societe : en rendre un seul nommerait un compte au hasard. Un element est le cas ordinaire, zero veut dire qu'elle n'a aucun rattachement. */
  accountNames: Array<Scalars['String']['output']>;
  /** Ce qui identifie la personne quand son nom manque : l'ecran a toujours quelque chose a ecrire. */
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  /** `Contact.A_quitte_la_societe__c` de la source. **NUL EST UN TROISIEME ETAT** : aucun contact ingere n'est lie a cette personne, donc la source ne dit rien, ce qui est le cas de qui a ete onboarde avant que ce lien ne soit ecrit. Rendu faux, il affirmerait qu'elle est toujours en poste. Une personne partie **compte toujours** comme porteuse et bloque donc l'archivage tant qu'elle n'est pas detachee. */
  hasLeftCompany?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

/** Un partenaire eligible, tel que le back-office le montre : dans le selecteur des deux modales comme dans le bloc « Partenaires » du detail. Meme forme des deux cotes, parce que c'est le meme objet. */
export type PartnerRow = {
  __typename?: 'PartnerRow';
  /** `External_ID__c`, format `CPT-0000029655`, la cle de rapprochement reprise dans le courriel au commercial. Nullable par prudence de contrat : mesuree a 100 % le 2026-08-26. */
  externalReference?: Maybe<Scalars['String']['output']>;
  /** La raison sociale, remplie a 100 %. Visible au back-office meme sur une liste anonyme. */
  name: Scalars['String']['output'];
  /** `PTN-XXXX`, emis par NOUS, unique et jamais reattribue (RG-PTN-07) : le meme partenaire porte le meme identifiant dans toutes les listes, et le garde quand on le retire. **Ecart assume avec la regle** : elle le veut emis « a la premiere apparition dans une liste », il est en fait pose des l'ingestion par un DEFAUT en base. Personne n'observe le moment, et rien ne se deduit du numero. */
  publicReference: Scalars['String']['output'];
  /** `Segment__c` verbatim, d'ou se lit le tag Gold / Blue (RG-PTN-12) et rien d'autre : ni statut, ni description, qui ne sont ni saisis ni affiches. **A ne pas confondre avec `network_tier`**, une autre picklist dont le medaillon ne se derive pas. Rare : 7,4 % des eligibles portent Gold ou Blue. */
  segment?: Maybe<Scalars['String']['output']>;
  /** Notre uuid, la cle a renvoyer aux mutations. Jamais l'`Account.Id` Salesforce. */
  sourcePartnerId: Scalars['ID']['output'];
};

/** Les cles de tri. **Il en manque une des six colonnes de RG-PAR-05**, et le motif a change le 2026-08-27 : `EXPERTISES` est desormais SERVIE (`purePlayerExpertise`, `strongExpertise`, et le filtre) mais elle n'est toujours pas TRIABLE, parce qu'un partenaire en porte 0..n et qu'il n'existe aucun ordre defini sur un ensemble. Trier sur la premiere par ordre alphabetique serait un ordre invente, que rien a l'ecran n'expliquerait. Ce n'est plus « la donnee manque » : la formulation precedente le disait, et elle enverrait chercher un manque deja comble. */
export enum PartnerSortKey {
  Certifications = 'CERTIFICATIONS',
  City = 'CITY',
  InterventionMode = 'INTERVENTION_MODE',
  Partner = 'PARTNER',
  Partnerships = 'PARTNERSHIPS'
}

/** Un droit du referentiel des autorisations, tel que l'ecran du back-office le presente. */
export type Permission = {
  __typename?: 'Permission';
  code?: Maybe<Scalars['ID']['output']>;
  /** Precision affichee sous le droit (« CRA, PV, candidatures »...). */
  description?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<PermissionDomain>;
  label?: Maybe<Scalars['String']['output']>;
  /** Le module de `portalModules` auquel le droit appartient : l'axe par ECRAN, celui de la maquette du back-office. NULL sur les cinq droits d'administration, et sur eux seuls : ils ne pendent a aucun module du portail, et c'est une lacune de la maquette et non du referentiel. Un droit de module reste accorde et SANS EFFET la ou le module n'est pas actif sur le compte : la conjonction « droit ∧ module actif » se calcule au moment de l'acte. */
  module?: Maybe<Scalars['String']['output']>;
  /** Le droit dont celui-ci depend : une action implique la consultation du MEME module, et le telechargement de masse implique l'unitaire. NULL quand le droit ne depend de rien. C'est le referentiel qui porte la dependance, pour qu'un ecran n'ait pas a la recopier : la maquette la code en dur dans une constante `SEE_OF`, et une seconde ecriture de la regle est celle qui derive. La base la GARANTIT de son cote, par cle etrangere. */
  requiresPermissionCode?: Maybe<Scalars['String']['output']>;
};

/** Famille d'affichage d'un droit : l'axe par CAPACITE. Il n'est plus le seul depuis PCG-99, `Permission.module` porte l'axe par ECRAN, celui de la maquette du back-office, et la divergence que cette description annoncait est fermee : `view_content` etait un seul droit pour tout ce qui se consulte, il y en a six. Les deux axes coexistent parce que la maquette ne montre que le portail client et ne nomme donc pas les cinq droits d'administration, dont ce domaine est le seul rangement. */
export enum PermissionDomain {
  ActAndValidate = 'ACT_AND_VALIDATE',
  Admin = 'ADMIN',
  Oversight = 'OVERSIGHT',
  ViewAndShare = 'VIEW_AND_SHARE'
}

/** Une colonne du tableau des activites d'une prestation. */
export enum PhaseColumn {
  DailyRate = 'DAILY_RATE',
  Type = 'TYPE',
  WorkedDays = 'WORKED_DAYS'
}

/**
 * Une entree du referentiel des modules du portail : les six entrees du menu de la maquette V2, moins « Accueil » qui n'est pas un module mais la page d'entree.
 *
 *  **Le type dit l'OBJET, la requete dit le SOUS-ENSEMBLE.** `portalModules` rend le referentiel entier, `myModules` les seules entrees ouvertes a la personne. Un ecran qui construit un menu lit la seconde ; un ecran qui classe quelque chose PAR module (la matrice des droits) lit la premiere, et se tromper de requete produit une liste qui se raccourcit selon celui qui la regarde.
 */
export type PortalModule = {
  __typename?: 'PortalModule';
  /** Code technique, stable : c'est lui que le front associe a une route. */
  code: Scalars['ID']['output'];
  /**
   * Le module a-t-il un ecran. Faux sur les quatre entrees du menu qui n'en ont pas encore.
   *
   *  **Un fait de la PLATEFORME, jamais d'un compte** : vrai ou faux partout a la fois, et il ne dit RIEN de l'activation, c'est `accountModules.enabled` qui la porte, compte par compte.
   *
   *  **Il ANNOTE, il ne refuse pas, et c'est ce qui le distingue de `activatable`.** Accorder un droit sur un module non livre est legitime : un role est durable et commun a tous les comptes, rien ne le refuse, et le jour ou le lot livre l'ecran il n'y a rien a reprendre. Ce que ce champ evite est l'inverse, une matrice ou « Factures » se coche exactement comme « Mes besoins » alors qu'aucun droit de ce groupe ne peut prendre effet nulle part. Griser la case serait donc une erreur : la formulation juste qualifie le GROUPE.
   */
  delivered: Scalars['Boolean']['output'];
  /** Libelle de l'entree de menu, tel que la maquette V2 l'ecrit. Il vient du referentiel : un ecran qui traduit un code en libelle par une table a lui en tiendrait une seconde, et c'est la seconde qui divergera au premier module ajoute. */
  label: Scalars['String']['output'];
  /** Ordre du menu. Unique au referentiel : deux modules au meme rang rendraient l'ordre instable d'une requete a l'autre. Il n'est PAS contigu (20, 30, 40, 50, 60, 70), les rangs sont espaces de dix pour qu'un module s'intercale sans reecrire les autres. C'est un ordre, jamais un indice. */
  sortOrder: Scalars['Int']['output'];
};

/** Un partenaire tel que le CLIENT le voit. Six colonnes au tableau (RG-PAR-05), dont une, les expertises, n'a AUCUNE SOURCE : le referentiel Expertises de Salesforce n'est pas replique au miroir (Q-PAR-02). Elle n'est donc pas un champ nul de ce type, elle est absente : un champ toujours vide se lit comme un partenaire sans expertise, ce qui est une affirmation fausse sur le partenaire. */
export type PortalPartner = {
  __typename?: 'PortalPartner';
  /** `BillingCity`, la ville du SIEGE, 85,3 % rempli. **Ce n'est pas la couverture geographique** (ou le partenaire intervient), qui n'est pas repliquee : `Couverture_Departementale__c` s'en approche a 84,9 % et n'est pas ingere, une approximation rendue sous le libelle de ce qu'elle approche etant une valeur fausse. */
  billingCity?: Maybe<Scalars['String']['output']>;
  /** `Mode_d_intervention__c` verbatim. Mesure du 2026-08-26 sur les 4 444 eligibles : 50,6 % rempli (AT/Forfait 1 247, AT 767, Forfait 230, CDS 3). **La cellule reste VIDE quand il est nul** (RG-PAR-06) : une valeur par defaut affirmerait un mode de prestation que le partenaire n'a pas declare. */
  interventionMode?: Maybe<Scalars['String']['output']>;
  /** `Gold Partner` ou `Blue Partner`, et RIEN D'AUTRE (RG-PAR-04). `Segment__c` porte huit valeurs dont « Prise de contact » sur 80,9 % du parc : elles sont des statuts INTERNES, le CR du 20/08 a retire la colonne qui les montrait, et le tri se fait cote serveur parce qu'un statut interne qui atteint le navigateur est un statut interne publie. Mesure du 2026-08-26 sur les eligibles : Gold 98, Blue 231, soit 7,4 % a eux deux. Nul est donc le cas ordinaire, et il n'affiche NI medaillon gris NI mention « non classe ». */
  medallion?: Maybe<Scalars['String']['output']>;
  /** La raison sociale. **NUL SUR UNE LISTE ANONYME**, et il ne s'agit pas d'un trou de donnee : `Account.Name` est rempli a 100 %. Le nom n'est pas efface au retour, il n'est jamais lu : la vue interrogee ne le porte pas (RG-PAR-03). */
  name?: Maybe<Scalars['String']['output']>;
  /** `PTN-XXXX`, emis par NOUS, unique et jamais reattribue. **C'est ce que le client lit sur une liste anonyme**, et il reste rendu sur une liste nominative : le rapprochement avec Freelance.com se fait par lui au telephone. */
  publicReference: Scalars['String']['output'];
  /**
   * Les domaines ou le partenaire est PURE PLAYER, par ordre alphabetique. C'est le niveau le plus fort des quatre du referentiel, et la maquette les met EN TETE de la colonne, en etiquette pleine etoilee.
   *
   *  Attention, **« LE domaine pure player » AU SINGULIER EST FAUX** : mediane 2, maximum 4, et seuls 38,7 % des partenaires qui en portent n'en ont qu'un (mesure du 2026-08-27 sur les 4 444 eligibles). 1 973 partenaires (44,4 %) en portent au moins un.
   *
   *  Attention, **L'ECHELLE DE LA SOURCE EST INVERSEE PAR RAPPORT A L'ORDRE DE RG-PTN-14** : le degre `4` est Pure player et le `3` Expertise forte, etabli sur la verite terrain que la spec donne elle-meme (DB&M PARTNERS, « Pure player (2) » et « Expertise forte (13) »). La traduction vit dans la vue `partner_expertise`, une seule fois : ne pas la refaire ailleurs.
   */
  purePlayerExpertise: Array<Scalars['String']['output']>;
  /** Notre uuid, la cle a renvoyer a `requestPartnerContact`. Jamais l'`Account.Id` Salesforce. */
  sourcePartnerId: Scalars['ID']['output'];
  /**
   * Les expertises FORTES, par ordre alphabetique. Le second des deux niveaux que le portail exploite (RG-PTN-14) ; « Expertise confirmee » et « Expertise annexe » ne sont JAMAIS lues, ni ici, ni dans le filtre, ni dans la modale.
   *
   *  **Les deux listes sont VIDES pour un partenaire sur deux** : 50,7 % des eligibles ne portent rien aux deux niveaux exploites. C'est l'etat ORDINAIRE, que RG-PTN-14 predit, donc l'ecran l'ecrit plutot que de laisser une cellule blanche.
   *
   *  Ce qui n'est PAS rendu : une expertise radiee (`chn_radie__c`, 42 cas parmi les exploites) et une expertise disparue de la source. Les deux sortent de la vue.
   */
  strongExpertise: Array<Scalars['String']['output']>;
  /** `Certifications_techniques__c`, decoupe sur les SAUTS DE LIGNE et sur rien d'autre. Le champ est du texte libre : sur les 292 valeurs des eligibles, 212 usent du saut de ligne, 33 de la virgule, 3 du point-virgule. **La virgule ne peut pas servir de separateur** : « ISTQB (fondation, manager, Safe), IQBBA » en contient trois a l'interieur d'une seule valeur, et decouper dessus inventerait « fondation » comme certification. Une valeur qui separe autrement rend donc UNE etiquette longue au lieu de plusieurs : une etiquette trop longue se lit, une etiquette inventee se croit. Mediane 4 lignes, maximum 133. */
  technicalCertifications: Array<Scalars['String']['output']>;
  /** `Partenariats_technologiques__c`, meme decoupage et meme raison. 289 valeurs sur les eligibles (6,5 %), mediane 2 lignes, maximum 38. */
  technologyPartnerships: Array<Scalars['String']['output']>;
};

/** Un compte de la personne sur ce module. C'est le referentiel du choix de compte de la modale de mise en relation (RG-PAR-11), et il ne suit aucun filtre : un compte sans partenaire y figure. */
export type PortalPartnerAccount = {
  __typename?: 'PortalPartnerAccount';
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
};

/** Une personne du portail et ses rattachements, bornes aux comptes accessibles a l'acteur. Alimente la fiche utilisateur du back-office. */
export type PortalUser = {
  __typename?: 'PortalUser';
  /** Consommation du lien d'activation, qui verifie l'e-mail. */
  activatedAt?: Maybe<Scalars['String']['output']>;
  disabledAt?: Maybe<Scalars['String']['output']>;
  disabledReason?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Ancrages de la PERSONNE chez les emetteurs, via les contacts dont elle a ete onboardee. Porte par la personne et non par le rattachement. Vide quand elle a ete creee a la main. */
  externalReferences?: Maybe<Array<ExternalRef>>;
  firstName?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  /** Fin de validite du lien, seulement tant qu'une invitation est en cours. */
  invitationExpiresAt?: Maybe<Scalars['String']['output']>;
  /** Nombre d'envois de cette invitation. Nul quand il n'y en a aucune. */
  invitationSentCount?: Maybe<Scalars['Int']['output']>;
  /** Derniere invitation ENVOYEE, relances comprises. */
  invitedAt?: Maybe<Scalars['String']['output']>;
  /** Dernier PASSAGE authentifie, tous comptes confondus : on se connecte en tant que personne. Attention, ce n'est pas l'evenement de connexion (cette API voit une requete portant un jeton valide, jamais l'authentification) et il n'est repose qu'au-dela d'une heure : a libeller « derniere activite ». Nul = jamais passee. */
  lastLoginAt?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Rattachements visibles par l'acteur, jamais toute l'histoire de la personne : agreger ne doit pas elargir. */
  memberships?: Maybe<Array<PortalUserMembership>>;
  /**
   * Ce que LE POOL porte comme second facteur pour cette personne, lu a la demande (PCG-303).
   *
   * **L'ETAT SE LIT, IL NE SE STOCKE PAS.** C'est une propriete vivante du pool : elle change sans nous, donc une colonne qui la porterait se tromperait en silence. Ce que nous stockons est l'EVENEMENT, `mfaEnabledAt`, que le pool ne sait pas dire.
   *
   * **`null` veut dire « le pool n'a pas repondu », et JAMAIS « aucun facteur ».** Personne absente du pool, requete en echec, inside-api indisponible : dans les trois cas l'ecran doit ecrire « etat non lu » et non « aucune », sans quoi il rapporte une non-conformite sur quelqu'un dont le pool n'a peut-etre jamais entendu parler. Une liste `factors` VIDE, elle, est une reponse : rien n'est enregistre.
   *
   * **Le vocabulaire du pool est rendu tel quel** (`SOFTWARE_TOKEN_MFA`, `SMS_MFA`, `EMAIL_OTP`) et non replie sur une enumeration a nous : la replier perdrait en silence une valeur le jour ou le pool en ajoute une, ce que ce depot a deja paye en recopiant la picklist d'une source qu'il ne possede pas.
   *
   * Un appel a inside-api par lecture. C'est le prix de la verite sur l'ecran ou la question se pose, et c'est pourquoi la LISTE des utilisateurs ne le porte pas.
   */
  mfa?: Maybe<MfaState>;
  /** Quand le portail a vu un facteur pour la PREMIERE fois. Nulle quand il n'y en a aucun. Ne se rafraichit pas a chaque changement de methode : ce qu'une lecture 27001 cherche est le moment de la mise en conformite. */
  mfaEnabledAt?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

/** Un rattachement de la personne : le compte, et ce qu'elle y porte. Role, statut et perimetre appartiennent au couple (personne x compte), jamais a la personne. */
export type PortalUserMembership = {
  __typename?: 'PortalUserMembership';
  /** Creation du rattachement : le moment ou la personne y a ete invitee. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /**
   * Les tableaux de bord detenus SUR CE COMPTE. Ils sont ici et non sur la personne parce qu'une habilitation pend d'un RATTACHEMENT (§3.4) : quelqu'un rattache a trois comptes peut en detenir trois distinctes, et « ce tableau de bord » ecrit sur une fiche par personne cacherait le compte au titre duquel il est accorde, celui que cet objet nomme deja.
   *
   * Vide est le cas ORDINAIRE : le catalogue est une liste blanche saisie a la main, et un compte sans entree n'accorde rien.
   *
   *  Une entree ARCHIVEE depuis l'octroi reste dans cette liste, avec son `blockedReason` : la ligne survit volontairement (elle est ce qui repond a « qui l'avait ») et la masquer repondrait « on ne vous l'a jamais accordee » a quelqu'un qui demande pourquoi son tableau de bord ne s'ouvre plus.
   */
  dashboards: Array<GrantedDashboard>;
  dataScope?: Maybe<DataScope>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Entree effective de la personne sur ce compte. */
  joinedAt?: Maybe<Scalars['String']['output']>;
  membershipId?: Maybe<Scalars['ID']['output']>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  /** Date de la DERNIERE fermeture. Elle n'est PAS effacee a la reouverture, donc elle est renseignee sur des rattachements aujourd'hui VIVANTS : elle date un evenement passe, elle ne decrit pas l'etat courant. C'est `status` qui dit si l'acces est ouvert, et l'afficher sans le lire d'abord annonce une fermeture qui a ete defaite. */
  revokedAt?: Maybe<Scalars['String']['output']>;
  /** Qui a decide cette derniere fermeture : le nom si on l'a, l'adresse sinon. Nul lorsque le compte de l'auteur a depuis ete supprime : la cle etrangere est `ON DELETE SET NULL`, la fermeture survit donc a son auteur. */
  revokedBy?: Maybe<Scalars['String']['output']>;
  /**
   * Motif de la derniere fermeture, a lire AVANT de rouvrir : sans lui le back-office rouvrirait a l'aveugle un acces que quelqu'un avait ferme pour une raison (§1.8, decision 4).
   *
   * Il est lu dans `activity_log`, ou la trace le depose ; aucune colonne ne le porte sur `membership`, et c'est un report assume tant qu'aucun ecran ne demande de TRIER par motif (§1.9, toujours ouvert).
   *
   *  Nul recouvre deux cas qui se ressemblent et sont tous deux honnetes : la fermeture n'a enonce aucun motif (l'argument de `revokeMembership` est facultatif) ou il n'y a jamais eu de fermeture. `revokedAt` les separe.
   *
   *  Meme avertissement que `revokedAt` : il decrit la derniere fermeture, pas l'etat courant.
   */
  revokedReason?: Maybe<Scalars['String']['output']>;
  roleCode?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['ID']['output']>;
  roleName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MembershipDisplayStatus>;
  /**
   * PCG-305. Les activites retenues, NOMMEES, en APERCU : vingt au plus par rattachement. Une personne peut en voir des centaines, et une fiche n'a pas a les derouler toutes ; `visibleNeedCount` et `visibleServiceCount` restent les nombres justes.
   *
   * Vide sur une portee ALL, ou il n'y a pas de restriction a detailler.
   */
  visibleActivities: Array<VisibleActivity>;
  /**
   * PCG-305. Combien de BESOINS un perimetre restreint retient. Zero sur une portee ALL : l'absence de restriction n'est pas une restriction vide.
   *
   * Attention, `visibleMarkets` N'EST PLUS LE PERIMETRE et restera vide : on coche desormais des ACTIVITES, et la table des marches n'a plus d'ecrivain. Une fiche qui compterait ce tableau ecrirait « restreint a 0 marches » sur un perimetre parfaitement rempli.
   */
  visibleNeedCount: Scalars['Int']['output'];
  /** PCG-305. Combien de PRESTATIONS un perimetre restreint retient. Meme regle. */
  visibleServiceCount: Scalars['Int']['output'];
};

export type PortfolioAssignment = {
  __typename?: 'PortfolioAssignment';
  kind?: Maybe<PortfolioKind>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
};

export type PortfolioEntryInput = {
  kind: PortfolioKind;
  organizationId: Scalars['ID']['input'];
};

/** Nature d'un rattachement de collaborateur interne a un compte. */
export enum PortfolioKind {
  AccountManager = 'ACCOUNT_MANAGER',
  Support = 'SUPPORT'
}

export type Query = {
  __typename?: 'Query';
  /**
   * Comptes sur lesquels l'acteur peut agir. Alimente le filtre par compte de l'ecran des utilisateurs, et c'est la MEME fonction qui borne accountUsers : le filtre ne peut donc pas proposer un compte que la liste refuserait.
   *
   * La liste n'est PAS filtree par `kind` : un administrateur back-office qui gere des collaborateurs internes a besoin de Freelance.com autant que des comptes clients. Un ecran qui n'onboarde que des clients ecarte lui-meme `INTERNAL`, et regroupe par `rootOrganizationId`, une personne cote client n'appartenant qu'a une seule racine.
   */
  accessibleAccounts?: Maybe<Array<AccessibleAccount>>;
  /**
   * Les activites d'un compte, cochables une par une a l'etape « Perimetre » de l'onboarding, et PRE-COCHEES pour l'adresse saisie a l'etape 1.
   *
   * Attention, ON COCHAIT DES MARCHES JUSQU'A PCG-305, et c'est ce qui a change. La branche restreinte des vues joignait sur le marche : une activite qui n'en porte aucun ne correspondait a rien et SORTAIT DE LA LISTE EN SILENCE. 16 % des besoins et 27 % des prestations sont dans ce cas. C'est ce silence qui avait fait naitre le refus d'un perimetre restreint sur les comptes ou « Mes besoins » ou « Mon activite » etait ouvert ; ce refus est retire par le meme lot, sa cause ayant disparu.
   *
   * Les prestations sortent GROUPEES par marche parce que cocher un marche entier est le geste courant, mais ce que l'appelant enregistre est la liste des PRESTATIONS. Les besoins sortent a plat.
   *
   * Une adresse VIDE n'est pas une erreur : l'ecran s'ouvre avant qu'elle soit saisie, la liste sort entiere et rien n'est pre-coche.
   *
   * Les lignes DESIGNEES PAR LA SOURCE sortent en premier, avant le tri par nom : ce sont celles que l'operateur vient verifier, et les chercher dans un tri alphabetique de 741 lignes est le geste qu'on lui epargne.
   *
   * Refus : MISSING_PERMISSION, FORBIDDEN_OUT_OF_SCOPE, les memes que `suggestedMarkets` et par le meme appel, pour que les deux lectures de cette etape refusent identiquement.
   */
  accountActivities: AccountActivities;
  /** Marches accessibles a un compte, avant toute restriction personnelle. Alimente le choix « Contrat(s) / marche(s) visibles » de M12-04. */
  accountMarkets?: Maybe<Array<Market>>;
  /**
   * Les modules d'un compte, vus du back-office : TOUT le referentiel, chaque ligne portant son etat.
   *
   * Reserve au **back-office**, la portee du role est verifiee AVANT la permission, un role portail sur mesure pouvant porter `manage_accounts` et un compte se configurerait lui-meme. Meme droit et meme perimetre que l'ouverture du compte : `manage_accounts`.
   *
   * Refus possibles : NOT_AUTHENTICATED, INTERNAL_STAFF_ONLY, MISSING_PERMISSION, FORBIDDEN_OUT_OF_SCOPE, ORGANIZATION_NOT_FOUND, INTERNAL_ORGANIZATION_NOT_ALLOWED.
   */
  accountModules?: Maybe<Array<AccountModule>>;
  /** Utilisateurs d'un compte, ou de tous les comptes accessibles a l'acteur quand organizationId est absent. UNE LIGNE PAR PERSONNE. Ecran M12-04. */
  accountUsers?: Maybe<AccountUsersPage>;
  /**
   * LA LISTE DES COMPTES DU BACK-OFFICE (PCG-141) : une table a plat, cherchee, paginee, comptee, chaque ligne portant trois compteurs de configuration.
   *
   *  A NE PAS CONFONDRE AVEC `accessibleAccounts`, et aucune des deux ne remplace l'autre. Celle-la rend un PERIMETRE (« sur quoi cet acteur peut-il agir ») non pagine et non cherche parce qu'un selecteur a besoin de l'ensemble d'un coup ; le parcours d'onboarding en depend. Celle-ci est une LISTE QU'UN OPERATEUR LIT : 7 583 comptes au parc, donc elle pagine et elle cherche. Les deux se bornent a la MEME fonction, `listAccessibleAccounts`, qui reste la porte unique de la question du perimetre.
   *
   *  L'ORGANISATION INTERNE EN EST EXCLUE, et elle reste dans `accessibleAccounts`. Freelance.com n'est pas un compte client : `resolveAccountForGesture` la refuse (INTERNAL_ORGANIZATION_NOT_ALLOWED), et TOUS les gestes vers lesquels cette liste conduit (ouvrir le portail, activer un module, declarer un tableau de bord) passent par lui. Une ligne sur laquelle tout l'ecran refuse ne fait qu'egarer. Le perimetre, lui, doit la garder : un administrateur back-office y administre ses collegues internes.
   *
   *  CE QU'ELLE NE CACHE PAS, mesure a zero aujourd'hui sur la base de dev comme sur le jeu de volume : un compte disparu de la source (`vanished_at`) reste en liste, une disparition se traite comme une fuite, et masquer la ligne retirerait le compte qu'il faut justement voir pour le fermer ; `organization.archived_at` n'a AUCUN lecteur dans ce module, et lui en inventer un ici serait une decision prise de biais.
   *
   * Droit : `manage_accounts`, celui des gestes de l'ecran, et une portee de role BACK-OFFICE.
   */
  accounts?: Maybe<AccountsPage>;
  /**
   * Etape 3 du parcours d'onboarding : les tableaux de bord attribuables. Bornes par `listAccessibleAccounts`, LA MEME fonction qui borne `accessibleAccounts`, le choix de l'etape 3 ne peut donc pas proposer un compte que l'etape 2 refuserait.
   *
   * `organizationIds` restreint aux comptes selectionnes a l'etape 2, et il faut s'en servir : un tableau de bord dont le compte n'est pas dans la selection est refuse par `inviteUser` a la DERNIERE etape, une fois role et perimetre composes. Un identifiant hors perimetre est REFUSE et non ecarte en silence, l'ecarter repondrait « ce compte n'a pas de tableau de bord » a une question qui etait « vous n'avez pas le droit de regarder la ».
   *
   * Le droit avant le perimetre, comme partout ailleurs : `manage_users`, parce qu'attribuer un tableau de bord est un acte d'administration des utilisateurs, la meme garde que `accountMarkets` pose sur le choix du perimetre du meme parcours.
   *
   * Refus : NOT_AUTHENTICATED, MISSING_PERMISSION, FORBIDDEN_OUT_OF_SCOPE.
   */
  assignableDashboards?: Maybe<AssignableDashboards>;
  /**
   * Etape 4 du parcours d'onboarding : les listes de partenaires attribuables. Le catalogue est GLOBAL et ne porte aucun `organization_id`, il n'isole rien, parce que son contenu n'isole rien : « Partenaires IA » veut dire la meme chose pour tout le monde. Il n'y a donc pas de perimetre a lui appliquer, et ce n'est pas un oubli.
   *
   * Le cloisonnement tient ailleurs et il tient : une personne appartient a un seul client, donc une habilitation posee sur la personne ne peut pas traverser deux clients. Ce qui borne cette requete est le DROIT, `manage_users`, celui que le parcours exige deja.
   *
   * Refus : NOT_AUTHENTICATED, MISSING_PERMISSION.
   */
  assignablePartnerLists?: Maybe<AssignablePartnerLists>;
  /**
   * Etape 1 du parcours d'onboarding : resoudre une adresse e-mail en contacts INGERES. L'etape ne saisit plus ni prenom, ni nom, ni fonction, l'identite vient de la SOURCE, et cette requete est ce qui la rapporte.
   *
   * **Option stricte, explicitement retenue : on n'onboarde que des contacts connus.** Une adresse qui ne designe aucun contact ingere est refusee, avec sa raison, une personne inconnue de Salesforce n'a ni compte, ni marche, ni perimetre, et l'onboarder produirait un utilisateur qui se connecte et NE VOIT RIEN.
   *
   *  **Rend une LISTE, jamais un contact elu au hasard** : `contact.email` ne porte aucune unicite, deliberement. Meme regle que `matchedContactCount` sur `suggestedMarkets`, et c'est l'ecran qui dit ce qu'il en fait.
   *
   *  La comparaison est **insensible a la casse** parce que la colonne est `citext` : c'est la base qui le tient, aucun `lower()` n'est rejoue ici, et aucune normalisation d'adresse (points, `+suffixe`) n'est inventee au bord.
   *
   * Borne par `listAccessibleAccounts`, LA MEME fonction qui borne `accessibleAccounts` et les deux catalogues de l'etape 3 : ce que l'acteur voit ne depasse pas ce qu'il peut administrer. La frontiere de lecture est `contact_account.organization_id`, noeud par noeud ; `contact.root_organization_id` n'est lu que pour le contact SANS aucun rattachement vivant, qui serait sinon introuvable, et c'est sa raison d'etre, pas une commodite.
   *
   * **Le vide n'est pas une erreur, c'est une reponse**, et `emptyReason` dit lequel des trois.
   *
   * `existingAttachments` rapporte, dans le MEME perimetre, les comptes ou cette adresse est deja rattachee : l'etape 2 les grise au lieu de les laisser cocher puis de les refuser a l'envoi. Refus : NOT_AUTHENTICATED, MISSING_PERMISSION.
   */
  contactsByEmail?: Maybe<ContactMatches>;
  /**
   * Le referentiel des partenaires proposables (RG-PTN-02), qui sert le selecteur des deux modales. Cinq criteres, definis une seule fois par la vue `eligible_partner` : type Partenaire, non radie, sans « contacter le channel », structure differente de Freelance, createur hors des deux portails techniques. 4 444 eligibles le 2026-08-26, soit moins d'un tiers des partenaires.
   *
   *  **L'eligibilite est recalculee a chaque lecture** (RG-PTN-03) : rien n'est a rafraichir, un partenaire qui devient inegible cesse d'etre rendu ici et disparait de toutes les listes.
   *
   *  `excludePartnerListId` sert la modale d'ajout, qui ne propose que « les eligibles non encore dans la liste ». La modale de declaration ne le passe pas, n'ayant pas encore de liste.
   *
   *  La page est BORNEE, 50 par defaut et 200 au plus, et `totalCount` dit le reste : servir 4 444 lignes a une modale ou la personne en cochera trois est un envoi pour rien, et une page rendue sans son total a l'air d'etre le tout.
   *
   * Reserve au **back-office** avec **`manage_referential`**.
   *
   * Refus possibles : NOT_AUTHENTICATED, INTERNAL_STAFF_ONLY, MISSING_PERMISSION, PARTNER_LIST_NOT_FOUND, INVALID_LIMIT, INVALID_OFFSET.
   */
  eligiblePartners: EligiblePartnerPage;
  /**
   * Les chiffres de l'ecran d'accueil, en UNE lecture.
   *
   * UN SEUL CHAMP ET NON QUATRE, parce que l'accueil les affiche ensemble : quatre requetes pour un ecran qui n'a qu'un etat de chargement rendraient quatre fois le periple d'authentification pour quatre nombres.
   *
   * AUCUN REFUS DE MODULE N'EST LEVE ICI, contrairement a `myNeeds`, `myServices` et `myInvoices` : l'accueil porte quatre tuiles de modules differents, et echouer parce que l'un d'eux est ferme emporterait les trois autres. Le refus est dit PAR TUILE, en rendant le champ nul.
   */
  homeSummary: HomeSummary;
  /**
   * Les tableaux de bord que la personne connectee peut ouvrir : LA PIECE QUI MANQUAIT A `dashboardEmbed`, qui savait ouvrir une entree dont on lui donne l'identifiant sans que rien ne permette de la decouvrir.
   *
   * Le module AVANT le perimetre, comme partout : la lecture est bornee aux rattachements ou « Tableau de bord » est ouvert, et une entree accordee sur un compte qui l'a ferme n'apparait pas ici, c'est exactement ce que le fabricant de jeton refuserait.
   *
   * N entrees NOMMEES PAR LEUR COMPTE, jamais un selecteur : le portail affiche l'union des rattachements, sans exception (§3.4).
   *
   *  Une entree ARCHIVEE reste listee, marquee `openable: false`. La retirer rendrait DASHBOARD_ARCHIVED inatteignable depuis l'ecran, et ferait disparaitre sans un mot ce qui s'ouvrait la veille.
   *
   * Refus : NOT_AUTHENTICATED, MODULE_NOT_ENABLED.
   */
  myDashboards?: Maybe<MyDashboards>;
  /**
   * Les factures CLIENT de l'utilisateur courant (PCG-31). Le perimetre est JOINT par `membership_visible_service` : une facture est visible si SA PRESTATION l'est, aucune vue de perimetre propre n'ayant ete creee.
   *
   * TROIS EXCLUSIONS, toutes tenues a la LECTURE et jamais a l'ingestion, comme les commandes annulees : typologie « Facture », montant STRICTEMENT POSITIF, statut different d'annule. Il faut les deux premieres et non une seule, 11 factures typees « Facture » portant un montant negatif sur le seul perimetre de la beta.
   *
   * TROIS FILTRES, `organizationIds` (Entite), `statuses` (Statut) et `period` (Periode), plus la recherche, tous dans la MEME instruction que la pagination : un filtre applique a la page recue repondrait « aucun resultat » pour une facture posee trois pages plus loin. `totalInvoices` les suit.
   *
   * LE FILTRE « MARCHE » EST SERVI depuis le 2026-08-13, et il se lit sur la PRESTATION, la facture ne portant aucun marche. Les factures sans contrat cadre sortent des qu'il est pose, 16,4 % des factures chargees : mesure faite sur les factures reelles, bien meilleure que les 44 % que la specification annonce sur les AT du parc, les deux chiffres etant justes sans compter la meme chose.
   *
   * L'URL DU PDF SORT depuis l'arbitrage du 2026-08-13, et c'est la POLICY S3 qui borne l'acces au document : voir `Invoice.documentUrl`.
   *
   * Refus : MODULE_NOT_ENABLED, qui est ici l'etat NOMINAL, « Factures » etant ferme par defaut sur tous les comptes.
   */
  myInvoices?: Maybe<MyInvoicesPage>;
  /** Marches visibles par l'utilisateur courant sur l'organisation courante, restriction personnelle comprise. */
  myMarkets?: Maybe<Array<Market>>;
  /**
   * **Le menu du portail.** Les modules ouverts sur AU MOINS UN des comptes de la personne : l'UNION de ses rattachements, jamais l'intersection : celle-ci ferait disparaitre un module quand on AJOUTE un rattachement, et la personne perdrait un acces en gagnant un compte.
   *
   *  **L'union n'ouvre qu'une entree de menu, jamais une ligne de donnee.** Le contenu de chaque module reste borne par compte sur tous les chemins de lecture, et chacun d'eux relit l'activation DU COMPTE qu'il sert : un module ouvert sur un seul compte apparait au menu, et les autres comptes refusent la lecture.
   *
   *  **Le menu n'est pas la securite.** Un front qui masque des lignes qu'il a recues n'est pas une securite, et cacher l'entree ne ferme pas l'URL : c'est `MODULE_NOT_ENABLED`, rendu par chaque chemin de lecture, qui ferme.
   *
   * Liste VIDE = aucun module ouvert sur aucun compte. C'est une reponse juste, pas un incident.
   *
   *  **Cette liste n'est PAS le referentiel**, c'est `portalModules`, et l'ecart s'est creuse avec PCG-98 : `portal_module` nomme les six entrees du menu de la maquette V2, dont quatre n'ont pas d'ecran. Aucune d'elles ne peut arriver ici (elles ne sont pas activables) mais un front qui construirait son menu depuis cette liste doit savoir qu'il lit des ACTIVATIONS, jamais un catalogue. `delivered` y est donc toujours vrai, et le rendre est ce qui permet de le CONSTATER plutot que de le croire : un faux signalerait une ligne d'`organization_module` posee hors de la mutation, le seul chemin que la garde applicative ne couvre pas.
   */
  myModules?: Maybe<Array<PortalModule>>;
  /** Besoins EN COURS de l'utilisateur courant. Le perimetre est JOINT par membership_visible_need, jamais filtre apres coup, et la regle d'affichage (ni commandes, ni perdus) descend en base AVEC la recherche, le filtre et la pagination, dans la meme instruction : une page pleine est pleine. Un besoin dont le stade est absent du referentiel RESTE dans la liste, avec un pas vide. */
  myNeeds?: Maybe<MyNeedsPage>;
  /**
   * Les partenaires de la liste de la personne connectee (RG-PAR-09), jamais l'annuaire : 4 444 partenaires sont eligibles au parc, une liste en compte une poignee.
   *
   *  **`listName` NUL veut dire « aucune liste rattachee »**, et ce n'est pas une erreur : le module n'a rien a montrer, et la reparation est a l'onboarding de la personne. A ne pas confondre avec une liste vide, qui se repare au back-office.
   *
   *  **L'anonymat se tient par la vue lue** et non par un champ efface au retour : une liste anonyme lit une vue qui ne porte pas le nom. La recherche suit, et ne porte pas sur le nom dans ce cas : elle serait sinon un oracle qui le reconstitue.
   *
   *  **Aucun filtre a cases n'est offert, et c'est une mesure et non un oubli.** La spec en veut trois : expertises, certifications, partenariats. Le premier n'a aucune source (Q-PAR-02). Les deux autres sont du TEXTE LIBRE : 1 514 lignes de certifications pour **1 282 valeurs distinctes** sur les eligibles, dont 117 de plus de 60 caracteres. Un menu construit dessus offrirait des options qui ne selectionnent qu'une ligne chacune, ce qui est un choisisseur de ligne et non un filtre. La recherche libre couvre les deux colonnes, ce que la spec lui demande deja.
   *
   *  **`MODULE_NOT_ENABLED` est l'etat NOMINAL sur la plupart des comptes** : le menu du portail annonce sept modules et l'API n'ouvre que ce qui a ete ouvert. Le refus tient compte d'avoir ete invite.
   *
   * Refus possibles : NOT_AUTHENTICATED, MODULE_NOT_ENABLED, INVALID_LIMIT, INVALID_OFFSET.
   */
  myPartners: MyPartnersPage;
  /**
   * Les sections de « Mon activite » : un groupe par (COMPTE, MARCHE), chacun portant le nombre COMPLET de prestations qu'il contient. C'est ce que la maquette V2 replie en accordeon.
   *
   * ATTENTION, DEUX GRAINS ET DEUX REQUETES. Celle-ci sert les en-tetes et leurs compteurs ; `myServices(section:)` sert les lignes d'un groupe qu'on deplie. Grouper une page de `myServices` afficherait « 4 prestations » sous un marche qui en porte 2 743, et 71,2 % des lignes du parc vivent dans une section de plus de 25.
   *
   * LA CLE EST (COMPTE, MARCHE) et l'API NE FUSIONNE JAMAIS : le portail affiche l'union des rattachements, donc deux comptes font deux sections meme sur le meme marche.
   *
   * TROIS NATURES, jamais fondues : marche relie, marche NOMME NON RELIE, et SANS CONTRAT CADRE. Cette derniere est rangee en dernier, avec son compteur : c'est un ecart assume a la maquette, qui n'en contient aucune.
   *
   * NON PAGINEE : 87 sections au maximum, donc `items.length` est le compte.
   *
   * LES MEMES FILTRES QUE `myServices` (PCG-130), et les compteurs les suivent : les deux requetes partagent un seul fragment SQL, donc `serviceCount` compte exactement ce que `myServices(section:)` deplie POUR LES MEMES ARGUMENTS. Une section dont plus rien n'est retenu QUITTE l'index, il n'y a donc aucun accordeon vide a masquer. `accounts` sert le menu « Entite » et ne suit, lui, aucun filtre.
   *
   * Refus : MODULE_NOT_ENABLED quand « Mon activite » est eteint sur tous les comptes.
   */
  myServiceSections?: Maybe<ServiceSectionIndex>;
  /**
   * Prestations de l'utilisateur courant. Le perimetre est JOINT par `membership_visible_service`, jamais filtre apres coup, et la recherche descend AVEC la pagination dans la meme instruction : une page pleine est pleine.
   *
   * TROIS FILTRES depuis PCG-130, `organizationIds` (Entite), `statuses` (Statut) et `period` (Periode), dans la MEME instruction que la pagination pour la meme raison : un filtre applique a la page recue repondrait « aucun resultat » pour une prestation posee trois pages plus loin. `totalServices` les suit. Le filtre « Marche » de la maquette est ECARTE : il ferait doublon avec le regroupement par marche de PCG-126, decide apres le dessin de cette barre.
   *
   *  NEUF colonnes de l'ecran ne sont pas servies faute de source : elles sont NOMMEES dans `unavailableColumns` plutot qu'omises. « Total commande » n'en fait PLUS partie depuis PCG-115, c'est `totalOrdered`, non nul, annulees exclues.
   *
   * `section` charge les lignes d'UN groupe de `myServiceSections` (PCG-126). Absent, la lecture reste celle d'avant ce lot, a plat sur tout le perimetre : l'argument RESTREINT, il ne remplace pas la liste.
   *
   * Refus : MODULE_NOT_ENABLED quand « Mon activite » est eteint sur le compte.
   */
  myServices?: Maybe<MyServicesPage>;
  /** Fiche d'un besoin. Hors perimetre et inexistant donnent la MEME reponse : l'appelant ne doit pas apprendre qu'un besoin existe ailleurs. */
  need?: Maybe<NeedDetail>;
  /** Les comptes au titre desquels l'utilisateur courant peut deposer un besoin, ce que l'ecran de depot doit lire pour proposer le choix. Rend TOUS ses rattachements ACTIFS, tries par nom : ceux qui ne peuvent pas recevoir de depot y sont, desactives, avec leur raison. Un rattachement `invited`, revoque ou quitte n'y est jamais. */
  needSubmissionAccounts?: Maybe<Array<SubmissionAccount>>;
  /**
   * Le detail d'une liste, archivee comprise : c'est le seul chemin de lecture d'une liste archivee, le tableau ne les rendant pas.
   *
   *  `search` filtre le bloc des partenaires cote serveur ; le compteur de l'en-tete l'ignore.
   *
   * Reserve au **back-office** avec **`manage_referential`**.
   *
   * Refus possibles : NOT_AUTHENTICATED, INTERNAL_STAFF_ONLY, MISSING_PERMISSION, PARTNER_LIST_NOT_FOUND.
   */
  partnerList: PartnerListDetail;
  /**
   * Le tableau de l'ecran « Listes de partenaires ». **Ni pagination ni tri**, le catalogue etant petit par nature : un theme est partage par tous les clients.
   *
   *  **Les listes ARCHIVEES n'y sont pas**, et leur nom reste pourtant reserve a jamais (RG-PTN-10) : l'archivage retire la liste de l'usage, le nom demeure pris. Consequence a connaitre : le back-office n'a AUCUNE porte vers une liste archivee, donc le refus de nom ne propose aucun geste de liberation.
   *
   *  `search` ne porte que sur le NOM de la liste, ni sur ses partenaires ni sur ses porteurs. L'absence de recherche ne contraint rien.
   *
   * Reserve au **back-office** avec **`manage_referential`**.
   *
   * Refus possibles : NOT_AUTHENTICATED, INTERNAL_STAFF_ONLY, MISSING_PERMISSION.
   */
  partnerLists: Array<PartnerListEntry>;
  /**
   * Referentiel complet des droits, sur ses DEUX axes : `domain` (la capacite) et `module` (l'ecran). Alimente la matrice de la fiche de role. Aucun argument : la liste est la meme pour tout le monde, et la masquer selon l'acteur ferait croire a un referentiel variable.
   *
   *  Ce referentiel dit ce que le produit sait EXPRIMER, jamais ce que l'appelant detient : `viewer` n'expose pas les permissions derriere le role, donc aucun ecran ne peut pre-empter un refus d'habilitation. Le refus se rend APRES le clic, en nommant le droit qui manque.
   */
  permissions?: Maybe<Array<Permission>>;
  /**
   * **Le referentiel des modules du portail** : leur code, leur libelle et l'ordre du menu, sans aucun contexte de compte. Alimente tout ecran qui CLASSE quelque chose par module, la matrice des droits du back-office (PCG-99), qui groupe les 36 droits sur `Permission.module`, et l'ecran d'edition d'un role.
   *
   * **Aucun argument, et c'est ce qui la distingue de `accountModules`.** Un module ne pend a aucun compte : ce sont les MEMES lignes pour tout le monde, semees par migration. `accountModules` croise ce referentiel avec l'etat d'UN compte et exige donc `manage_accounts` et le perimetre de ce compte ; les demander ici reviendrait a exiger un compte pour lire une liste qui n'en concerne aucun, c'est ce qui empechait la matrice des droits de nommer ses propres groupes.
   *
   *  **A ne pas confondre avec `myModules`**, qui repond a une autre question : celle-ci dit ce qui EXISTE, l'autre ce qui est OUVERT a la personne. Un front qui construirait sa matrice sur `myModules` la verrait se raccourcir selon l'operateur qui la regarde, et un front qui construirait son menu sur `portalModules` afficherait six entrees a tout le monde.
   *
   *  **L'ordre est celui du referentiel** (`sortOrder`), pas un ordre a recalculer : c'est le meme que celui dans lequel `permissions` rend ses lignes, de sorte que les deux requetes ne peuvent pas presenter les modules dans deux ordres differents sur un meme ecran.
   *
   * Refus possibles : NOT_AUTHENTICATED, NO_ACTIVE_MEMBERSHIP.
   */
  portalModules?: Maybe<Array<PortalModule>>;
  /** Fiche d'une personne du portail. Hors perimetre et inexistant donnent la MEME reponse nulle : l'appelant ne doit pas apprendre qu'une personne existe sur un compte qu'il ne voit pas. */
  portalUser?: Maybe<PortalUser>;
  /**
   * Roles attribuables d'une portee. Alimente le selecteur de role de M12-04 et celui de l'invitation d'un collaborateur.
   *
   *  La liste rend TOUS les roles de la portee, y compris ceux que l'acteur n'a pas le droit d'accorder : chacun porte `grantableByViewer` et, quand il est faux, `notGrantableReason`. Le selecteur les affiche DESACTIVES avec leur raison, il ne les retire pas, deux roles sur sept se lisent comme un referentiel incomplet, et « vous ne pouvez pas accorder un role qui depasse le votre » n'est pas « ce role n'existe pas ». C'est le MEME appel a `can_grant_role()` que celui qui refuse a l'envoi, donc le selecteur et la mutation ne peuvent pas se contredire.
   *
   * Refus : NOT_AUTHENTICATED, BACKOFFICE_ROLE_NOT_ALLOWED.
   */
  roles?: Maybe<Array<Role>>;
  /**
   * Fiche d'une prestation. `null` pour « n'existe pas » ET pour « hors perimetre », indistinctement : l'appelant ne doit pas apprendre qu'une prestation existe ailleurs. Le perimetre est JOINT par `membership_visible_service`.
   *
   * Refus : MODULE_NOT_ENABLED quand « Mon activite » est eteint, l'URL d'un module eteint repond explicitement, c'est l'adresse qu'un utilisateur garde en favori.
   */
  service?: Maybe<ServiceDetail>;
  /**
   * L'onglet Activites d'une prestation dont l'activite est saisie dans Connecteed : les CRA (PCG-228).
   *
   *  Attention, **ELLE NE REMPLACE PAS `servicePhases`, ELLE COEXISTE**. Laquelle des deux l'ecran lit se decide sur `ServiceDetail.activitySource`, et il n'y a **AUCUN repli automatique** de l'une sur l'autre : replier ferait afficher les phases d'une prestation dont l'activite vit ailleurs, c'est-a-dire des chiffres justes sur la mauvaise source. Une prestation en `CONSUMPTIONS` sans aucun CRA rend donc une page vide, et l'ecran l'ecrit.
   *
   *  **Deux filtres, et ce sont ceux de la specification** : seul le type « Prestation sous-traitance » s'affiche, les frais et les astreintes ayant leurs propres colonnes ailleurs ; et seul `REJECTED` se retranche des six statuts, par symetrie avec l'exclusion des phases annulees.
   *
   *  `null` quand la prestation n'existe pas ou est hors perimetre, meme reponse que `service`, et pour la meme raison.
   *
   * Refus possibles : NOT_AUTHENTICATED, MODULE_NOT_ENABLED, INVALID_LIMIT, INVALID_OFFSET.
   */
  serviceActivities?: Maybe<ServiceActivityPage>;
  /**
   * L'onglet Conformite d'une prestation : qui intervient, et ou en est la vigilance du partenaire qui l'engage.
   *
   * Attention, LA SPEC DECRIT DEUX ONGLETS DIFFERENTS SOUS UN SEUL NOM, et c'est a savoir avant de rendre cet ecran. La page « detail AT & ATF & RM » titre « Onglet Intervenants » (renomme « Conformite » par la maquette) et donne TROIS colonnes sur des PERSONNES ; la page « detail forfait » titre « Onglet Conformite » et donne DEUX colonnes sur des PARTENAIRES, en ecrivant elle-meme le contraste : « Le partenaire, pas une personne, contrairement a l'onglet Intervenants de l'AT/ATF/RM ». `subject` tranche, sur le type de la prestation, parce que c'est une regle de la SOURCE.
   *
   * Attention, LES LIGNES SE LISENT SUR LES MEMES PHASES QUE L'ONGLET ACTIVITES, filtres compris. S'en passer ferait reapparaitre ici les six types de phase que RG-02 retranche et les phases a montant nul de RG-2, dont les commissions d'apport d'affaires : « Apport d'affaire M Mendes » sur la fiche que le client lit, dans l'onglet d'a cote. 56 couples sur 1 689 sont dans ce cas.
   *
   * CET ONGLET ETAIT DECLARE INDISPONIBLE POUR `no_source`, ce qui etait vrai de notre cote et faux du cote de l'emetteur : `Provigis_Status__c` est repliquee au miroir, 7 461 dossiers, et lisible avec le droit qu'on avait deja. Ce qui manquait etait une table chez nous.
   *
   * `null` quand la prestation n'existe pas ou est hors perimetre, indistinctement, comme `service` et `servicePhases` ; une LISTE VIDE quand elle est visible et ne porte aucune phase affichable.
   *
   * Refus : MODULE_NOT_ENABLED quand « Mon activite » est eteint sur le compte.
   */
  serviceCompliance?: Maybe<ServiceComplianceList>;
  /**
   * L'onglet DC4 d'une prestation : les declarations de sous-traitance qui la concernent.
   *
   *  LE CLOISONNEMENT PASSE PAR LA LIAISON : un DC4 ne porte aucun compte, 312 des 2 102 documents rattaches remontent sur PLUSIEURS comptes et jusqu'a 55. La requete part de `membership_visible_service` et descend par `service_dc4` ; lire `dc4` depuis un identifiant rendrait a un client les documents de 54 autres.
   *
   *  NON PAGINEE, par mesure et non par commodite : 37 documents au maximum sur une prestation.
   *
   *  Trois des cinq colonnes de l'ecran ne sont pas servies et sont nommees dans `unavailableColumns`, dont « Action », le bouton « Signer le DC4 », qui attend le juridique.
   *
   * `null` quand la prestation n'existe pas ou est hors perimetre ; une LISTE VIDE quand elle est visible et ne porte aucun DC4, les deux se distinguent.
   *
   * Refus : MODULE_NOT_ENABLED quand « Mon activite » est eteint sur le compte.
   */
  serviceDc4s?: Maybe<ServiceDc4List>;
  /**
   * Les commandes CLIENT d'une prestation, avec leurs lignes.
   *
   * Attention, IL N'Y A PAS D'ONGLET « COMMANDES » DANS LA MAQUETTE V2, et c'est a savoir avant de placer cet ecran : les commandes vivent dans l'onglet **Vue d'ensemble** de la fiche, en accordeon de cartes. L'onglet dont l'identifiant est `tpresta-commandes` porte le libelle « Activites » et rend les PHASES, deja servies par `servicePhases`.
   *
   * Attention, LE CLOISONNEMENT PART DE LA PRESTATION, JAMAIS DU COMPTE DE LA COMMANDE. Une commande porte son propre compte, ingere brut et sans cle etrangere, qui DIVERGE de celui de son contrat sur 6 620 commandes sur 68 205 (9,7 %), reparties sur 2 342 prestations. Le contrat fait foi : la requete part de `membership_visible_service`, descend par `service`, et joint la commande par SES DEUX colonnes. Le compte declare par la commande n'est pas lu du tout.
   *
   * Attention, PAGINEE, contrairement a `serviceDc4s`, et c'est une mesure et non une habitude : 2,65 commandes par prestation en moyenne, 8 au 95ᵉ centile, **92 au maximum**, et les deux prestations les plus chargees sont encore actives et accumulent. Les LIGNES d'une commande, elles, sont completes et non paginees : 51 au maximum.
   *
   * Attention, LA PERIODE ET LA REFERENCE DU BON DE COMMANDE SONT SERVIES DEPUIS PCG-138, sur `startDate`, `endDate` et `purchaseOrderReference`. Elles etaient declarees non disponibles pour « aucune source » alors que la source les portait a 99,1 % : c'est notre table qui n'avait pas de colonne, elle les a depuis, et 4 666 des 4 691 commandes venues du miroir les portent en base de dev (99,47 %). Attention, les deux dates sont INDEPENDAMMENT NULLABLES, leur absence est un ETAT (une commande validee n'est pas encore commandee) et une periode INVERSEE est rendue telle quelle.
   *
   * Attention, LE STATUT EST SERVI DEPUIS PCG-146, sur `displayStatus`, traduit par `service_order_status_mapping` : SIX libelles pour SEPT cles source, `Validé` et `VALIDATION` etant le MEME etat (809 commandes). Il etait declare non disponible faute de referentiel, ce qui etait exact ; le produit a tranche, donc le champ est servi. Une valeur non traduite rend un NUL, jamais la valeur brute.
   *
   * Attention, SEPT BLOCS DE LA CARTE NE SONT TOUJOURS PAS SERVIS et sont NOMMES dans `unavailableColumns` plutot qu'omis, avec le geste qui debloque chacun.
   *
   * Attention, AUCUN TOTAL N'EST DERIVE DES LIGNES, deliberement : le montant porte par la commande et la somme de ses lignes divergent sur 1,92 % des commandes et 6,8 M€ sur le parc, et laquelle est « le total commande » n'est pas tranche par le produit.
   *
   * `null` quand la prestation n'existe pas ou est hors perimetre : indistinctement, comme `service`. Une page VIDE quand elle est visible et ne porte aucune commande : 692 prestations sur 25 752 (2,7 %) sont dans ce cas.
   *
   * Refus : MODULE_NOT_ENABLED quand « Mon activite » est eteint sur le compte.
   */
  serviceOrders?: Maybe<ServiceOrderPage>;
  /**
   * L'onglet Activites d'une prestation, PAGINE : `service_phase` porte 202 067 lignes, jusqu'a 496 sur une seule prestation.
   *
   *  Trois des six colonnes de l'ecran ne sont pas servies et sont nommees dans `unavailableColumns`.
   *
   * `null` quand la prestation n'existe pas ou est hors perimetre, meme reponse que `service`, et pour la meme raison.
   */
  servicePhases?: Maybe<ServicePhasePage>;
  viewer?: Maybe<User>;
};


export type QueryAccountActivitiesArgs = {
  email: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAccountMarketsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryAccountModulesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryAccountUsersArgs = {
  direction?: InputMaybe<SortDirection>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<AccountUsersSort>;
  status?: InputMaybe<MembershipDisplayStatus>;
};


export type QueryAccountsArgs = {
  direction?: InputMaybe<SortDirection>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  portalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAssignableDashboardsArgs = {
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryContactsByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryEligiblePartnersArgs = {
  excludePartnerListId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyInvoicesArgs = {
  direction?: InputMaybe<SortDirection>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  marketIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  period?: InputMaybe<InvoicePeriod>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<InvoicesSort>;
  statuses?: InputMaybe<Array<InvoiceDisplayStatus>>;
};


export type QueryMyNeedsArgs = {
  contactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  direction?: InputMaybe<SortDirection>;
  displaySteps?: InputMaybe<Array<NeedDisplayStep>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  marketIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<NeedsSort>;
};


export type QueryMyPartnersArgs = {
  expertise?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<PartnerSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QueryMyServiceSectionsArgs = {
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  period?: InputMaybe<ServicePeriod>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ServiceDisplayStatus>>;
};


export type QueryMyServicesArgs = {
  direction?: InputMaybe<SortDirection>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  period?: InputMaybe<ServicePeriod>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<ServiceSectionInput>;
  sort?: InputMaybe<ServicesSort>;
  statuses?: InputMaybe<Array<ServiceDisplayStatus>>;
};


export type QueryNeedArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPartnerListArgs = {
  partnerListId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPartnerListsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPortalUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryRolesArgs = {
  scope: RoleScope;
};


export type QueryServiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServiceActivitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  serviceId: Scalars['ID']['input'];
};


export type QueryServiceComplianceArgs = {
  serviceId: Scalars['ID']['input'];
};


export type QueryServiceDc4sArgs = {
  serviceId: Scalars['ID']['input'];
};


export type QueryServiceOrdersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  serviceId: Scalars['ID']['input'];
};


export type QueryServicePhasesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  serviceId: Scalars['ID']['input'];
};

export type ResendInvitationPayload = {
  __typename?: 'ResendInvitationPayload';
  /** Vrai si le mail est EFFECTIVEMENT parti. Faux laisse l'invitation dans la file de rejeu : la rotation du jeton, elle, est acquise. */
  activationEmailSent?: Maybe<Scalars['Boolean']['output']>;
  /** Fin de validite du NOUVEAU lien. L'echeance repart de zero, elle n'est jamais prolongee. */
  expiresAt?: Maybe<Scalars['String']['output']>;
  invitationId?: Maybe<Scalars['ID']['output']>;
  /** Toujours vrai, et ce n'est pas decoratif : le lien precedent CESSE DE FONCTIONNER. L'interface doit le dire a l'operateur, c'est la contrepartie de la rotation du jeton et la seule chose qui la rende acceptable. */
  previousLinkRevoked?: Maybe<Scalars['Boolean']['output']>;
  /** Nombre total d'envois a cette personne, relances comprises. */
  sentCount?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type Role = {
  __typename?: 'Role';
  code?: Maybe<Scalars['String']['output']>;
  /** Colonne « Cree le » de la liste des roles du back-office. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Ce que le role autorise, en une phrase. Alimente les cartes de role du back-office. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * L'acteur de CETTE requete peut-il accorder ce role ? Repond a la meme question que `inviteUser` et `inviteCollaborator` refusent a l'envoi, avec le MEME appel a `can_grant_role()` : le selecteur et l'envoi ne peuvent donc pas se contredire.
   *
   * Juge sur le rattachement de la requete (celui que designe `X-Organization-Id`, sinon le rattachement par defaut) et JAMAIS sur l'union des rattachements de la personne, qui serait un elargissement : le plus fort de ses roles accorderait alors sur le compte ou elle porte le plus faible. Il ne prend pas de compte en argument parce que le refus n'en depend pas non plus : un acteur portail ne peut agir que sur SON organisation, et un acteur interne ne porte aucun rattachement sur les comptes de son portefeuille, c'est pourquoi la comparaison de roles ne s'applique pas a lui.
   *
   *  Ne dit RIEN du perimetre : qu'un compte soit dans le portefeuille de l'acteur est la question de l'etape 2, a laquelle `accessibleAccounts` repond. FAUX ici veut dire « ce role, jamais » ; il ne veut pas dire « pas sur ce compte ».
   */
  grantableByViewer: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  /** Nombre de rattachements qui portent ce role. Les revoques et les departs ne comptent pas : c'est le meme filtre que viewer.memberships, donc les deux ecrans disent la meme chose. */
  membershipCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** POURQUOI l'acteur ne peut pas accorder ce role. Nul des qu'il le peut. Ce n'est pas une erreur, et le role n'est pas retire de la liste : il s'affiche desactive avec sa raison, deux roles sur sept feraient croire a un referentiel incomplet. */
  notGrantableReason?: Maybe<RoleNotGrantableReason>;
  /** Droits que ce role accorde, dans l ordre de la matrice. */
  permissions?: Maybe<Array<Permission>>;
  scope?: Maybe<RoleScope>;
};

/** Pourquoi l'acteur de la requete ne peut pas accorder ce role. Nul des qu'il le peut. */
export enum RoleNotGrantableReason {
  /** L'acteur n'a pas le droit d'administrer les personnes : `manage_users` pour un role de portail, `manage_staff` pour un role de back-office. Le droit AVANT le role, comme partout ailleurs. C'est aussi ce que lit un acteur portail devant un role back-office, et c'est exact, aucun role de portail ne porte `manage_staff`. */
  MissingPermission = 'MISSING_PERMISSION',
  /** La requete ne porte aucun rattachement actif : ni `X-Organization-Id` valide, ni rattachement par defaut, et plusieurs candidats. L'acteur n'accorde alors RIEN, quel que soit le role. Atteignable par `viewer.memberships.role`, jamais par `roles`, qui refuse d'abord par NOT_AUTHENTICATED. */
  NoActiveMembership = 'NO_ACTIVE_MEMBERSHIP',
  /** Le role accorde des droits que l'acteur n'a pas lui-meme : `can_grant_role()` est faux. C'est le seul refus qui parle du ROLE et non de l'acteur, et le geste est d'en choisir un autre ou de se faire habiliter. Il ne dit RIEN du perimetre : le compte est la question de l'etape 2, a laquelle `accessibleAccounts` repond deja. */
  PrivilegeEscalation = 'PRIVILEGE_ESCALATION'
}

/** Portee d'un role. Un role back-office ne peut vivre que sur l'organisation interne. */
export enum RoleScope {
  Backoffice = 'BACKOFFICE',
  Portal = 'PORTAL'
}

/** Une prestation : un contrat d'application. MEME OBJET SOURCE qu'un marche, distingue par son type d'enregistrement. */
export type Service = {
  __typename?: 'Service';
  /** Mesure a 21,3 % : la cellule est vide huit fois sur dix, et ce n est pas un bug. */
  clientReference?: Maybe<Scalars['String']['output']>;
  /** UN COMPTE et non une enumeration : les intervenants se projettent depuis les phases, dont une prestation porte jusqu'a 496. */
  contributorCount?: Maybe<Scalars['Int']['output']>;
  /** Libelle d'affichage traduit. NE JAMAIS recopier `sourceStatus` a la place : « Termine facture » s'affiche « RECEPTIONNE ». Nul quand le referentiel ne porte aucune traduction, un trou VISIBLE, et non un libelle invente. */
  displayStatus?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  /** NOTRE uuid, jamais une reference metier : `name` n'est pas une cle. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Une PROPRIETE au stockage et un AIGUILLAGE a l'affichage : vrai ouvre la fiche portage quel que soit le type de base. */
  isPortageCommercial?: Maybe<Scalars['Boolean']['output']>;
  /** Composee A LA LECTURE depuis quatre colonnes : une colonne pre-composee perdrait le code postal des le premier tri. */
  location?: Maybe<Scalars['String']['output']>;
  /** Attention, c est la SEULE condition d un lien. Nul a cote d un `marketName` renseigne signifie « marche nomme, non relie » : on affiche le nom, on n ouvre aucune fiche, nous n avons pas l objet. */
  marketId?: Maybe<Scalars['ID']['output']>;
  /** Attention, DEUX ABSENCES DIFFERENTES, a lire avec `marketId` (PCG-123). Nul = AUCUN marche : cas ordinaire et majoritaire, 48,5 % des contrats n en ont pas, l ecran ecrit « aucun marche » et il n y a rien a rattraper. Renseigne avec `marketId` NUL = un marche NOMME mais NON RELIE, 190 prestations mesurees le 2026-08-10 : on affiche le nom SANS lien. Renseigne avec `marketId` = le marche resolu, seul etat cliquable. Confondre les deux fait lire « pas de marche » sur une prestation qui en a un. */
  marketName?: Maybe<Scalars['String']['output']>;
  marketReference?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** L'operationnel, lu sur le contact INGERE et jamais sur un utilisateur du portail. */
  operationalName?: Maybe<Scalars['String']['output']>;
  /**
   * « Nb de jours commandes » : somme des quantites des LIGNES des commandes client vivantes, annulees exclues. MEME perimetre de commandes que `totalOrdered`, ecrit une seule fois cote resolveur pour que deux colonnes voisines du meme tableau ne puissent pas parler de commandes differentes.
   *
   *  NUL LA OU `totalOrdered` VAUT ZERO, ET L'ASYMETRIE EST VOULUE. Le montant zero est une affirmation de la source, qui l'ecrit elle-meme sur les contrats sans commande ; ici rien ne l'affirme, et « 0 jour commande » serait un chiffre que personne n'a ecrit. La specification le demande dans ces termes : afficher «, », jamais 0.
   *
   *  NUL AUSSI HORS ASSISTANCE TECHNIQUE, et c'est une propriete de la DONNEE plutot qu'une regle d'ecran, d'ou sa place ici. Sur un forfait la quantite d'une ligne de commande n'est pas un nombre de jours mais un nombre d'unites d'oeuvre : elle y vaut 51,9 en moyenne sur la base de dev, et la rendre sous cet en-tete donnerait un chiffre faux avec l'aplomb d'un chiffre juste. Le portage (RM) n'est PAS retranche : ce n'est pas un type mais un axe a part (`isPortageCommercial`), et une prestation portee reste `at` ou `atf`.
   *
   *  EN CHAINE et a deux decimales, comme les montants : une quantite porte des demi-journees, et un NUMERIC(16, 2) rendu en nombre s'arrondit.
   */
  orderedDays?: Maybe<Scalars['String']['output']>;
  /** Le COMPTE dont vient la ligne. Il devient indispensable avec l'union des rattachements (PCG-27) : sans lui, deux prestations de deux comptes se lisent comme deux lignes du meme compte. C'est aussi ce qui a tranche la colonne « Entite », qui restait indisponible faute de savoir si elle designait le compte ou l'etablissement. */
  organizationName: Scalars['String']['output'];
  /**  TROIS valeurs derivees d'une source qui n'en porte que DEUX : le booleen « est freelance » croise avec le portage. La derivation vit au resolveur, jamais en base, un champ a trois valeurs sur une source a deux FABRIQUERAIT la troisieme. UNKNOWN est une absence de ressource, pas une quatrieme nature. */
  partnerKind?: Maybe<PartnerKind>;
  /**  Regle d'AFFICHAGE : deux colonnes candidates DIVERGENT sur 289 prestations. On retient le partenaire de la PERSONNE (rempli a 98,4 %), celui du contrat servant de repli (12,3 %). */
  partnerName?: Maybe<Scalars['String']['output']>;
  /**
   * « Nb de jours restant a facturer » : les quantites commandees moins les quantites facturees, sur le MEME perimetre de lignes que `orderedDays`, donc nul dans exactement les memes cas.
   *
   *  LA SPECIFICATION SE CONTREDIT SUR CETTE COLONNE et c'est la seconde ecriture qui est retenue, confirmee par son auteur le 2026-08-12 : son tableau de mapping donne la seule somme des quantites facturees, sa section « Calculs backend » donne la difference. Seule la difference porte le nom de la colonne, l'autre afficherait le facture sous l'en-tete du restant.
   *
   *  UN RESULTAT NEGATIF EST RAMENE A ZERO, sur decision de la specification (« le restant a facturer ne peut pas etre negatif »). Le cas existe, 494 lignes en production, et AUCUNE en base de dev : c'est donc une regle qu'aucun essai local ne verifiera, d'ou son test. Elle ecrase une anomalie de la source la ou ce depot la rend d'ordinaire telle quelle, et c'est assume : un restant negatif se lirait comme une dette du client envers nous.
   */
  remainingDaysToInvoice?: Maybe<Scalars['String']['output']>;
  serviceType?: Maybe<Scalars['String']['output']>;
  /** Statut de la source, VERBATIM : la picklist appartient a l'emetteur. */
  sourceStatus?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  /**
   * « Total commande » : somme des commandes CLIENT vivantes de la prestation, ANNULEES EXCLUES.
   *
   *  CALCULE, jamais recopie. Salesforce porte son propre `INO_Montant_Total_Commandes_Client__c`, renseigne sur 19,5 % des contrats d'application seulement et d'autant plus souvent qu'ils sont recents (5,8 % en 2020, 74,3 % en 2026) : l'afficher tel quel montrerait un total sur les prestations recentes et rien sur les anciennes, sans qu'un lecteur puisse distinguer « aucune commande » de « pas encore calcule ». La formule reproduite ici concorde avec ce champ sur 5 172 contrats sur 5 172 (100 %) ; annulees comprises, 96,2 %.
   *
   *  NON NUL, et « 0.00 » AFFIRME qu'il n'y a rien de commande. Ce n'est pas notre convention mais celle de la source : les 31 contrats dont toutes les commandes sont annulees y portent 0, comme les 28 sans aucune commande qui renseignent le champ. C'est L'INVERSE de `orderedDays`, et l'asymetrie est argumentee sur ce champ-la.
   *
   *  EN CHAINE et a deux decimales, jamais un flottant : un NUMERIC(16, 2) rendu en nombre s'arrondit. Meme regle que `ServicePhase.amountInvoiced`. Il peut etre NEGATIF, 732 commandes client portant un avoir.
   *
   *  Ce n'est PAS le total facture, qui reste non servi faute de reprise des factures : voir `unavailableColumns`.
   */
  totalOrdered: Scalars['String']['output'];
};

/** Une ligne de la vue Activites : UN CRA, et non un mois. C'est ce qui la distingue de `ServicePhase`, dont la ligne est une echeance mensuelle. Une meme phase peut donc apparaitre sur deux lignes : c'est rare (97,5 % des phases citees ne portent qu'un CRA) mais reel, jusqu'a 18 sur une seule. */
export type ServiceActivity = {
  __typename?: 'ServiceActivity';
  /** Le montant client du CRA, EN CHAINE. Verifie au centime sur un cas reel cote source (22 j x 618,56 euros = 13 608,32 euros). */
  amount?: Maybe<Scalars['String']['output']>;
  /**
   * Le TJM, **et c'est ICI qu'il en est un**.
   *
   *  Attention, **A NE PAS CONFONDRE AVEC LE PRIX DE LA PHASE** : celui-la est rempli a 99,4 % et n'est pas un taux journalier, il egale le montant du mois sur 24,7 % des lignes et monte a 9 055 000 euros. Celui-ci a une mediane de 618,56 euros. C'est exactement pourquoi la colonne TJM de la vue Phases reste non servie et que celle-ci l'est.
   *
   *  **Il reste imparfait, et c'est un defaut de SAISIE et non d'ecran.** Mesure du 2026-08-28 sur les 8 310 CRA affichables de la base de dev : mediane 710 euros, mais **4,3 % des valeurs depassent 5 000 euros** et le maximum est 280 204. Sur ces 348 lignes, **332 sont declarees a UN SEUL JOUR** : ce sont des forfaits saisis comme une journee, et seules 100 d'entre elles sont coherentes avec leur propre montant. La colonne est servie parce que 95,7 % des valeurs sont justes et que c'est le seul TJM de la source, mais ces lignes montrent au client un taux journalier a cinq chiffres. Remonte au produit le 2026-08-28, meme famille que les phases d'apporteur d'affaires : la correction est chez celui qui saisit.
   *
   *  Pour comparer, la coherence `montant = jours x TJM` tient sur 93,6 % des lignes completes.
   */
  dailyRate?: Maybe<Scalars['String']['output']>;
  /** La date de realisation, remplie a 100 %. **L'ecran n'en tire QUE LE MOIS** : c'est le repli de `periodName`, pas une colonne a elle. Elle sert aussi de cle de tri, le nom du mois etant du texte (« Aout 2026 » se trierait avant « Juin 2026 »). */
  deliveryDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Le mois, tel que la phase le nomme (« Juin 2026 »).
   *
   *  Attention, **NUL VEUT DIRE « CE CRA NE CITE AUCUNE PHASE »** et non « pas de periode » : `deliveryDate` dit alors quand. Mesure du 2026-08-28 : 100 865 CRA citent une phase, 5 995 n'en citent aucune et portent une date, **ZERO n'ont ni l'un ni l'autre**. La periode ne manque donc jamais, mais elle ne vient pas toujours du meme endroit, et l'ecran doit lire les deux champs.
   */
  periodName?: Maybe<Scalars['String']['output']>;
  /** L'intervenant, colonne « Intervenant » de la specification. Rempli a 99,9 %, et les 106 802 references du miroir resolvent toutes dans le catalogue : un nul designe donc un CRA sans intervenant declare, pas une resolution ratee. */
  resourceName?: Maybe<Scalars['String']['output']>;
  /**
   * Le statut du CRA, **VERBATIM DE LA SOURCE** : aucun referentiel ne le traduit, a la difference des phases et des prestations. L'ecran porte donc le vocabulaire, et une valeur inconnue doit s'y VOIR plutot que de tomber dans un « autre ».
   *
   *  Cinq valeurs peuvent arriver : `VALIDATED`, `TO_BE_FILLED`, `TO_BE_VALIDATED`, `TO_BE_SUBMITTED`, `ARCHIVED`. `REJECTED` est retranche par la lecture, seul retranchement et il est explicite dans la specification. **Un statut NUL entre**, la source en portant 10 au parc.
   */
  status?: Maybe<Scalars['String']['output']>;
  /**
   * La « CHARGE » : les jours declares, **EN CHAINE** pour ne pas arrondir.
   *
   *  C'est `Quantity__c` et non `Charge__c`, et **la mesure a tranche ce que la specification laissait ouvert** : sur les 101 381 CRA en jours, 94 882 sont identiques, 897 portent `Quantity__c` seul, **ZERO portent `Charge__c` seul et ZERO divergent**. Le second est un sous-ensemble strict du premier, donc le premier fait foi sans perte.
   */
  workedDays?: Maybe<Scalars['String']['output']>;
};

export type ServiceActivityPage = {
  __typename?: 'ServiceActivityPage';
  items: Array<ServiceActivity>;
  /** Les CRA affichables de la prestation, avant pagination. Il vient de l'API et jamais de `items.length`, et il porte **les memes deux filtres que la liste** : sans cela il annoncerait « 12 activites » au-dessus d'un tableau qui en montre neuf, defaut deja paye sur le compteur des commandes a PCG-149. */
  totalActivities: Scalars['Int']['output'];
};

/** Une colonne de la liste des prestations, designee par le contrat. */
export enum ServiceColumn {
  Consumption = 'CONSUMPTION',
  Entity = 'ENTITY',
  OrderedDays = 'ORDERED_DAYS',
  RemainingDaysToInvoice = 'REMAINING_DAYS_TO_INVOICE',
  TotalExpensesInvoiced = 'TOTAL_EXPENSES_INVOICED',
  TotalInvoiced = 'TOTAL_INVOICED',
  TotalOnCallInvoiced = 'TOTAL_ON_CALL_INVOICED',
  TotalOrdered = 'TOTAL_ORDERED',
  TotalRemainingToInvoice = 'TOTAL_REMAINING_TO_INVOICE',
  TotalServicesInvoiced = 'TOTAL_SERVICES_INVOICED',
  WorkedDays = 'WORKED_DAYS'
}

/** Une ligne de l'onglet Conformite. CE QU'ELLE DESIGNE DEPEND DU SUJET DE LA LISTE, voir `ComplianceSubject` : sur `RESOURCE` c'est un couple (intervenant, partenaire), sur `PARTNER` c'est un partenaire seul. */
export type ServiceComplianceEntry = {
  __typename?: 'ServiceComplianceEntry';
  /**
   * Le statut Provigis du partenaire, VERBATIM et en anglais : `verified`, `to_verify`, `invalid`, `offline`. La traduction appartient a l'ECRAN, comme pour les statuts de phase : c'est la picklist d'une source qu'on ne possede pas, et une cinquieme valeur doit pouvoir remonter jusqu'au lecteur plutot que d'etre rangee dans un « autre » ou personne ne la verrait.
   *
   * Attention, NUL VEUT DIRE « AUCUN DOSSIER » ET NON « CONFORME ». Le vocabulaire de la plateforme pour ce cas est « Jamais controle ». C'est l'etat de 395 des 1 594 lignes de la base de dev, une sur quatre : l'absence est ORDINAIRE, donc elle se redige plutot que de laisser une cellule blanche dans une colonne de statuts.
   *
   * Attention, `to_verify` NE COMPTE QUE 13 DOSSIERS SUR 7 461 (0,17 %) : un des quatre libelles ne se verra pour ainsi dire jamais, ce qui n'autorise pas a le retirer.
   *
   * Le statut est ELU quand le partenaire porte plusieurs dossiers (556 comptes, dont 33 qui se contredisent) : dossier le plus recemment modifie, a egalite le plus defavorable, puis l'Id. La regle vit dans la vue `partner_compliance` et vient de la page Confluence « Dashboard EDF », pour que le portail et le tableau de bord ne rendent pas deux statuts du meme partenaire.
   */
  complianceStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * La colonne « Type » de la maquette. NULLE sur le sujet `PARTNER`, ou cette colonne n'existe pas : une valeur y serait une colonne de plus que la spec.
   *
   * Attention, TROIS NATURES ET NON DEUX. La spec n'en donne que deux ; la maquette en affiche trois, la troisieme etant le salarie porte, qui ne se lit nulle part et se DERIVE de `isPortageCommercial`. Le portage l'emporte sur les deux autres.
   *
   * Attention, ELLE SE LIT SUR LE TYPE DE STRUCTURE DU PARTENAIRE ET NON SUR `Est_Freelance__c`, qui est le champ de la spec et qui est REPLIQUE A TORT : 1 093 vrais au miroir contre 7 009 ressources dont le partenaire est de structure « Freelance », soit 203 independants sur 276 affiches « Partenaire » sur le perimetre de la base de dev. HYPOTHESE A CONFIRMER avec le produit, argumentee sur `FREELANCE_STRUCTURE_TYPE`.
   */
  nature?: Maybe<PartnerKind>;
  /**
   * Le partenaire par lequel l'intervenant est engage, et le porteur du statut de conformite.
   *
   * Attention, IL EST SERVI SUR LE SUJET `RESOURCE` AUSSI, ou la spec ne prevoit que trois colonnes, et ce n'est pas une quatrieme colonne : 38 couples (prestation, intervenant) sur 1 633 portent DEUX partenaires distincts, donc deux lignes du meme nom avec deux statuts differents. Sans le partenaire a cote, elles se lisent comme un doublon. Une ligne par ressource obligerait a ELIRE un partenaire, c'est-a-dire a inventer le statut affiche.
   */
  partnerName?: Maybe<Scalars['String']['output']>;
  /** L'intervenant. NUL sur le sujet `PARTNER`, ou la ligne n'est pas une personne : la spec forfait ecrit elle-meme que la colonne « Intervenant » y porte « le partenaire, pas une personne ». Nul aussi, sur le sujet `RESOURCE`, quand la ressource n'a pas de nom : 3 des 35 076 ressources sont dans ce cas. */
  resourceName?: Maybe<Scalars['String']['output']>;
};

/** L'onglet Conformite d'une prestation. NON PAGINEE par mesure : 1,16 intervenant par prestation en moyenne, 28 au maximum, donc la liste est COMPLETE et son compte est `items.length`. */
export type ServiceComplianceList = {
  __typename?: 'ServiceComplianceList';
  items: Array<ServiceComplianceEntry>;
  /** Ce que les lignes designent. A LIRE AVANT DE RENDRE LES COLONNES : les deux sujets n'ont pas le meme nombre de colonnes ni le meme objet. */
  subject: ComplianceSubject;
};

/** Un DC4 (declaration de sous-traitance) rattache a une prestation. C'est un objet PARTAGE : le meme document remonte sur jusqu'a 55 comptes, et c'est la liaison `service_dc4` qui porte le cloisonnement. */
export type ServiceDc4 = {
  __typename?: 'ServiceDc4';
  /**  LE SEUL CHAMP QUI DISE « SIGNATURE ATTENDUE » : le badge de la maquette vient de lui, et non du statut source ou cette valeur n'existe pas. 165 des 2 102 documents rattaches. Ce n'est PAS une echelle de statut : il ne dit rien des 1 937 autres. */
  clientMustSign: Scalars['Boolean']['output'];
  /**
   * Le statut du DC4, **TRADUIT par `dc4_status_mapping`** depuis PCG-230 : neuf valeurs source vers six libelles (RG-05 du ticket).
   *
   *  **Ce champ etait TOUJOURS NUL, et le motif etait trop large.** Il disait qu'aucun referentiel ne traduisait le statut d'un DC4, ce qui etait vrai, et en concluait qu'il fallait un arbitrage, ce qui ne l'etait pas : la correspondance etait deja ecrite dans le ticket. Il n'y avait qu'un referentiel a semer, et c'est fait.
   *
   *  Sept cles possibles : `en_preparation`, `signature_en_cours`, `signe_deux_parties`, `a_valider`, `actif`, `termine`, et `rejete` qui n'est jamais rendu, la lecture le retranchant (RG-06). L'ECRAN porte les libelles francais, comme pour les phases.
   *
   *  Attention, **NUL VEUT DIRE « STATUT NON TRADUIT » ET NON « AUCUN STATUT »** : les 720 DC4 rattaches de la base en portent un, et la jointure du referentiel est A GAUCHE, ce qui fait ENTRER celui qu'il ignore plutot que de l'escamoter. Un ecran qui rendrait le nul comme un statut inventerait une valeur.
   *
   *  La valeur SOURCE ne sort pas du schema : elle ne sert qu'a joindre le referentiel.
   */
  displayStatus?: Maybe<Scalars['String']['output']>;
  /** NOTRE uuid. */
  id: Scalars['ID']['output'];
  /** La colonne « Document ». C'est une REFERENCE et non un type de document : 2 102 valeurs distinctes sur 2 102 documents, de la forme `DC4-0000000001`. Le « DC4 de sous-traitance » de la maquette est le libelle de la LIGNE, il appartient a l'ecran. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * L'objet de la prestation que ce DC4 declare : la **seconde moitie de la colonne « Document »** (RG-03 de PCG-230), le numero etant la premiere.
   *
   *  **L'ecran ecrivait « Declaration de sous-traitance » a la place**, faute de l'avoir : un libelle identique sur toutes les lignes, qui n'apprenait rien. Ce champ est rempli sur 2 391 des 2 391 DC4 du miroir.
   *
   *  Attention, **TEXTE LIBRE ET PRESQUE UNE VALEUR PAR DOCUMENT** : 1 887 valeurs distinctes, jusqu'a 171 caracteres. Il ne se groupe pas, ne se filtre pas, et ne fait pas une categorie de document.
   *
   *  Attention, **IL PORTE DU BRUIT DE SAISIE** et rien ne le retire : « TEST » revient 15 fois. Deviner ce qui est un vrai objet serait pire que de le rendre, et un « TEST » visible chez le client est ce qui fera corriger la source.
   */
  naturePrestation?: Maybe<Scalars['String']['output']>;
  /** Date de notification au client : l'une des TROIS candidates de la colonne « Envoye le », et la moins renseignee : 475 des 2 102 documents rattaches (22,6 %). Voir la colonne `SENT_AT` de `unavailableColumns`. */
  notifiedAt?: Maybe<Scalars['String']['output']>;
  /** La colonne « Partenaire », lue sur le catalogue `source_partner`. Un partenaire n'est JAMAIS une organisation : le confondre rouvrirait exactement la frontiere que PCG-86 a posee. */
  partnerName?: Maybe<Scalars['String']['output']>;
  /** Signature du partenaire, 1 895 des 2 102 (90,2 %). Candidate de « Envoye le ». */
  partnerSignedAt?: Maybe<Scalars['String']['output']>;
  /** Signature, 1 862 des 2 102 (88,6 %). Candidate de « Envoye le ». */
  signedAt?: Maybe<Scalars['String']['output']>;
};

/** L'onglet DC4 d'une prestation, NON PAGINE : une prestation porte 37 documents au maximum (mesure du 2026-08-09), la ou elle porte jusqu'a 496 phases. La liste est complete, donc son compte est sa longueur. */
export type ServiceDc4List = {
  __typename?: 'ServiceDc4List';
  items: Array<ServiceDc4>;
  /** Les colonnes de l'onglet que l'API ne sert pas, avec leur motif. Les TROIS portent `PENDING_DECISION` : leur donnee est chargee, c'est une reponse metier ou juridique qui manque. Le front y lit de quoi ecrire pourquoi, sans annoncer un lot qui n'existe pas. */
  unavailableColumns: Array<UnavailableDc4Column>;
};

/** La fiche d'une prestation. TROIS de ses SEPT onglets ne sont pas servis : ils sont NOMMES dans `unavailableTabs` plutot qu'omis, un panneau vide se lirait « cette prestation n'a aucun document » alors que le raccordement n'existe pas. L'onglet DC4 a quitte cette liste avec PCG-96, et le front n'a rien eu a changer pour cesser d'afficher la mention : c'est ce que le contrat promet. */
export type ServiceDetail = {
  __typename?: 'ServiceDetail';
  /**
   * OU l'activite de cette prestation est saisie, donc **ce que l'onglet doit lire** : les phases du contrat, ou les CRA (PCG-225).
   *
   *  C'est la Question 2 de l'arbre de decision arbitre le 2026-08-28 ; sa Question 1, « du temps ou un resultat », decide de la FICHE et se lit sur `serviceType`.
   *
   *  **AU MOINS UNE mission de gestion validee suffit** : s'il en existe une, il y a de l'activite saisie dans Connecteed, donc quelque chose a montrer. Le choix n'etait pas cosmetique, 2 490 contrats du parc sur 15 875 (15,7 %) portant A LA FOIS une mission validee et une non validee.
   *
   *  Attention, **IL NE DIT PAS QU'IL Y A QUELQUE CHOSE A MONTRER** : une prestation en `CONSUMPTIONS` peut n'avoir aucun CRA saisi, et une en `PHASES` aucune phase. L'onglet garde donc ses etats vides, et il n'y a **aucun repli automatique** d'une source sur l'autre : replier ferait afficher les phases d'une prestation dont l'activite vit ailleurs, c'est-a-dire un chiffre juste sur la mauvaise source.
   *
   *  Attention, **DEUX FAITS DONNENT `PHASES`** : « des missions, aucune validee » (367 prestations de la base) et « aucune mission du tout » (458). Dans les deux cas rien ne dit que l'activite soit saisie dans Connecteed, et l'ecran lit la meme source.
   */
  activitySource: ActivitySource;
  clientReference?: Maybe<Scalars['String']['output']>;
  /** UN COMPTE : les noms se lisent sur `servicePhases`, qui est paginee. */
  contributorCount: Scalars['Int']['output'];
  displayStatus?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** La MEME carte que sur la fiche d'un besoin, lue sur le RATTACHEMENT et non sur la prestation : elle est donc identique sur toutes les fiches d'un meme compte. Nulle quand l'echelle ne resout aucun barreau. */
  interlocutor?: Maybe<Interlocutor>;
  /**  C'EST L'AIGUILLAGE DE LA VARIANTE PORTAGE, et la difference n'est pas cosmetique : la maquette y remplace les cartes de commande par un bloc unique, les jours par un montant engage, et le tableau de conformite par des documents. Le front bascule sur ce booleen ; aucune autre donnee ne change. */
  isPortageCommercial: Scalars['Boolean']['output'];
  /** Composee A LA LECTURE depuis quatre colonnes. */
  location?: Maybe<Scalars['String']['output']>;
  /** Attention, c est la SEULE condition d un lien : voir `marketName`. */
  marketId?: Maybe<Scalars['ID']['output']>;
  /** Attention, DEUX ABSENCES DIFFERENTES, a lire avec `marketId` (PCG-123). Nul = aucun marche, le cas ordinaire. Renseigne avec `marketId` NUL = un marche nomme mais NON RELIE : on affiche le nom, sans lien. Renseigne avec `marketId` = le marche resolu. */
  marketName?: Maybe<Scalars['String']['output']>;
  marketReference?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  operationalName?: Maybe<Scalars['String']['output']>;
  /** Le compte, « Client » du bloc Contexte de la mission. */
  organizationName: Scalars['String']['output'];
  partnerKind: PartnerKind;
  partnerName?: Maybe<Scalars['String']['output']>;
  /** La ressource portee par la prestation elle-meme. A ne pas confondre avec `contributorCount`, qui compte les personnes vues sur les phases. */
  resourceName?: Maybe<Scalars['String']['output']>;
  serviceType: Scalars['String']['output'];
  sourceStatus: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  /** Les onglets que la fiche ne sert pas, avec leur motif. Le front y lit de quoi afficher une explication plutot qu'un panneau vide, et la distinction PENDING_INGESTION / NO_SOURCE lui dit ou il peut promettre. */
  unavailableTabs: Array<UnavailableServiceTab>;
};

/** Statut affiche d'une prestation, traduit par `service_status_mapping`. SIX valeurs fermees par un CHECK : c'est le referentiel du filtre « Statut », et il evite au front d'en tenir une seconde copie. Attention, L'ORDRE N'EST PAS UN CONTRAT : le SDL exporte est trie alphabetiquement, l'introspection rend l'ordre de declaration. Le rang du menu appartient a l'ecran, comme les libelles. */
export enum ServiceDisplayStatus {
  /**
   * Annulé : 131. Attention, AUCUNE PRESTATION PORTANT CETTE VALEUR N'EST PLUS VISIBLE depuis PCG-151 : `membership_visible_service` les exclut, donc elles ne sortent ni de la liste, ni de l'index des sections, ni de leur propre fiche. La valeur reste dans l'enumeration parce que celle-ci decrit le REFERENTIEL, qui les traduit toujours, et non ce que telle requete rend.
   *
   * Attention, ELLE RESTE DONC ACCEPTEE PAR LE FILTRE `statuses` ET N'Y RAMENE RIEN, ce qui est le comportement juste : un argument refuse serait une erreur de validation la ou la reponse honnete est une liste vide. C'est en revanche a l'ecran de ne pas l'OFFRIR dans son menu, un filtre qui ne ramene jamais rien se lisant comme une panne.
   */
  Annule = 'ANNULE',
  /** Commandé : 281 prestations mesurees. */
  Commande = 'COMMANDE',
  /** En cours : 12 384, le cas le plus frequent. */
  EnCours = 'EN_COURS',
  /** Receptionne : 756. Attention, LA LIGNE QUI JUSTIFIE LE REFERENTIEL : la source dit « Terminé facturé », l'ecran dit « RECEPTIONNE », et aucune regle ne mene de l'une a l'autre. */
  Receptionne = 'RECEPTIONNE',
  /** Réglé : 11 436. */
  Regle = 'REGLE',
  /** Terminé opérationnel : 762. */
  TermineOperationnel = 'TERMINE_OPERATIONNEL'
}

/** Un compte proposable dans le filtre « Entite » de « Mon activite » : notre uuid et le nom affiche. */
export type ServiceFilterAccount = {
  __typename?: 'ServiceFilterAccount';
  /** NOTRE uuid, celui-la meme qu'on renvoie dans `organizationIds` et dans `ServiceSectionInput.organizationId`. */
  id: Scalars['ID']['output'];
  /** Le nom du compte. */
  name: Scalars['String']['output'];
};

/** Une commande CLIENT d'une prestation : une carte `commande-resume` de la maquette V2. Attention, Le cote FOURNISSEUR n'entre jamais en base : la meme cle source porte autant de commandes fournisseur que client, et un total non filtre exposerait la MARGE au client. C'est un CHECK qui le tient, pas une discipline de `WHERE`. */
export type ServiceOrder = {
  __typename?: 'ServiceOrder';
  /**
   * Le « Montant » de la carte, TEL QUE LA COMMANDE LE PORTE.
   *
   * Attention, CALCULE DE RIEN : ce n'est pas la somme des lignes, et les deux DIVERGENT sur 1 301 des 67 810 commandes qui portent des lignes (1,92 %), pour un ecart de 6,8 M€ sur le parc. Laquelle des deux est « le total commande » n'est pas tranche : voir `LINES_TOTAL` dans `unavailableColumns`.
   *
   * Attention, EN CHAINE et a deux decimales, jamais un flottant : un NUMERIC(16, 2) rendu en nombre s'arrondit. Attention, IL PEUT ETRE NEGATIF : 732 commandes client portent un avoir.
   */
  amount?: Maybe<Scalars['String']['output']>;
  /**
   * Le « Statut » de la carte, TRADUIT par `service_order_status_mapping` (PCG-146).
   *
   * Attention, SIX LIBELLES POUR SEPT CLES SOURCE : `Validé` et `VALIDATION` rendent tous deux `VALIDE`, 809 commandes au 2026-08-12. C'est l'argument le plus fort en faveur de la table : sans elle l'ecran montrerait DEUX etats la ou le metier n'en voit qu'UN.
   *
   * Attention, NUL QUAND LE REFERENTIEL NE TRADUIT PAS, ET C'EST UN TROU QU'ON VOIT : ni libelle invente, ni valeur brute recopiee, la picklist de l'emetteur ne sort pas du schema. Mesure du 2026-08-12 : ZERO commande dans ce cas, les sept valeurs de la source etant semees. Le garde-fou est donc sans effet plutot que theorique, et un huitieme statut se compterait au journal de la passe d'ingestion.
   *
   * Attention, CE BLOC A QUITTE `unavailableColumns`, il n'y a pas change de motif. Il y portait `PENDING_DECISION` (la donnee est la, c'est la reponse qui manquait), le produit a rendu la table, et la seule reparation d'un motif devenu faux est de servir le champ. Sa valeur `STATUS` reste en revanche dans `OrderColumn`, qui nomme les blocs de l'ecran et non les indisponibilites.
   *
   * Attention, LES LIBELLES FRANCAIS APPARTIENNENT A L'ECRAN, comme leur rang : l'API sert un ensemble ferme de codes.
   */
  displayStatus?: Maybe<OrderDisplayStatus>;
  /** Fin de la periode de la commande, `AAAA-MM-JJ` (PCG-138). Voir `startDate` : les deux sont independamment nullables, l'absence est un etat, et une fin anterieure au debut est rendue telle quelle. Deux valeurs sont franchement aberrantes a la source (une fin au 1922-12-31 et une au 2201-03-31) et entrent quand meme, une borne « de bon sens » ayant le meme cout qu'un CHECK d'ordre. */
  endDate?: Maybe<Scalars['String']['output']>;
  /** NOTRE uuid. */
  id: Scalars['ID']['output'];
  /**
   * Les lignes de la commande, COMPLETES et NON PAGINEES : 51 au maximum, 1,76 en moyenne (mesure du 2026-08-11 sur 119 801 lignes). Leur compte est donc `lines.length`, et aucun total ne vit a cote.
   *
   * Attention, UN TABLEAU VIDE EST UNE REPONSE ET NON UNE ABSENCE : 395 des 68 205 commandes (0,58 %) ne portent aucune ligne. C'est exactement pourquoi aucun total derive des lignes n'est servi : il vaudrait « 0.00 » sur ces 395 commandes, affirmant que rien n'y est commande alors que leur `amount` dit le contraire. Une case vide sur une colonne de montants se lit « zero ».
   */
  lines: Array<ServiceOrderLine>;
  /**
   * La ligne « Commande » de la carte. C'est le NOM de notre objet, rempli a 100 %, de la forme « 17IF0029-01 ».
   *
   * Attention, CE N'EST PAS LA REFERENCE DU BON DE COMMANDE DU CLIENT, et les deux existent cote a cote a la source : celle-la est emise par le client et PLUSIEURS commandes la partagent, donc elle n'identifie pas une commande. Elle est servie a cote, sous `purchaseOrderReference`.
   */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /**
   * La « Reference bon de commande » de la carte (« 446547 » sur la maquette), VERBATIM (PCG-138).
   *
   * Attention, ELLE NE PORTE AUCUNE IDENTITE ET NE DOIT JAMAIS SERVIR DE CLE, ni de regroupement affiche comme s'il etait un objet. Elle est emise par LE CLIENT et plusieurs commandes la partagent : jusqu'a 86 commandes sur 18 prestations en base de dev, et une reference partagee par DEUX comptes en couvre 50. C'est du texte libre, de 3 a 40 caracteres en local et de 1 a 69 au parc, parfois deux references separees par un slash, parfois une phrase (« EN ATTENTE DE COMMANDE NE PAS FACTURER »), et l'une vaut litteralement `;`. Rien n'est decoupe ni normalise.
   *
   * Attention, TROIS FAITS VOISINS, TROIS CHAMPS, et la carte en affiche deux : `orderNumber` est le `Name` de NOTRE objet ; `ServiceDetail.clientReference` est la « Reference client », un fait de la PRESTATION que la maquette recopie sur chaque carte ; celle-ci est celle du BON DE COMMANDE. Les deux dernieres coincident sur 2 des 561 commandes de la base de dev ou les deux existent, donc l'une ne remplace pas l'autre.
   *
   * Attention, LE NOM DU CHAMP N'EST PAS CELUI DE LA COLONNE, qui est `client_order_reference`, et c'est voulu : `purchaseOrderReference` nomme le bloc de l'ecran (`PURCHASE_ORDER_REFERENCE`) et ne peut pas se confondre a la relecture avec `ServiceDetail.clientReference`, ce que `clientOrderReference` aurait fait a une lettre pres, sur la meme carte.
   */
  purchaseOrderReference?: Maybe<Scalars['String']['output']>;
  /**
   * Debut de la periode de la commande, `AAAA-MM-JJ` (PCG-138).
   *
   * Attention, DEUX DATES INDEPENDAMMENT NULLABLES, ET JAMAIS UN COUPLE : trois commandes du parc portent une fin SANS debut, et aucune l'inverse. Il n'y a donc pas d'objet « periode », qui laisserait croire que l'une implique l'autre.
   *
   * Attention, L'ABSENCE EST UN ETAT, PAS UN TROU DE SAISIE, et l'ecran en a besoin pour choisir entre un tiret et une phrase : une commande VALIDEE mais pas encore commandee n'a pas de periode. 539 des 541 commandes portant la cle source « Validé » sont dans ce cas (99,6 %), 24 des 25 en base de dev.
   *
   * Attention, ET DEPUIS PCG-146 CETTE PHRASE NE SE LIT PLUS SUR `displayStatus`, MEME S'IL EST DESORMAIS SERVI. Le libelle `VALIDE` fusionne DEUX cles source qui se comportent a l'INVERSE l'une de l'autre sur ce point precis : `Validé` est sans debut sur 99,6 % de ses lignes, `VALIDATION` sur ZERO de ses 268, et la cle ne sort pas du schema. Sous le libelle, l'absence de periode tombe a 539 sur 809 (66,6 %). Ce champ reste donc le seul indice fiable : c'est lui qu'on lit, jamais le statut.
   *
   * Attention, LA PERIODE PEUT ETRE INVERSEE et elle est rendue TELLE QUELLE : 9 commandes de la base de dev finissent avant de commencer, de 1 a 435 jours, majoritairement au statut « Totalement facture ». Aucun CHECK d'ordre n'existe en base, deliberement, et l'API ne remet rien a l'endroit : ce sont les dates de la source.
   */
  startDate?: Maybe<Scalars['String']['output']>;
};

/** Une ligne d'une commande client, SERVIE BRUTE. Attention, L'API n'en derive AUCUN total : la definition du « total commande » (le montant porte par la commande, ou la somme de ses lignes) n'est pas tranchee par le produit, et les deux ne coincident pas. Servir les lignes telles quelles est ce qui permettra de calculer la definition retenue sans nouveau lot d'ingestion. */
export type ServiceOrderLine = {
  __typename?: 'ServiceOrderLine';
  description?: Maybe<Scalars['String']['output']>;
  /** NOTRE uuid. */
  id: Scalars['ID']['output'];
  /** Quantite deja facturee, EN CHAINE. Attention, NUL N'EST PAS ZERO : nul dit que la source ne porte rien, « 0 » dit que rien n'a ete facture. Attention, Le « reste a facturer » de la maquette serait la difference des deux sommes, et il N'EST PAS SERVI : voir `REMAINING_TO_INVOICE` dans `unavailableColumns`, et surtout ne pas le confondre avec le champ que la source porte sous ce nom, faux six fois sur dix. */
  invoicedQuantity?: Maybe<Scalars['String']['output']>;
  /** Le numero de ligne de la source. Attention, NUL SUR 13,7 % DES LIGNES (16 358 sur 119 801, mesure du 2026-08-11) : ce n'est pas une cle, et la liste est ordonnee dessus puis sur l'uuid pour que l'ordre reste total. */
  lineNumber?: Maybe<Scalars['String']['output']>;
  /** Quantite commandee, EN CHAINE. Attention, ELLE PEUT ETRE NEGATIVE : ce sont des avoirs, et les masquer les perdrait. */
  quantity?: Maybe<Scalars['String']['output']>;
  /** Prix unitaire, EN CHAINE pour ne pas arrondir un NUMERIC(16, 2) en flottant. Meme regle que `ServicePhase.amountInvoiced`. */
  unitPrice?: Maybe<Scalars['String']['output']>;
};

/** Une page des commandes d'une prestation. */
export type ServiceOrderPage = {
  __typename?: 'ServiceOrderPage';
  items: Array<ServiceOrder>;
  /**
   * Commandes client vivantes de la prestation, AVANT pagination. Il vient de l'API et jamais de `items.length` : une prestation en porte jusqu'a 92, et le compteur d'une liste paginee ne compte jamais une page.
   *
   * Attention, IL RETRANCHE LES ANNULEES DEPUIS PCG-149, comme la liste : le compteur porte la MEME clause, faute de quoi il annoncerait « 5 commandes » au-dessus d'une page qui en montre trois. Il compte donc desormais la meme chose que `Service.totalOrdered`, la ou les deux repondaient a deux questions differentes et demandaient un drapeau par ligne pour se reconcilier.
   *
   * Attention, RIEN NE DIT COMBIEN ONT ETE MASQUEES, et c'est la decision du lot : 162 prestations du parc n'ont QUE des commandes annulees, donc leur page est VIDE avec un total a zero, sans un mot sur ce qui l'a videe. Ce que le client ne doit pas voir, il ne doit pas non plus le deviner. L'ecran ne peut donc pas ecrire « cette prestation ne porte aucune commande » sous une page vide : ce serait une affirmation sur la prestation, et fausse.
   */
  totalOrders: Scalars['Int']['output'];
  /**
   * Les blocs de la carte que l'API ne sert pas, avec leur motif. Attention, LES TROIS MOTIFS COEXISTENT ICI, seul endroit du schema ou c'est le cas, et ils ne disent pas la meme chose : `NO_SOURCE` demande un amendement de modele, `PENDING_INGESTION` attend un chargement, `PENDING_DECISION` attend une reponse. Le front n'y lit « bientot » que sur le deuxieme.
   *
   * Attention, SEPT BLOCS, APRES ETRE PASSE DE DIX A HUIT (PCG-138) PUIS DE HUIT A SEPT (PCG-146), ET LES TROIS SORTIES SONT LE MEME GESTE. « Periode » et « Reference bon de commande » portaient `NO_SOURCE` alors que la source etait remplie a 99,1 %, le manque etant chez nous : la migration qui a donne ses colonnes a la table a rendu les deux entrees fausses, et elles sont servies depuis. « Statut » portait `PENDING_DECISION` (toute la donnee etait la, c'est la reponse qui manquait) et le produit a rendu la table de traduction : il est servi sur `displayStatus`. Un motif devenu faux se repare en SERVANT le champ, jamais en lui trouvant un autre motif : sans quoi l'ecran garde une phrase d'indisponibilite au-dessus d'une donnee presente. Leurs valeurs restent en revanche dans `OrderColumn` : cette enumeration nomme les blocs de l'ecran, pas les indisponibilites.
   */
  unavailableColumns: Array<UnavailableOrderColumn>;
};

/** La periode de « Mon activite ». Elle borne la date de FIN, jamais celle de debut. */
export enum ServicePeriod {
  /** « Depuis le debut » : aucune borne. C'est le defaut, et l'absence de l'argument dit la meme chose. */
  AllTime = 'ALL_TIME',
  /** Depuis le 1er janvier de l'annee PRECEDENTE, donc deux annees civiles (« Depuis janvier 2025 »). 10 565 prestations mesurees le 2026-08-10. */
  SinceJanuaryLastYear = 'SINCE_JANUARY_LAST_YEAR',
  /** Depuis le 1er janvier de l'annee EN COURS cote serveur (« Depuis janvier 2026 » sur la maquette). 7 257 prestations mesurees le 2026-08-10. */
  SinceJanuaryThisYear = 'SINCE_JANUARY_THIS_YEAR'
}

/** Une ligne de l'onglet Activites. C'est une ECHEANCE MENSUELLE du contrat, pas une etape de projet. */
export type ServicePhase = {
  __typename?: 'ServicePhase';
  /**
   * Le « MONTANT » de la specification (RG-04 de PCG-227), lu sur `INO_Montant__c` : le montant client de l'echeance.
   *
   *  Attention, **UN TROISIEME MONTANT ET NON UN DOUBLON**, et la mesure est ce qui l'a fait ajouter : rempli sur 21 856 des 21 870 phases de la base (99,9 %) quand `amountInvoiced` l'est sur 12 973 (59,3 %), et **8 889 phases portent celui-ci sans celui-la**, soit 40,6 % du tableau qui affichait un tiret alors que la donnee existait. Cas reel : la prestation « Architecte technique SAP » porte 18 000 ici sur chacun de ses mois et RIEN en facture.
   *
   *  **EN CHAINE**, pour la meme raison que les deux autres : un `NUMERIC(16, 2)` rendu en nombre s'arrondit. Il peut etre **NEGATIF** (2 cas au parc).
   *
   *  Attention, **C'EST LE CHAMP QUE RG 2 LIRA** : une phase a zero ne s'affiche pas, ce qui ecarte les commissions d'apporteur d'affaires mal saisies en « Prestation sous-traitance ». La regle n'est PAS encore posee : 407 des 767 phases a zero du parc sont des echeances A VENIR, pas encore facturees, et les masquer priverait le client de son calendrier. Arbitrage envoye au produit le 2026-08-28.
   */
  amountClient?: Maybe<Scalars['String']['output']>;
  /**
   * Montant FACTURE, EN CHAINE pour ne pas arrondir. NUL et « 0 » ne sont PAS la meme chose : nul dit que la source ne porte aucun montant, « 0 » dit qu'un montant nul a ete facture, quatre phases sur dix sont dans le premier cas. Il peut etre NEGATIF : ce sont des avoirs, et les masquer les perdrait.
   *
   *  Attention, **CE N'EST PLUS CE QUE LA COLONNE « MONTANT » DE L'ECRAN AFFICHE** : c'est `amountClient`. Celui-ci reste servi parce que « ce qui a ete facture » est un fait a part entiere, mais il est vide sur quatre lignes sur dix.
   */
  amountInvoiced?: Maybe<Scalars['String']['output']>;
  /**
   * Le statut de la phase (RG-04 de PCG-227), **TRADUIT par le referentiel** `service_phase_status_mapping` et jamais la chaine de la source : recopier la picklist de l'emetteur l'afficherait comme si c'etait notre libelle.
   *
   *  Attention, **NUL VEUT DIRE « STATUT NON TRADUIT » ET NON « AUCUN STATUT »**. La jointure du referentiel est A GAUCHE, ce qui fait ENTRER la phase dont le statut est inconnu plutot que de l'escamoter, et la passe journalise l'ecart. Un ecran qui rendrait le nul comme un statut inventerait une valeur ; il doit dire qu'il ne sait pas.
   *
   *  Les valeurs affichables sont celles du referentiel moins `annule`, que la lecture retranche : une phase annulee ne sort jamais d'ici.
   */
  displayStatus?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**  C'EST UN MOIS (« Juin 2026 »), et il s'affiche tel quel. */
  name?: Maybe<Scalars['String']['output']>;
  /**  ORDONNE ET NE NUMEROTE PAS : le compteur source est GLOBAL et monte a 107 898. Afficher « Phase 56195 » serait faux. */
  position?: Maybe<Scalars['Int']['output']>;
  resourceName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  /**
   * La « CHARGE » de la specification (RG-04 de PCG-227) : les jours realises du mois, lus sur `INO_Duree_Realisee__c`.
   *
   *  **EN CHAINE pour ne pas arrondir**, meme regle que `amountInvoiced` : 21,5 et 21 ne sont pas le meme nombre de jours.
   *
   *  Attention, **NUL EST L'ETAT ORDINAIRE ET NON L'EXCEPTION** : 5 831 des 22 737 phases de la base en portent une, soit une sur quatre. Le taux depend fortement du perimetre, 85,8 % sur le perimetre gere Salesforce que la specification mesure. L'ecran doit donc ECRIRE l'absence : une cellule blanche dans une colonne de jours se lit comme un zero, defaut deja paye sur `Service.totalOrdered` a PCG-125.
   *
   *  Attention, **NE PAS EN DERIVER UN TJM** par division du montant : le resultat ne retombe sur le champ de prix de la phase que dans 34,1 % des cas. Voir `unavailableColumns` pour ce qui retient le TJM.
   */
  workedDays?: Maybe<Scalars['String']['output']>;
};

export type ServicePhasePage = {
  __typename?: 'ServicePhasePage';
  items: Array<ServicePhase>;
  /** Phases vivantes de la prestation, avant pagination. Il vient de l'API et jamais de `items.length` : une prestation en porte jusqu'a 496. */
  totalPhases: Scalars['Int']['output'];
  unavailableColumns: Array<UnavailablePhaseColumn>;
};

/** Un groupe de « Mon activite » : les prestations d'un MARCHE pour un COMPTE, avec leur nombre COMPLET. C'est l'en-tete d'un accordeon de la maquette V2. */
export type ServiceSection = {
  __typename?: 'ServiceSection';
  /** ATTENTION, LA NATURE VOYAGE et ne se deduit pas : trois natures distinctes, jamais fondues. Elle se lit sur les colonnes de stockage et non sur le nom affiche, sans quoi un marche resolu mais sans nom se rangerait avec les sans-cadre. */
  kind: ServiceSectionKind;
  /** Le marche, SECONDE MOITIE DE LA CLE, et la SEULE condition d'un lien vers une fiche. Nul sur NAMED_MARKET et sur NO_MARKET. */
  marketId?: Maybe<Scalars['ID']['output']>;
  /** La seconde moitie de la cle QUAND le marche n'est pas relie : pose sur la seule nature NAMED_MARKET, nul partout ailleurs. C'est ce qu'on renvoie dans `ServiceSectionInput.marketLabel`. */
  marketLabel?: Maybe<Scalars['String']['output']>;
  /** Le nom AFFICHE de la section. Attention, c'est un CASE et jamais un COALESCE (PCG-78) : un marche resolu mais SANS NOM rend vide, il n'emprunte pas le libelle de la source, qui pourrait nommer un autre marche. Nul aussi sur NO_MARKET, ou l'intitule appartient a l'ecran. */
  marketName?: Maybe<Scalars['String']['output']>;
  marketReference?: Maybe<Scalars['String']['output']>;
  /** Le compte, PREMIERE MOITIE DE LA CLE. A renvoyer tel quel dans `myServices`. */
  organizationId: Scalars['ID']['output'];
  /** Le nom du compte. Attention, il ne se deduit pas du marche : un meme marche consomme par deux comptes rend DEUX sections, et c'est ce nom qui les distingue. */
  organizationName: Scalars['String']['output'];
  /**
   * ATTENTION, LE NOMBRE COMPLET DE PRESTATIONS DE LA SECTION, jamais celui d'une page. C'est la raison d'etre de cette requete : `myServices` est pagine a 25 lignes, donc grouper une page afficherait « 4 prestations » sous un marche qui en porte 2 743. Mesure du parc : plus grosse section par personne, mediane 50 et maximum 2 743 ; 59 % des lecteurs ont au moins une section qui deborde une page.
   *
   * Il SUIT la recherche, comme `totalServices` : un compteur qui l'ignorerait annoncerait « 40 prestations » au-dessus d'un accordeon qui en deplie deux.
   */
  serviceCount: Scalars['Int']['output'];
};

/** L'index des sections de « Mon activite », NON PAGINE : 87 sections au maximum pour la personne la plus chargee du parc. Son compte est donc `items.length`, et il ne faut pas lui ajouter de pager pour lui donner l'air des autres listes. */
export type ServiceSectionIndex = {
  __typename?: 'ServiceSectionIndex';
  /**
   * Les comptes proposables dans le filtre « Entite » : ceux ou « Mon activite » est ouvert, y compris ceux qui ne portent aucune prestation.
   *
   * Attention, IL NE SUIT AUCUN FILTRE, et c'est sa raison d'etre. Un menu deduit des lignes rendues se raccourcirait au premier clic : on coche un compte, les autres quittent le menu, et plus rien ne permet d'y revenir. Sa longueur EST `accountsInScope`, les deux venant de la meme lecture.
   *
   * C'est ICI que la barre de filtres le lit : elle est dessinee avant qu'un seul accordeon soit deplie, donc avant que `myServices` parte. Meme argument qu'`accountsInScope`.
   */
  accounts: Array<ServiceFilterAccount>;
  /** Sur combien de comptes cet index porte. Attention, IL VOYAGE ICI AUSSI, et ce n'est pas une commodite : avec un accordeon replie au depart, la requete de page peut ne JAMAIS partir, et la phrase « vous ne voyez qu'une partie de ce que vous detenez » disparaitrait de l'ecran sans que rien n'echoue. Meme valeur que sur `myServices`, calculee par la meme fonction. */
  accountsInScope: Scalars['Int']['output'];
  /** Nombre de rattachements actifs de la personne. */
  accountsTotal: Scalars['Int']['output'];
  /** Les sections, dans l'ORDRE D'AFFICHAGE : compte, puis nature, puis nom, « sans contrat cadre » EN DERNIER. Une section vide n'existe pas : le regroupement porte sur l'ensemble deja recherche, donc l'ecran n'a aucun accordeon vide a masquer. */
  items: Array<ServiceSection>;
};

/** La section a charger, designee par les trois colonnes qui la classent. Elle RESTREINT la liste, elle n'ouvre rien : une section d'un compte hors perimetre rend une page vide et un total a zero. */
export type ServiceSectionInput = {
  /** L'uuid du marche pour une section LINKED_MARKET. Nul pour les deux autres natures. */
  marketId?: InputMaybe<Scalars['ID']['input']>;
  /** Le libelle pour une section NAMED_MARKET, celui que l'index rend dans `marketLabel`. Nul pour les deux autres natures. Attention, pose A COTE d'un `marketId` il ne designe AUCUNE section : la base l'interdit (`service_market_label_check`), donc la page revient vide. */
  marketLabel?: InputMaybe<Scalars['String']['input']>;
  /** Le compte. Attention, il est OBLIGATOIRE, et c'est la decision : deux comptes font DEUX sections, meme sur le meme marche. Le portail affiche l'union des rattachements (PCG-27), donc sans le compte deux prestations de deux comptes seraient indiscernables. Une fusion se defait a l'ecran, une perte de compte ne se rattrape pas. */
  organizationId: Scalars['ID']['input'];
};

/** LA NATURE DU MARCHE D'UNE PRESTATION. Le nom dit « section » parce que l'index de « Mon activite » l'a servie en premier ; le fait, lui, est porte par la prestation et deux ecrans le lisent depuis PCG-231, l'index des sections et la colonne « Marche » de la liste des factures. Une seconde enumeration aux memes trois valeurs aurait donne deux echelles pour un fait, et les renommer est un lot a soi. */
export enum ServiceSectionKind {
  /** Le marche est RESOLU : nous detenons l'objet. C'est la SEULE nature cliquable : `marketId` reste la seule condition d'un lien. */
  LinkedMarket = 'LINKED_MARKET',
  /** La source NOMME un contrat cadre que la paire (compte, marche) n'a pas laisse relier : on affiche le nom, SANS lien vers une fiche, nous n'avons pas l'objet. 190 prestations mesurees le 2026-08-10, sur six cadres et douze comptes. C'est `marketLabel` qui porte le nom, et c'est lui qu'on renvoie pour demander la section. */
  NamedMarket = 'NAMED_MARKET',
  /** Aucun contrat cadre : cas ORDINAIRE et MASSIF, 48,5 % des prestations en moyenne ponderee, et la plus grosse section sur 37 % des comptes. Attention, c'est une section a part entiere, rangee EN DERNIER, avec son compteur. C'est un ECART ASSUME a la maquette, qui ne contient aucun groupe sans cadre et dont le code de regroupement effacerait ces lignes avec le tableau. */
  NoMarket = 'NO_MARKET'
}

/** Un onglet de la fiche d'une prestation. */
export enum ServiceTab {
  Activities = 'ACTIVITIES',
  Compliance = 'COMPLIANCE',
  Contact = 'CONTACT',
  Dc4 = 'DC4',
  Documents = 'DOCUMENTS',
  History = 'HISTORY',
  Overview = 'OVERVIEW'
}

/** Colonne de tri de la liste des prestations. */
export enum ServicesSort {
  /** Reference client. */
  ClientReference = 'CLIENT_REFERENCE',
  /** Date de fin. */
  EndDate = 'END_DATE',
  /** Nom du compte. Constant dans une section, celle-ci etant une paire (compte, marche) : utile quand `section` est absent. */
  Entity = 'ENTITY',
  /** Intitule du marche TEL QUE LA LIGNE L'AFFICHE : le nom du cadre resolu, et a defaut le libelle brut de la prestation. Constant dans une section, comme le compte. */
  Market = 'MARKET',
  /** Intitule de la prestation. */
  Name = 'NAME',
  /** Nom de l'interlocuteur operationnel, cote client. */
  Operational = 'OPERATIONAL',
  /** Date de debut. Ordre par defaut, du plus recent au plus ancien. */
  StartDate = 'START_DATE'
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Un compte au titre duquel l'utilisateur courant peut deposer un besoin. TOUS ses rattachements actifs sont rendus, y compris ceux qui ne peuvent pas recevoir de depot : ceux-la portent leur raison et s'affichent desactives. */
export type SubmissionAccount = {
  __typename?: 'SubmissionAccount';
  /** Pourquoi le depot est impossible sur ce compte. Nul des que `canSubmit` est vrai. Ce n'est PAS une erreur : la requete a reussi. C'est le MEME verdict que `submitNeed` rendrait ensuite, calcule par la meme fonction : le selecteur et l'envoi ne peuvent pas se contredire. */
  blockedReason?: Maybe<SubmissionBlockedReason>;
  /** L'utilisateur peut-il deposer au titre de ce compte ? FAUX ne retire pas le compte de la liste : il s'affiche desactive avec sa raison. */
  canSubmit: Scalars['Boolean']['output'];
  /** A renvoyer tel quel dans `submitNeed(organizationId:)`. Chaine opaque pour le front. */
  organizationId: Scalars['ID']['output'];
  /** Le nom du compte, tel qu'il s'affiche dans le selecteur. */
  organizationName: Scalars['String']['output'];
};

/** Pourquoi ce compte ne peut pas recevoir de depot de besoin. Nul des qu'il le peut. */
export enum SubmissionBlockedReason {
  /** Le role porte sur CE rattachement n'accorde pas `submit_need`. ATTENTION, CE REFUS A CHANGE DE FREQUENCE A PCG-132, pas de nature : les CINQ roles systeme du portail portent desormais le droit, donc il ne se produit plus avec eux. Il reste atteignable par un role cree sur mesure depuis PCG-124, et une personne portant un role PAR compte, « je depose ici et pas la » reste possible. Geste : demander un autre role sur ce compte. */
  MissingPermission = 'MISSING_PERMISSION',
  /** Le module « Mes besoins » n'est pas ouvert sur CE compte. L'entree de menu, elle, est en UNION : elle apparait des qu'un seul compte l'ouvre, donc ce refus est le cas normal d'une personne rattachee a plusieurs comptes dont un seul porte le module. Geste : en demander l'ouverture. */
  ModuleNotEnabled = 'MODULE_NOT_ENABLED'
}

/** L'e-mail au commercial est-il parti ? Question distincte du rapprochement. */
export enum SubmissionTransmissionStatus {
  Bounced = 'BOUNCED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sent = 'SENT'
}

/** Accuse de reception d'une demande. Ce N'EST PAS un besoin : elle n'apparait dans la liste qu'une fois creee dans Salesforce puis rapprochee. */
export type SubmittedNeed = {
  __typename?: 'SubmittedNeed';
  id?: Maybe<Scalars['ID']['output']>;
  /**
   * L'adresse a laquelle la demande part : C'EST CELLE DE L'INTERLOCUTEUR AFFICHE SUR LA FICHE, resolu par la meme echelle a quatre barreaux (`membership_account_manager`, choix 16) et sur le meme rattachement. Le client ecrit a qui il voit ; l'ecart entre les deux lectures etait le defaut PCG-82.
   *
   * Null quand l'echelle rend `none`, aucun barreau ne resout, et la fiche n'affiche alors aucune carte non plus. La demande est enregistree quand meme, `PENDING`, et rejouable : un compte mal configure ne doit pas couter au client sa capacite a exprimer un besoin. Ce que ce null NE dit PAS : le modele (§3.7) veut qu'une demande sans interlocuteur parte a une BOITE DE REPLI, transmise et jamais en attente. Cette boite n'existe pas encore dans la configuration de l'API, c'est PCG-83.
   */
  recipientEmail?: Maybe<Scalars['String']['output']>;
  /** A communiquer au client ET recopiee par le commercial dans Salesforce : c est elle qui permettra le rapprochement. */
  reference?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['String']['output']>;
  /** PENDING est l'etat normal d'un enregistrement dont l'e-mail n'est pas encore parti, pas un incident. */
  transmissionStatus?: Maybe<SubmissionTransmissionStatus>;
};

/** Une colonne de l'onglet DC4 que l'ecran demande et que l'API ne sert pas, avec son motif. */
export type UnavailableDc4Column = {
  __typename?: 'UnavailableDc4Column';
  column: Dc4Column;
  detail: Scalars['String']['output'];
  reason: UnavailableReason;
  /**  NUL SUR LES TROIS, et c'est le motif qui le veut : `PENDING_DECISION` n'attend aucun lot, donc une cle Jira promettrait une date a une question qui n'en a pas. La question est nommee dans `detail`. */
  ticket?: Maybe<Scalars['String']['output']>;
};

/** Un bloc de la carte d'une commande que l'ecran demande et que l'API ne sert pas, avec son motif. */
export type UnavailableOrderColumn = {
  __typename?: 'UnavailableOrderColumn';
  column: OrderColumn;
  detail: Scalars['String']['output'];
  reason: UnavailableReason;
  /** Attention, NUL SUR LES SEPT. Sur un `PENDING_DECISION` une cle Jira promettrait une date a une question qui n'en a pas ; sur un `NO_SOURCE` il n'y a aucun lot a suivre, mais un amendement de modele a obtenir ; et les deux `PENDING_INGESTION` attendent un lot qui n'est pas ouvert. La question est nommee dans `detail` : c'est ce qui se suit ici. */
  ticket?: Maybe<Scalars['String']['output']>;
};

export type UnavailablePhaseColumn = {
  __typename?: 'UnavailablePhaseColumn';
  column: PhaseColumn;
  detail: Scalars['String']['output'];
  reason: UnavailableReason;
  ticket?: Maybe<Scalars['String']['output']>;
};

/** Pourquoi une donnee n'est pas servie. */
export enum UnavailableReason {
  /** Aucune table, nulle part. Cela attend un arbitrage de modelisation, et RIEN ne doit etre promis. */
  NoSource = 'NO_SOURCE',
  /**  LA DONNEE EST LA, et c'est le LIBELLE, la COLONNE ou le GESTE qui attend un arbitrage metier ou juridique. Ni un chargement ni une table ne debloque : une reponse le fait. Le front ne doit donc pas annoncer « bientot », le motif nomme la question ouverte. */
  PendingDecision = 'PENDING_DECISION',
  /** La table EXISTE, l'ingestion ne la charge pas encore. Un lot la debloque : le front peut annoncer « bientot » sans mentir. */
  PendingIngestion = 'PENDING_INGESTION'
}

/** Une colonne que l'ecran demande et qu'AUCUNE source n'alimente aujourd'hui, avec son motif. */
export type UnavailableServiceColumn = {
  __typename?: 'UnavailableServiceColumn';
  column?: Maybe<ServiceColumn>;
  /** Pourquoi elle n'est pas servie, en francais et destine a etre affiche. */
  reason?: Maybe<Scalars['String']['output']>;
};

/** Un onglet de la fiche qui n'est pas servi, avec son motif. */
export type UnavailableServiceTab = {
  __typename?: 'UnavailableServiceTab';
  /** Le motif redige, destine a etre affiche a la place du panneau vide. */
  detail: Scalars['String']['output'];
  reason: UnavailableReason;
  tab: ServiceTab;
  /** La cle Jira qui debloque, quand elle existe : une cle se suit, une phrase se perd. Nulle sur un motif NO_SOURCE, et nulle aussi sur un PENDING_INGESTION dont le lot n'est pas encore ouvert. */
  ticket?: Maybe<Scalars['String']['output']>;
};

export type User = {
  __typename?: 'User';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  memberships?: Maybe<Array<Membership>>;
  /** Au moins un des comptes de cette personne exige le MFA. Union cote serveur sur ses rattachements actifs et invites : a lire tel quel, sans replier `memberships` soi-meme. */
  mfaRequired?: Maybe<Scalars['Boolean']['output']>;
};

export type VisibleActivity = {
  __typename?: 'VisibleActivity';
  id: Scalars['ID']['output'];
  /** « need » ou « service ». Servi parce que les deux portent des noms qui se ressemblent. */
  kind: Scalars['String']['output'];
  /** Nul quand l'objet n'en porte pas : l'ecran l'ecrit plutot que de laisser une ligne vide. */
  name?: Maybe<Scalars['String']['output']>;
};
